
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("jQwFa", function(module, exports) {
$parcel$export(module.exports, "getClickUrl", () => $d5dcd928552f2bed$export$cf3c5acf9e9d0f02);

var $aMKAs = parcelRequire("aMKAs");
const $d5dcd928552f2bed$export$cf3c5acf9e9d0f02 = (url, jsonLd)=>{
    if (jsonLd && jsonLd.data) {
        const visitUrl = (0, $aMKAs.extractVisitUrl)(jsonLd.data);
        if (visitUrl) return visitUrl;
    }
    return url;
};

});
parcelRegister("aMKAs", function(module, exports) {
$parcel$export(module.exports, "extractVisitUrl", () => $04ea6501b5b71fa6$export$c81497d3681f24f4);
const $04ea6501b5b71fa6$export$c81497d3681f24f4 = (jsonLd)=>{
    return jsonLd['atlassian:visitUrl'];
};

});


parcelRegister("jpYbX", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkCrossProductUrlWrapper", () => $e2edc3e0e083b2bb$export$119a84bedaff7b6e);

var $fc4bM = parcelRequire("fc4bM");

var $iO0Ti = parcelRequire("iO0Ti");

var $fnEFU = parcelRequire("fnEFU");

var $d217T = parcelRequire("d217T");

var $abcPE = parcelRequire("abcPE");
const $e2edc3e0e083b2bb$export$119a84bedaff7b6e = ({ details: details })=>{
    const { product: product, bridgeProduct: bridgeProduct, xpcProduct: xpcProduct, xpcSubProduct: xpcSubProduct } = (0, $fnEFU.useSmartLinkContext)();
    // xpcProduct takes precedence over product — it identifies the host product for XPC analytics
    // without affecting link resolution (which uses the `product` prop separately).
    const effectiveProduct = xpcProduct ?? product;
    const effectiveBridge = bridgeProduct ?? (0, $d217T.XPC_CONSTANTS).SMART_LINKS_XPC_BRIDGE;
    const effectiveProductForWrapper = (effectiveProduct === null || effectiveProduct === void 0 ? void 0 : effectiveProduct.toLowerCase()) ?? 'unknown';
    const wrapUrl = (0, $iO0Ti.useCrossProductUrlWrapper)({
        bridge: effectiveBridge,
        product: effectiveProductForWrapper,
        ...xpcSubProduct ? {
            subProduct: xpcSubProduct
        } : {}
    });
    return (0, $fc4bM.useCallback)((url)=>{
        if (typeof window === 'undefined' || !(0, $abcPE.getIsFirstPartyLink)(details) || !effectiveProduct) return url;
        let parsedUrl;
        try {
            parsedUrl = new URL(url);
        } catch  {
            return url;
        }
        if (parsedUrl.searchParams.has((0, $d217T.XPC_CONSTANTS).QUERY_PARAM)) return url;
        return wrapUrl(url);
    }, // Keep bridge/subproduct in the dependency array so consumers that memoize this callback
    // refresh when mini-modal context updates from smartLinks to rovo-chat.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        details,
        effectiveBridge,
        effectiveProduct,
        wrapUrl,
        xpcSubProduct
    ]);
};

});
parcelRegister("iO0Ti", function(module, exports) {
$parcel$export(module.exports, "useCrossProductUrlWrapper", () => $d961716374f3f23b$export$fc6e9265f8d85c92);
$parcel$export(module.exports, "default", () => $d961716374f3f23b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $6Zi52 = parcelRequire("6Zi52");

var $bKWnN = parcelRequire("bKWnN");

var $c6RWu = parcelRequire("c6RWu");

var $hs3Zi = parcelRequire("hs3Zi");
const $d961716374f3f23b$export$5d4c4eab0863aae3 = 'interactionSessionIdUpdated';
/**
 * Kill switch config, defaults to enabled so we fail open if the config can't be resolved.
 * https://switcheroo.atlassian.com/ui/configurations/d3b9839b-0a19-4f81-928e-44fc4fac4c55/key/atlaskit-analytics-cross-product-kill-switch
 */ const $d961716374f3f23b$var$KILL_SWITCH_CONFIG = 'atlaskit-analytics-cross-product-kill-switch';
/**
 * This React hook is called with the correct bridge, product and sub-product parameters.
 * It returns a function that can be used to generate URLs with cross-product interaction parameters.
 *
 * @param options - Properties object that contains the following parameters:
 *
 * @returns A function that appends interaction session ID and other cross-product interaction parameters to a given URL.
 */ function $d961716374f3f23b$export$fc6e9265f8d85c92(options) {
    const { bridge: bridge, product: product, subProduct: subProduct } = options;
    // This is a kill switch rather than an experiment, so no exposure is fired.
    const isEnabled = !(0, $bKWnN.UNSAFE_expValNoExposure)($d961716374f3f23b$var$KILL_SWITCH_CONFIG, 'value', false);
    // `useRef(initialValue)` evaluates `initialValue` on every render but only uses the result on
    // the first render. Populate the ref imperatively the first time we need it so we don't call
    // `getInstance()` on every render (per Billy Chen's review suggestion).
    const interactionSessionClientRef = (0, $fc4bM.useRef)(undefined);
    if (isEnabled && !interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $hs3Zi.default).getInstance();
    const [interactionSessionId, setInteractionSessionId] = (0, $fc4bM.useState)(()=>{
        var _interactionSessionCl;
        return ((_interactionSessionCl = interactionSessionClientRef.current) === null || _interactionSessionCl === void 0 ? void 0 : _interactionSessionCl.getCurrentInteractionSessionId()) ?? '';
    });
    (0, $fc4bM.useEffect)(()=>{
        if (!isEnabled) return ()=>{};
        // Add event listener that subscribes to any future interaction session ID updates
        const unbind = (0, $6Zi52.bind)(document, {
            type: $d961716374f3f23b$export$5d4c4eab0863aae3,
            listener: ()=>{
                // Re-attempt fetch Global interactionSessionClient if not present already
                if (!interactionSessionClientRef.current) interactionSessionClientRef.current = (0, $hs3Zi.default).getInstance();
                if (interactionSessionClientRef.current) {
                    const currentSessionId = interactionSessionClientRef.current.getCurrentInteractionSessionId();
                    currentSessionId && setInteractionSessionId(currentSessionId);
                }
            }
        });
        return unbind;
    }, [
        isEnabled
    ]);
    return (0, $fc4bM.useCallback)((url)=>{
        if (!isEnabled || !interactionSessionId) return url;
        return (0, $c6RWu.generateUrlWithParams)(url, bridge, interactionSessionId, product, subProduct);
    }, [
        isEnabled,
        bridge,
        interactionSessionId,
        product,
        subProduct
    ]);
}
var $d961716374f3f23b$export$2e2bcd8739ae039 = $d961716374f3f23b$export$fc6e9265f8d85c92;

});
parcelRegister("c6RWu", function(module, exports) {
$parcel$export(module.exports, "generateUrlWithParams", () => $612dc55854ad9d39$export$2e3999ec51334ffe);
const $612dc55854ad9d39$export$81d16f1428ce0486 = 'xpis';
const $612dc55854ad9d39$export$2e3999ec51334ffe = (url, bridge, interactionSessionId, product, subProduct)=>{
    const interactionSource = subProduct ? `${product}-${subProduct}` : product;
    const interactionSession = {
        bridge: bridge,
        id: interactionSessionId,
        source: interactionSource
    };
    const paramValueEncoded = btoa(JSON.stringify(interactionSession));
    let partialUrl = false;
    let urlObj;
    // If relative URL provided, add localhost as placeholder base, to be stripped later
    try {
        urlObj = new URL(url);
    } catch  {
        urlObj = new URL(url, 'http://localhost/');
        partialUrl = true;
    }
    urlObj.searchParams.set($612dc55854ad9d39$export$81d16f1428ce0486, paramValueEncoded);
    if (partialUrl) return urlObj.pathname + urlObj.search;
    else return urlObj.toString();
};

});

parcelRegister("hs3Zi", function(module, exports) {
$parcel$export(module.exports, "default", () => $ef277bd35074aef6$export$2e2bcd8739ae039);
// WARNING: This value is shared between @atlaskit/analytics-cross-product and
// @atlassiansox/analytics-cross-product-interaction-client. Take care when updating.
const $ef277bd35074aef6$export$7bc189309d2ad463 = 'analyticsInteractionSesssionTrackingClient';
class $ef277bd35074aef6$export$2e2bcd8739ae039 {
    static getInstance() {
        let interactionSessionTracking;
        try {
            // Check if InteractionSessionTracking in global window object
            if ($ef277bd35074aef6$export$7bc189309d2ad463 in window) interactionSessionTracking = window[$ef277bd35074aef6$export$7bc189309d2ad463];
        } catch (err) {
        // Silently swallow exception
        }
        return interactionSessionTracking;
    }
}

});


parcelRegister("d217T", function(module, exports) {
$parcel$export(module.exports, "XPC_CONSTANTS", () => $67d11956f8ca527a$export$77dc2792a6ac896b);
const $67d11956f8ca527a$export$77dc2792a6ac896b = {
    SMART_LINKS_XPC_BRIDGE: 'smartLinks',
    QUERY_PARAM: 'xpis'
};

});

parcelRegister("abcPE", function(module, exports) {
$parcel$export(module.exports, "getIsFirstPartyLink", () => $2c16a5128a17a070$export$189e6ab4f1c74893);
const $2c16a5128a17a070$export$189e6ab4f1c74893 = (details)=>{
    var _details$meta;
    return ((details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.is1PLink) ?? false) === true;
};

});


parcelRegister("eANHk", function(module, exports) {
$parcel$export(module.exports, "useSmartLinkRenderers", () => $2ed9ec1a3bfc3415$export$c3514c024fefef57);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");
const $2ed9ec1a3bfc3415$export$c3514c024fefef57 = ()=>{
    const context = (0, $fnEFU.useSmartLinkContext)();
    let renderers = context === null || context === void 0 ? void 0 : context.renderers;
    renderers = (0, $fc4bM.useMemo)(()=>renderers, [
        renderers
    ]);
    return renderers;
};

});

parcelRegister("8K8sp", function(module, exports) {
$parcel$export(module.exports, "SmartLinkModalProvider", () => $8be21497b8c70068$export$bb4eb02a83e1a0f8);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $kX8sF = parcelRequire("kX8sF");

var $IobPJ = parcelRequire("IobPJ");
const $8be21497b8c70068$export$bb4eb02a83e1a0f8 = ({ children: children })=>{
    const [element, setElement] = (0, $fc4bM.useState)(null);
    const api = (0, $fc4bM.useMemo)(()=>({
            open: (modal)=>setElement(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fc4bM.Suspense), {
                    fallback: null
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kX8sF.StopPropagation), null, modal))),
            close: ()=>setElement(null)
        }), []);
    const fallbackRender = (0, $fc4bM.useCallback)(({ resetErrorBoundary: resetErrorBoundary })=>{
        resetErrorBoundary();
        return null;
    }, []);
    const onReset = (0, $fc4bM.useCallback)(()=>setElement(null), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $IobPJ.SmartLinkModalContext).Provider, {
        value: api
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        fallbackRender: fallbackRender,
        onReset: onReset
    }, element));
};

});
parcelRegister("kX8sF", function(module, exports) {
$parcel$export(module.exports, "StopPropagation", () => $aebc7b5e55bb9d4d$export$3e100bc08448f36c);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $aebc7b5e55bb9d4d$var$styles = {
    wrapper: "_c71lidpf _p12fidpf _kqswstnw"
};
const $aebc7b5e55bb9d4d$export$3e100bc08448f36c = ({ children: children })=>{
    const onClick = (0, $fc4bM.useCallback)((e)=>{
        // Prevent click events from bubbling up
        e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        as: "span",
        role: "none",
        xcss: $aebc7b5e55bb9d4d$var$styles.wrapper,
        onClick: onClick
    }, children);
};

});


parcelRegister("aNEya", function(module, exports) {
$parcel$export(module.exports, "getAnchorAttributesFromEvent", () => $8f86219e53c9614b$export$bd1e92a09497f497);
const $8f86219e53c9614b$export$bd1e92a09497f497 = (event)=>{
    const currentTarget = event.currentTarget;
    if (!(currentTarget instanceof HTMLAnchorElement)) return {
        href: undefined,
        target: '_self'
    };
    return {
        href: currentTarget.href,
        target: currentTarget.target || '_self'
    };
};

});

parcelRegister("bNNZ4", function(module, exports) {
$parcel$export(module.exports, "isSpecialClick", () => $8d5ef8e8a18398b6$export$5b1771037ab7c451);
parcelRequire("fc4bM");
const $8d5ef8e8a18398b6$export$5b1771037ab7c451 = (event)=>event.button === 1;

});

parcelRegister("kTSf6", function(module, exports) {
$parcel$export(module.exports, "isSpecialEvent", () => $566d0323e13b7e81$export$efca2c4705678489);
parcelRequire("fc4bM");

var $j38Ls = parcelRequire("j38Ls");

var $bNNZ4 = parcelRequire("bNNZ4");

var $9pmKt = parcelRequire("9pmKt");
const $566d0323e13b7e81$export$efca2c4705678489 = (evt)=>evt.isDefaultPrevented() && ((0, $j38Ls.isIframe)() || (0, $9pmKt.isSpecialKey)(evt) || (0, $bNNZ4.isSpecialClick)(evt));

});
parcelRegister("j38Ls", function(module, exports) {
$parcel$export(module.exports, "isIframe", () => $bf43a75f366aadfa$export$e6c5ffa684aac4d7);
const $bf43a75f366aadfa$export$e6c5ffa684aac4d7 = ()=>window.parent !== parent;

});

parcelRegister("9pmKt", function(module, exports) {
$parcel$export(module.exports, "isSpecialKey", () => $7d093461de3b9f6d$export$d8de0cd37d316fdf);
parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");
const $7d093461de3b9f6d$export$d8de0cd37d316fdf = (event)=>{
    return (0, $dRkX9.fg)('platform-smart-card-shift-key') ? event.metaKey || event.ctrlKey || event.shiftKey : event.metaKey || event.ctrlKey;
};

});


parcelRegister("8jRNm", function(module, exports) {
$parcel$export(module.exports, "updateAnchorHref", () => $4c1e56d519fbeed4$export$9853bee72613d48f);
const $4c1e56d519fbeed4$export$9853bee72613d48f = (event, href)=>{
    if (!(event.currentTarget instanceof HTMLAnchorElement)) return;
    event.currentTarget.href = href;
};

});

parcelRegister("6Sqna", function(module, exports) {
$parcel$export(module.exports, "default", () => $4975249c55c38726$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fnEFU = parcelRequire("fnEFU");

var $dRkX9 = parcelRequire("dRkX9");

var $d7r8x = parcelRequire("d7r8x");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $1Ebbu = parcelRequire("1Ebbu");

var $1CO4o = parcelRequire("1CO4o");

var $gkKen = parcelRequire("gkKen");

var $fypiH = parcelRequire("fypiH");

var $gysdQ = parcelRequire("gysdQ");

var $jpYbX = parcelRequire("jpYbX");

var $fjS9q = parcelRequire("fjS9q");

var $heq9X = parcelRequire("heq9X");
const $4975249c55c38726$var$PENDING_LINK_STATUSES = [
    (0, $j9rqA.SmartLinkStatus).Pending,
    (0, $j9rqA.SmartLinkStatus).Resolving
];
/**
 * This represents a Flexible Card: a link represented by a card with metadata.
 * This is the container in which all Flexible UI Blocks and Elements exist.
 * Note: TitleBlock is mandatory for a Flexible Card to render.
 * @see Container
 */ const $4975249c55c38726$var$FlexibleCard = ({ appearance: appearance = 'flexible', navigation: navigation, cardState: cardState, children: children, id: id, onAuthorize: onAuthorize, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, onError: onError, onResolve: onResolve, origin: origin, placeholderData: placeholderData, renderers: renderers, showHoverPreview: showHoverPreview, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, testId: testId, ui: ui, url: url, title: ssrTitle })=>{
    var _details$meta2, _flexibleCardContext$;
    const aiSummaryConfig = (0, $gkKen.useAISummaryConfig)();
    const resolve = (0, $fypiH.default)();
    const { isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, product: product } = (0, $fnEFU.useSmartLinkContext)();
    const rovoConfig = (0, $gysdQ.default)();
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const { status: cardType, details: details } = cardState;
    const status = cardType;
    const appendCrossProductAnalyticsParams = (0, $jpYbX.useSmartLinkCrossProductUrlWrapper)({
        details: details
    });
    const transformUrl = (0, $fc4bM.useCallback)((destinationUrl = url)=>appendCrossProductAnalyticsParams(destinationUrl), [
        appendCrossProductAnalyticsParams,
        url
    ]);
    // if we have placeholder state it means we can internally use it
    // as temporary resolved data until the actual data comes back as one of the final statuses
    const placeholderCardState = (0, $fc4bM.useMemo)(()=>$4975249c55c38726$var$PENDING_LINK_STATUSES.includes(status) && placeholderData && (0, $1Ebbu.extractPlaceHolderCardState)(placeholderData), [
        placeholderData,
        status
    ]);
    const placeHolderStatus = placeholderCardState ? placeholderCardState.status : undefined;
    const context = (0, $fc4bM.useMemo)(()=>(0, $heq9X.getContextByStatus)({
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            response: placeholderCardState ? placeholderCardState.details : details,
            id: id,
            onAuthorize: onAuthorize,
            onClick: onClick,
            onAuxClick: onAuxClick,
            onContextMenu: onContextMenu,
            origin: origin,
            renderers: renderers,
            resolve: resolve,
            product: product,
            rovoConfig: rovoConfig,
            actionOptions: actionOptions,
            status: placeholderCardState ? placeHolderStatus : status,
            url: url,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }), [
        aiSummaryConfig,
        appearance,
        actionOptions,
        details,
        id,
        isPreviewPanelAvailable,
        isPreviewRestricted,
        onAuthorize,
        onClick,
        onAuxClick,
        onContextMenu,
        openPreviewPanel,
        origin,
        placeholderCardState,
        placeHolderStatus,
        product,
        renderers,
        resolve,
        rovoConfig,
        status,
        transformUrl,
        url,
        fireEvent
    ]);
    const flexibleCardContext = (0, $fc4bM.useMemo)(()=>({
            data: context,
            navigation: context ? navigation : undefined,
            status: placeHolderStatus ?? status,
            ui: ui
        }), [
        context,
        placeHolderStatus,
        status,
        ui,
        navigation
    ]);
    const { linkTitle: linkTitle } = context || {};
    const title = linkTitle === null || linkTitle === void 0 ? void 0 : linkTitle.text;
    (0, $fc4bM.useEffect)(()=>{
        switch(status){
            case (0, $j9rqA.SmartLinkStatus).Resolved:
                if (onResolve) {
                    var _details$meta;
                    onResolve({
                        title: title,
                        url: url,
                        extensionKey: details === null || details === void 0 || (_details$meta = details.meta) === null || _details$meta === void 0 ? void 0 : _details$meta.key
                    });
                }
                break;
            case (0, $j9rqA.SmartLinkStatus).Errored:
            case (0, $j9rqA.SmartLinkStatus).Fallback:
            case (0, $j9rqA.SmartLinkStatus).Forbidden:
            case (0, $j9rqA.SmartLinkStatus).NotFound:
            case (0, $j9rqA.SmartLinkStatus).Unauthorized:
                if (onError) onError({
                    status: status,
                    url: url
                });
                break;
        }
    }, [
        onError,
        onResolve,
        status,
        title,
        url,
        details === null || details === void 0 || (_details$meta2 = details.meta) === null || _details$meta2 === void 0 ? void 0 : _details$meta2.key
    ]);
    const retry = (_flexibleCardContext$ = flexibleCardContext.data) === null || _flexibleCardContext$ === void 0 || (_flexibleCardContext$ = _flexibleCardContext$.actions) === null || _flexibleCardContext$ === void 0 ? void 0 : _flexibleCardContext$[(0, $j9rqA.InternalActionName).UnresolvedAction];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1CO4o.FlexibleCardContext).Provider, {
        value: flexibleCardContext
    }, $4975249c55c38726$var$PENDING_LINK_STATUSES.includes(status) && !Boolean(placeholderCardState) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $d7r8x.default), {
        name: "smart-card-flexible-card"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fjS9q.default), {
        testId: testId,
        ...ui,
        title: ssrTitle,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        showHoverPreview: showHoverPreview,
        hoverPreviewOptions: hoverPreviewOptions,
        actionOptions: actionOptions,
        status: status,
        retry: retry
    }, children));
};
var $4975249c55c38726$export$2e2bcd8739ae039 = $4975249c55c38726$var$FlexibleCard;

});
parcelRegister("1Ebbu", function(module, exports) {
$parcel$export(module.exports, "extractPlaceHolderCardState", () => $39d8a7b362f4e608$export$684541b2632ffbbc);
const $39d8a7b362f4e608$var$isValidPlaceholderData = (placeholderData)=>(placeholderData === null || placeholderData === void 0 ? void 0 : placeholderData.data) && 'url' in placeholderData.data && 'name' in placeholderData.data;
const $39d8a7b362f4e608$export$684541b2632ffbbc = (placeholderData)=>{
    return $39d8a7b362f4e608$var$isValidPlaceholderData(placeholderData) ? {
        status: 'resolved',
        metadataStatus: undefined,
        details: placeholderData
    } : undefined;
};

});

parcelRegister("fjS9q", function(module, exports) {
$parcel$export(module.exports, "default", () => $e92d02d12ff9164a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ 
var $2R2iS = parcelRequire("2R2iS");
var $8xbhL = parcelRequire("8xbhL");

var $fc4bM = parcelRequire("fc4bM");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $8tmA1 = parcelRequire("8tmA1");

var $bfu8W = parcelRequire("bfu8W");

var $3vVf0 = parcelRequire("3vVf0");

var $le6AR = parcelRequire("le6AR");

var $2Dis3 = parcelRequire("2Dis3");
const $e92d02d12ff9164a$var$filterChildren = (children, removeBlockRestriction)=>{
    if (removeBlockRestriction) return children;
    return (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children, (child)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child) && (0, $8tmA1.isFlexibleUiBlock)(child) ? child : undefined);
};
const $e92d02d12ff9164a$var$getTitleBlockProps = (children)=>{
    const block = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.toArray(children).map((child)=>(0, $3vVf0.getFlexibleUiBlock)(child)).filter((x)=>x !== undefined).at(0);
    if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(block)) return block.props;
};
const $e92d02d12ff9164a$var$getLayeredLink = (testId, context, children, onClick, onAuxClick, onContextMenu, title, navigation)=>{
    const { linkTitle: linkTitle, url: url = '' } = context || {};
    // SSR cannot reliably extract TitleBlock props from children, so `title` is
    // provided from CardSSR as a stable server/client value to prevent hydration
    // text mismatches for the clickable container link.
    const { anchorTarget: target, text: text } = $e92d02d12ff9164a$var$getTitleBlockProps(children) || {};
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $2Dis3.default), {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        target: (0, $dRkX9.fg)('confluence_ep_shim_macro_links_v2') ? target ?? (navigation === null || navigation === void 0 ? void 0 : navigation.target) : target,
        testId: testId,
        text: title || text || (linkTitle === null || linkTitle === void 0 ? void 0 : linkTitle.text),
        url: (0, $dRkX9.fg)('confluence_ep_shim_macro_links_v2') ? (navigation === null || navigation === void 0 ? void 0 : navigation.url) ?? url : url
    });
};
const $e92d02d12ff9164a$var$baseStyleCommon = null;
const $e92d02d12ff9164a$var$backgroundStyles = null;
const $e92d02d12ff9164a$var$elevationStyles = null;
const $e92d02d12ff9164a$var$clickableContainerStyles = null;
const $e92d02d12ff9164a$var$gapStyleMap = {
    xlarge: "_zulpr2fv",
    large: "_zulpzu5n",
    medium: "_zulp1bpf",
    small: "_zulpswc3"
};
/**
 * Get container padding based on smart link size
 * Equivalent version for DS primitives space token is getPrimitivesPaddingSpaceBySize()
 * at view/FlexibleCard/components/utils.tsx
 */ const $e92d02d12ff9164a$var$getPadding = (size)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $j9rqA.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $j9rqA.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $j9rqA.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};
const $e92d02d12ff9164a$var$getGap = (size)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).XLarge:
            return "var(--ds-space-250, 20px)";
        case (0, $j9rqA.SmartLinkSize).Large:
            return "var(--ds-space-200, 16px)";
        case (0, $j9rqA.SmartLinkSize).Medium:
            return "var(--ds-space-100, 8px)";
        case (0, $j9rqA.SmartLinkSize).Small:
        default:
            return "var(--ds-space-050, 4px)";
    }
};
const $e92d02d12ff9164a$var$previewOnLeftStyleMap = {
    xlarge: "_19bver0k _y5vk1ejb",
    large: "_19bv16ru _y5vkv47k",
    medium: "_19bv1g7w _y5vk1eak",
    small: "_19bvlbes _y5vku2gc"
};
const $e92d02d12ff9164a$var$previewOnRightStyleMap = {
    xlarge: "_u5f3er0k _1yob1ejb",
    large: "_u5f316ru _1yobv47k",
    medium: "_u5f31g7w _1yob1eak",
    small: "_u5f3lbes _1yobu2gc"
};
/**
 * A container is a hidden component that build the Flexible Smart Link.
 * All the Flexible UI components are wrapped inside the container.
 * It inherits the ui props from Card component and applies the custom styling
 * accordingly.
 * @internal
 * @see Block
 */ const $e92d02d12ff9164a$var$Container = ({ children: children, clickableContainer: clickableContainer = false, hideBackground: hideBackground = false, hideElevation: hideElevation = false, hidePadding: hidePadding = false, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, retry: retry, showHoverPreview: showHoverPreview = false, hoverPreviewOptions: hoverPreviewOptions, actionOptions: actionOptions, removeBlockRestriction: removeBlockRestriction = false, size: size = (0, $j9rqA.SmartLinkSize).Medium, status: status, testId: testId = 'smart-links-container', title: title })=>{
    const padding = hidePadding ? '0px' : $e92d02d12ff9164a$var$getPadding(size);
    const gap = $e92d02d12ff9164a$var$getGap(size);
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    const context = cardContext === null || cardContext === void 0 ? void 0 : cardContext.data;
    const { previewOnLeft: previewOnLeft, previewOnRight: previewOnRight } = (0, $bfu8W.getChildrenOptions)(children, context);
    const isResolved = status === 'resolved';
    const isUnresolvedWithAuthFlow = status !== 'resolved' && retry !== undefined;
    const hasHoverCardOverride = (hoverPreviewOptions === null || hoverPreviewOptions === void 0 ? void 0 : hoverPreviewOptions.render) !== undefined;
    const canShowHoverCard = showHoverPreview && (isResolved || isUnresolvedWithAuthFlow || hasHoverCardOverride);
    const containerPaddingStyles = null;
    const container = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-smart-link-container": true,
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _2lx21bp4 _1ul9idpf _1reo15vq _kqswh2mm _1pcmkb7n _1v7y1i6y _ufn21i6y",
            $e92d02d12ff9164a$var$gapStyleMap[size],
            !hideBackground && "_bfhkhp5a",
            "_1yt418y6 _jb7v18y6 _y5vk167t _1yob1wow _r37x1r5k",
            previewOnLeft && $e92d02d12ff9164a$var$previewOnLeftStyleMap[size],
            previewOnRight && $e92d02d12ff9164a$var$previewOnRightStyleMap[size],
            !hideElevation && "_19itia51 _2rkopb1k _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            clickableContainer && "_nqwih2mm _18ywh2mm _1nq3h2mm _1t4ckb7n _1nxdkb7n _xnbykb7n"
        ]),
        style: {
            "--_1xumd0e": (0, $8xbhL.default)(padding),
            "--_73mooq": (0, $8xbhL.default)(previewOnLeft ? gap : padding),
            "--_12k13bg": (0, $8xbhL.default)(previewOnRight ? gap : padding)
        }
    }, clickableContainer ? $e92d02d12ff9164a$var$getLayeredLink(testId, context, children, onClick, onAuxClick, onContextMenu, title, cardContext === null || cardContext === void 0 ? void 0 : cardContext.navigation) : null, $e92d02d12ff9164a$var$filterChildren(children, removeBlockRestriction));
    if (context !== null && context !== void 0 && context.url && canShowHoverCard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $le6AR.default), {
        isHoverPreview: isResolved || hasHoverCardOverride,
        isAuthTooltip: isUnresolvedWithAuthFlow,
        actionOptions: actionOptions,
        testId: testId,
        url: context.url,
        hoverPreviewOptions: hoverPreviewOptions
    }, container);
    return container;
};
var $e92d02d12ff9164a$export$2e2bcd8739ae039 = $e92d02d12ff9164a$var$Container;

});
parcelRegister("8tmA1", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiBlock", () => $8ab6ad98b6a477e0$export$b56fc89cf6e7d1e9);

var $fc4bM = parcelRequire("fc4bM");

var $aWTkn = parcelRequire("aWTkn");

var $lxogF = parcelRequire("lxogF");

var $gndj3 = parcelRequire("gndj3");

var $4G7KW = parcelRequire("4G7KW");

var $7hyc5 = parcelRequire("7hyc5");

var $eZzzn = parcelRequire("eZzzn");

var $8DLmm = parcelRequire("8DLmm");

var $PBikU = parcelRequire("PBikU");

var $htqFW = parcelRequire("htqFW");

var $8AeTQ = parcelRequire("8AeTQ");
const $8ab6ad98b6a477e0$var$Blocks = {
    ActionBlock: $aWTkn.default,
    AIFooterBlock: $lxogF.default,
    Block: $gndj3.default,
    FooterBlock: $4G7KW.default,
    MetadataBlock: $eZzzn.default,
    PreviewBlock: $8DLmm.default,
    SnippetBlock: $PBikU.default,
    TitleBlock: $htqFW.default,
    ResolvedHoverCardFooterBlock: $7hyc5.default
};
const $8ab6ad98b6a477e0$export$b56fc89cf6e7d1e9 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node)) return false;
    if ((0, $8AeTQ.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $8ab6ad98b6a477e0$export$b56fc89cf6e7d1e9(child);
        });
        return isChildrenValid;
    }
    if (Object.values($8ab6ad98b6a477e0$var$Blocks).some((type)=>type === node.type)) return true;
    return false;
};

});
parcelRegister("aWTkn", function(module, exports) {
$parcel$export(module.exports, "default", () => $47974e6bc4c296e2$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $5QRjl = parcelRequire("5QRjl");

var $5JwWG = parcelRequire("5JwWG");

var $1YSgn = parcelRequire("1YSgn");

var $abdiM = parcelRequire("abdiM");

var $5fYbv = parcelRequire("5fYbv");

var $5uGAu = parcelRequire("5uGAu");

var $gjk4e = parcelRequire("gjk4e");

var $iWoHD = parcelRequire("iWoHD");

var $6MfmW = parcelRequire("6MfmW");

var $8H2BQ = parcelRequire("8H2BQ");

var $8gSVN = parcelRequire("8gSVN");

var $8Up1A = parcelRequire("8Up1A");

var $aV7nQ = parcelRequire("aV7nQ");

var $1mR3m = parcelRequire("1mR3m");

var $7ESpL = parcelRequire("7ESpL");
const $47974e6bc4c296e2$var$ignoreContainerPaddingStyles = null;
const $47974e6bc4c296e2$var$Actions = {
    [(0, $j9rqA.ActionName).AutomationAction]: (0, $abdiM.default),
    [(0, $j9rqA.ActionName).CopyLinkAction]: (0, $5fYbv.default),
    [(0, $j9rqA.ActionName).CustomAction]: (0, $5JwWG.default),
    [(0, $j9rqA.ActionName).DeleteAction]: (0, $gjk4e.default),
    [(0, $j9rqA.ActionName).DownloadAction]: (0, $iWoHD.default),
    [(0, $j9rqA.ActionName).EditAction]: (0, $6MfmW.default),
    [(0, $j9rqA.ActionName).FollowAction]: (0, $8H2BQ.default),
    [(0, $j9rqA.ActionName).PreviewAction]: (0, $8gSVN.default),
    [(0, $j9rqA.ActionName).RovoChatAction]: (0, $8Up1A.default),
    [(0, $j9rqA.InternalActionName).AISummaryAction]: (0, $1YSgn.default),
    [(0, $j9rqA.InternalActionName).UnresolvedAction]: (0, $5uGAu.default),
    [(0, $j9rqA.InternalActionName).ViewRelatedLinksAction]: (0, $aV7nQ.default)
};
const $47974e6bc4c296e2$var$DEFAULT_SORT_ORDER = [
    'PreviewAction',
    'CopyLinkAction',
    'AISummaryAction'
];
const $47974e6bc4c296e2$var$sort = (a, b)=>{
    let idxA = $47974e6bc4c296e2$var$DEFAULT_SORT_ORDER.indexOf(a);
    let idxB = $47974e6bc4c296e2$var$DEFAULT_SORT_ORDER.indexOf(b);
    if (idxA === -1) idxA = $47974e6bc4c296e2$var$DEFAULT_SORT_ORDER.length;
    if (idxB === -1) idxB = $47974e6bc4c296e2$var$DEFAULT_SORT_ORDER.length;
    return idxA - idxB;
};
const $47974e6bc4c296e2$var$ActionBlock = ({ blockRef: blockRef, onClick: onClickCallback, size: size, spaceInline: spaceInline, className: className, testId: testId = 'smart-block-action' })=>{
    const context = (0, $dweer.useFlexibleUiContext)();
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    const [message, setMessage] = (0, $fc4bM.useState)();
    const [isLoading, setIsLoading] = (0, $fc4bM.useState)(false);
    const onLoadingChange = (0, $fc4bM.useCallback)((isLoading)=>{
        setIsLoading(isLoading);
    }, [
        setIsLoading
    ]);
    const padding = !(ui !== null && ui !== void 0 && ui.hidePadding) ? (0, $7ESpL.getPrimitivesPaddingSpaceBySize)((ui === null || ui === void 0 ? void 0 : ui.size) || (0, $j9rqA.SmartLinkSize).Medium) : undefined;
    const onClick = (0, $fc4bM.useCallback)((name)=>{
        setMessage(undefined);
        onClickCallback === null || onClickCallback === void 0 || onClickCallback(name);
    }, [
        onClickCallback
    ]);
    const onError = (0, $fc4bM.useCallback)((error)=>{
        setMessage(error);
    }, []);
    const actions = (0, $fc4bM.useMemo)(()=>{
        if (!(context !== null && context !== void 0 && context.actions)) return;
        const arr = Object.keys(context.actions).filter((name)=>name !== (0, $j9rqA.ActionName).RovoChatAction);
        arr.sort($47974e6bc4c296e2$var$sort);
        const renderAction = (name)=>{
            const Action = name in $47974e6bc4c296e2$var$Actions ? $47974e6bc4c296e2$var$Actions[name] : undefined;
            if (!Action) return null;
            return /*#__PURE__*/ $fc4bM.createElement(Action, {
                as: "stack-item",
                spaceInline: spaceInline,
                key: name,
                onClick: ()=>onClick(name),
                onError: onError,
                onLoadingChange: onLoadingChange,
                size: size || (ui === null || ui === void 0 ? void 0 : ui.size),
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                style: padding ? {
                    paddingInline: padding
                } : undefined,
                hideTooltip: isLoading
            });
        };
        return arr.map((name)=>renderAction(name));
    }, [
        context === null || context === void 0 ? void 0 : context.actions,
        spaceInline,
        onError,
        onLoadingChange,
        size,
        ui === null || ui === void 0 ? void 0 : ui.size,
        padding,
        isLoading,
        onClick
    ]);
    if (!actions) return null;
    return /*#__PURE__*/ $fc4bM.createElement("div", {
        ref: blockRef,
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _16jlkb7n _1bsb129b _18u01ivi _2hwxc10g",
            className
        ])
    }, actions, /*#__PURE__*/ $fc4bM.createElement((0, $1mR3m.ActionFooter), {
        message: message,
        testId: testId
    }));
};
var $47974e6bc4c296e2$export$2e2bcd8739ae039 = $47974e6bc4c296e2$var$ActionBlock;

});
parcelRegister("1mR3m", function(module, exports) {
$parcel$export(module.exports, "ActionFooter", () => $5ba77dacc9fa9a94$export$2d2b754ac238f9aa);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $gDsF8 = parcelRequire("gDsF8");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $7isd9 = parcelRequire("7isd9");
const $5ba77dacc9fa9a94$var$styles = {
    containerStyles: "_kkk2n7od _2rko12b0 _1rjc12x7 _18zru2gc _19pku2gc _2hwxu2gc _otyrze3t _18u0u2gc _1bsb1osq _fiawglyw",
    errorContentStyles: "_bozgv77o",
    titleStyles: "_11c8wadc _syazazsu"
};
const $5ba77dacc9fa9a94$var$getIcon = (appearance)=>{
    switch(appearance){
        case 'error':
            return /*#__PURE__*/ $fc4bM.createElement((0, (/*@__PURE__*/$parcel$interopDefault($gDsF8))), {
                color: "var(--ds-icon-danger, #C9372C)",
                spacing: "compact",
                label: "Error",
                testId: "action-error-icon",
                size: "small"
            });
        default:
            return null;
    }
};
const $5ba77dacc9fa9a94$export$2d2b754ac238f9aa = ({ message: message, testId: testId })=>{
    if (!message) return null;
    return /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        backgroundColor: message.appearance === 'error' ? 'color.background.danger' : undefined,
        testId: `${testId}-footer`,
        style: {
            width: `calc(100% - var(--container-padding-left) - var(--container-padding-right))`
        },
        xcss: $5ba77dacc9fa9a94$var$styles.containerStyles
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7isd9.default), {
        isFadeIn: true,
        show: true,
        showTransition: true
    }, /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
        alignBlock: "start",
        grow: "fill",
        space: "space.075",
        xcss: $5ba77dacc9fa9a94$var$styles.errorContentStyles
    }, message.icon || $5ba77dacc9fa9a94$var$getIcon(message.appearance), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $5ba77dacc9fa9a94$var$styles.titleStyles
    }, message.title))));
};

});
parcelRegister("7isd9", function(module, exports) {
$parcel$export(module.exports, "default", () => $552879ae3577e573$export$2e2bcd8739ae039);

var $223PG = parcelRequire("223PG");
var $552879ae3577e573$export$2e2bcd8739ae039 = (0, $223PG.MotionWrapper);

});
parcelRegister("223PG", function(module, exports) {
$parcel$export(module.exports, "MotionWrapper", () => $c6b1a47b56b6c1b2$export$6118ed0013927eb2);

var $fc4bM = parcelRequire("fc4bM");

var $dBtOK = parcelRequire("dBtOK");
const $c6b1a47b56b6c1b2$export$6118ed0013927eb2 = ({ children: children, isFadeIn: isFadeIn = false, minHeight: minHeight = 0, show: show, showTransition: showTransition = false })=>{
    const [height, setHeight] = (0, $fc4bM.useState)(0);
    const ref = (0, $fc4bM.useRef)(null);
    const transition = isFadeIn ? 'height, opacity' : 'height';
    (0, $fc4bM.useEffect)(()=>{
        if (show && ref.current) // set the height of the error message container explicitly to the height
        // of its contents (including anything hidden due to overflow) so that we
        // can animate the height of the container
        setHeight(ref.current.scrollHeight);
        else setHeight(0);
    }, [
        children,
        show
    ]);
    return show ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), {
        style: {
            height: height,
            minHeight: minHeight,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
            lineHeight: 0,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden',
            // a fit for purpose state variable to control when the 'visible' styles should be appled
            opacity: height > 0 ? 1 : 0,
            // we only want to transition opacity and height when the error message is initially shown
            // not if its to be shown on mount
            transitionProperty: showTransition ? transition : 'none',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            transitionDuration: '0.3s'
        },
        ref: ref
    }, children) : null;
};

});



parcelRegister("7ESpL", function(module, exports) {
$parcel$export(module.exports, "getPrimitivesPaddingSpaceBySize", () => $07671ad226657843$export$1af10e3728e3a644);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $j9rqA = parcelRequire("j9rqA");
const $07671ad226657843$export$1af10e3728e3a644 = (size)=>{
    switch(size){
        case (0, $j9rqA.SmartLinkSize).XLarge:
            return "var(--ds-space-300, 24px)";
        case (0, $j9rqA.SmartLinkSize).Large:
            return "var(--ds-space-250, 20px)";
        case (0, $j9rqA.SmartLinkSize).Medium:
            return "var(--ds-space-200, 16px)";
        case (0, $j9rqA.SmartLinkSize).Small:
        default:
            return "var(--ds-space-100, 8px)";
    }
};

});


parcelRegister("lxogF", function(module, exports) {
$parcel$export(module.exports, "default", () => $893bf817f8cb78c3$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $4PrIA = parcelRequire("4PrIA");
/**
 * Represents a AIFooterBlock, designed to show provider metadata in
 * addition to AI tooltip icons if AI is enabled
 * @param {AIFooterBlockProps} AIFooterBlockProps
 * @see Block
 */ const $893bf817f8cb78c3$var$AIFooterBlock = ({ testId: testId = 'smart-ai-footer-block', ...props })=>{
    var _cardContext$ui;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $j9rqA.SmartLinkStatus).Resolved) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4PrIA.default), {
        ...props,
        size: props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
        testId: testId
    });
};
var $893bf817f8cb78c3$export$2e2bcd8739ae039 = $893bf817f8cb78c3$var$AIFooterBlock;

});
parcelRegister("4PrIA", function(module, exports) {
$parcel$export(module.exports, "default", () => $57927c03bbad805a$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $38Op4 = parcelRequire("38Op4");

var $gndj3 = parcelRequire("gndj3");

var $6ulQU = parcelRequire("6ulQU");
const $57927c03bbad805a$var$AIFooterBlockResolvedView = (props)=>{
    var _context$actions;
    const context = (0, $dweer.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.InternalActionName).AISummaryAction];
    const { testId: testId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gndj3.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $38Op4.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    }), actionData ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6ulQU.AIFooterMetadata), {
        ...actionData,
        testId: `${testId}-ai-metadata`
    }) : null);
};
var $57927c03bbad805a$export$2e2bcd8739ae039 = $57927c03bbad805a$var$AIFooterBlockResolvedView;

});
parcelRegister("6ulQU", function(module, exports) {
$parcel$export(module.exports, "AIFooterMetadata", () => $afaee1bb5ca4ae1b$export$175228cc2c92b3b6);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $dFt22 = parcelRequire("dFt22");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $bcTS3 = parcelRequire("bcTS3");

var $ewFKq = parcelRequire("ewFKq");

var $khHoI = parcelRequire("khHoI");

var $bU1DE = parcelRequire("bU1DE");
const $afaee1bb5ca4ae1b$export$175228cc2c92b3b6 = ({ testId: testId, url: url })=>{
    const { state: { status: status } } = (0, $khHoI.default)(url);
    if (status !== 'done') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $i3riz.Inline), {
        space: "space.100",
        testId: testId,
        alignInline: "end",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bcTS3.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $ewFKq.messages).ai_summarized_info_short),
        position: "bottom"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dBtOK.Box), tooltipProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $bU1DE.InfoIcon), {
            label: "Information",
            color: "var(--ds-icon-subtle, #505258)"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dFt22))), {
        label: "AI",
        color: "var(--ds-icon-subtle, #505258)"
    }));
};

});
parcelRegister("bU1DE", function(module, exports) {
$parcel$export(module.exports, "InfoIcon", () => $619f1eccb018c6e9$export$2957fc44b3d2481);

var $fc4bM = parcelRequire("fc4bM");

var $fKWgA = parcelRequire("fKWgA");
const $619f1eccb018c6e9$export$2957fc44b3d2481 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fKWgA))), {
        color: props.color || 'currentColor',
        ...props
    });

});




parcelRegister("4G7KW", function(module, exports) {
$parcel$export(module.exports, "default", () => $ab36cdff310bf8c1$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $fLEQb = parcelRequire("fLEQb");
var $ab36cdff310bf8c1$export$2e2bcd8739ae039 = (0, $fLEQb.FooterBlock);

});
parcelRegister("fLEQb", function(module, exports) {
$parcel$export(module.exports, "FooterBlock", () => $69d11f85f55e970d$export$f83744e65a5b0c8f);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $cRZsT = parcelRequire("cRZsT");
const $69d11f85f55e970d$export$f83744e65a5b0c8f = ({ testId: testId = 'smart-footer-block', alwaysShow: alwaysShow, ...props })=>{
    var _cardContext$ui;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $j9rqA.SmartLinkStatus).Resolved && !alwaysShow) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cRZsT.default), {
        ...props,
        size: props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
        testId: testId
    });
};

});
parcelRegister("cRZsT", function(module, exports) {
$parcel$export(module.exports, "default", () => $a72a6437ad51f5c6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fJ9SP = parcelRequire("fJ9SP");

var $4gVCP = parcelRequire("4gVCP");

var $j9rqA = parcelRequire("j9rqA");

var $dweer = parcelRequire("dweer");

var $38Op4 = parcelRequire("38Op4");

var $kJrsj = parcelRequire("kJrsj");

var $gndj3 = parcelRequire("gndj3");

var $2UGy7 = parcelRequire("2UGy7");

var $8NM7g = parcelRequire("8NM7g");
const $a72a6437ad51f5c6$var$actionGroupStyles = null;
const $a72a6437ad51f5c6$var$safariStyles = null;
const $a72a6437ad51f5c6$var$providerStyles = null;
const $a72a6437ad51f5c6$var$rovoActionStyles = null;
const $a72a6437ad51f5c6$var$FooterBlockResolvedView = (props)=>{
    var _context$actions;
    const { actions: actions, testId: testId, onActionMenuOpenChange: onActionMenuOpenChange, size: size = (0, $j9rqA.SmartLinkSize).Medium, hideProvider: hideProvider, isPreviewBlockErrored: isPreviewBlockErrored } = props;
    const context = (0, $dweer.useFlexibleUiContext)();
    const rovoChatAction = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.ActionName).RovoChatAction];
    const isRovoActionsEnabled = (0, $fc4bM.useMemo)(()=>{
        return !!rovoChatAction && rovoChatAction.product === 'CONFLUENCE' && (actions === null || actions === void 0 ? void 0 : actions.some((action)=>action.name === 'RovoChatAction'));
    }, [
        rovoChatAction,
        actions
    ]);
    const hasPreview = isRovoActionsEnabled && !!(context !== null && context !== void 0 && context.preview) && !isPreviewBlockErrored;
    const hasActions = (0, $fc4bM.useMemo)(()=>{
        var _filterActionItems;
        return ((_filterActionItems = (0, $8NM7g.filterActionItems)(actions, context)) === null || _filterActionItems === void 0 ? void 0 : _filterActionItems.length) > 0;
    }, [
        actions,
        context
    ]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { safari: safari = false } = (0, $fc4bM.useMemo)(()=>(0, $fJ9SP.browser)(), []);
    const onDropdownOpenChange = (0, $fc4bM.useCallback)((isOpen)=>{
        if (onActionMenuOpenChange) onActionMenuOpenChange({
            isOpen: isOpen
        });
    }, [
        onActionMenuOpenChange
    ]);
    // WidthObserver fires whenever the footer's available width changes.
    const [containerWidth, setContainerWidth] = (0, $fc4bM.useState)(undefined);
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...props,
        testId: `${testId}-resolved-view`
    }, !hideProvider && /*#__PURE__*/ $fc4bM.createElement((0, $38Op4.default), {
        appearance: "subtle",
        testId: `${testId}-provider`,
        hideLabel: hasPreview,
        className: (0, $2R2iS.default)([
            isRovoActionsEnabled && "_1wpz1h6o"
        ])
    }), actions && hasActions ? /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        testId: "smart-element-group-actions",
        align: (0, $j9rqA.SmartLinkAlignment).Right,
        direction: (0, $j9rqA.SmartLinkDirection).Horizontal,
        width: (0, $j9rqA.SmartLinkWidth).Flexible,
        className: (0, $2R2iS.default)([
            size === (0, $j9rqA.SmartLinkSize).XLarge && "_c71lxy5q",
            safari && "_4t3i1osq",
            isRovoActionsEnabled && "_kqswh2mm"
        ])
    }, !!rovoChatAction && (rovoChatAction === null || rovoChatAction === void 0 ? void 0 : rovoChatAction.product) === 'CONFLUENCE' && /*#__PURE__*/ $fc4bM.createElement((0, $4gVCP.WidthObserver), {
        setWidth: setContainerWidth,
        offscreen: true
    }), /*#__PURE__*/ $fc4bM.createElement((0, $kJrsj.default), {
        onDropdownOpenChange: onDropdownOpenChange,
        items: actions,
        appearance: isRovoActionsEnabled ? 'subtle' : 'default',
        size: isRovoActionsEnabled ? (0, $j9rqA.SmartLinkSize).Small : size,
        containerWidth: isRovoActionsEnabled ? containerWidth : undefined
    })) : null);
};
var $a72a6437ad51f5c6$export$2e2bcd8739ae039 = $a72a6437ad51f5c6$var$FooterBlockResolvedView;

});



parcelRegister("7hyc5", function(module, exports) {
$parcel$export(module.exports, "default", () => $853b9746c3e42fe7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $dweer = parcelRequire("dweer");

var $1YSgn = parcelRequire("1YSgn");

var $abdiM = parcelRequire("abdiM");

var $5fYbv = parcelRequire("5fYbv");

var $5uGAu = parcelRequire("5uGAu");

var $iWoHD = parcelRequire("iWoHD");

var $8H2BQ = parcelRequire("8H2BQ");

var $8gSVN = parcelRequire("8gSVN");

var $8Up1A = parcelRequire("8Up1A");

var $aV7nQ = parcelRequire("aV7nQ");

var $38Op4 = parcelRequire("38Op4");

var $gndj3 = parcelRequire("gndj3");
/**
 * Allowed footer actions for HoverCard, in display order. Fetched from context.
 */ const $853b9746c3e42fe7$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS = [
    (0, $j9rqA.ActionName).RovoChatAction
];
const $853b9746c3e42fe7$var$Actions = {
    [(0, $j9rqA.ActionName).AutomationAction]: (0, $abdiM.default),
    [(0, $j9rqA.ActionName).CopyLinkAction]: (0, $5fYbv.default),
    [(0, $j9rqA.ActionName).DownloadAction]: (0, $iWoHD.default),
    [(0, $j9rqA.ActionName).FollowAction]: (0, $8H2BQ.default),
    [(0, $j9rqA.ActionName).PreviewAction]: (0, $8gSVN.default),
    [(0, $j9rqA.ActionName).RovoChatAction]: (0, $8Up1A.default),
    [(0, $j9rqA.InternalActionName).AISummaryAction]: (0, $1YSgn.default),
    [(0, $j9rqA.InternalActionName).UnresolvedAction]: (0, $5uGAu.default),
    [(0, $j9rqA.InternalActionName).ViewRelatedLinksAction]: (0, $aV7nQ.default)
};
const $853b9746c3e42fe7$var$ignoreContainerMarginStyles = null;
const $853b9746c3e42fe7$var$elevatedFooterStyles = null;
const $853b9746c3e42fe7$var$providerStyles = null;
const $853b9746c3e42fe7$var$actionsStyles = null;
/**
 * Footer block for HoverCard resolved view: Provider on the left, ActionGroup (up to 4 actions) on the right.
 * @internal
 * @param {ResolvedHoverCardFooterBlockProps} ResolvedHoverCardFooterBlockProps
 * @see Block
 */ const $853b9746c3e42fe7$var$ResolvedHoverCardFooterBlock = ({ testId: testId = 'smart-hover-card-footer-block', onActionClick: onActionClick, hideProvider: hideProvider, ...props })=>{
    var _cardContext$ui;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    const context = (0, $dweer.useFlexibleUiContext)();
    const size = props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size);
    const actions = (0, $fc4bM.useMemo)(()=>{
        if (!(context !== null && context !== void 0 && context.actions)) return [];
        let arr = Object.keys(context.actions);
        arr = arr.filter((name)=>!$853b9746c3e42fe7$var$HIDDEN_HOVER_CARD_FOOTER_ACTIONS.includes(name));
        return arr.map((name)=>{
            const Action = name in $853b9746c3e42fe7$var$Actions ? $853b9746c3e42fe7$var$Actions[name] : undefined;
            // Note: For the spinner to render properly, e.g. AI summary action,
            // the spinner need to be updated. See FIX-ME comment on ActionButton
            return Action ? /*#__PURE__*/ $fc4bM.createElement(Action, {
                key: name,
                as: "stack-item",
                content: "",
                onClick: ()=>onActionClick === null || onActionClick === void 0 ? void 0 : onActionClick(name),
                size: size,
                iconSize: 'small'
            }) : null;
        });
    }, [
        context === null || context === void 0 ? void 0 : context.actions,
        onActionClick,
        size
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...props,
        size: size,
        testId: `${testId}-resolved-view`,
        className: (0, $2R2iS.default)([
            "_18zrpxbi _1rjcutpp _vchhusvi _1bsb129b _18u01ivi _2hwxc10g _otyr1ya9 _4t3ioahv",
            "_zulpu2gc _x3doj0fz _bfhkhfxm _mrkb1mok _1o0z1mok"
        ])
    }, !hideProvider && /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_4t3i1ejb _1e0c1txw _4cvr1h6o _1bah1y6m _vchhusvi _16jlkb7n"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $38Op4.default), {
        appearance: "subtle",
        testId: `${testId}-provider`
    })), actions.length > 0 ? /*#__PURE__*/ $fc4bM.createElement("div", {
        "data-testid": `${testId}-actions`,
        className: (0, $2R2iS.default)([
            "_zulpidpf _1e0c1txw _18u01wug _4cvr1h6o _vchhusvi _7386ze3t _1xdd12b0 _17zize3t _19p4ze3t _6zimze3t _f9lhze3t _rvy9ze3t _ue4dze3t _zgrbze3t _10cuze3t _6syfze3t _3hv7ze3t"
        ])
    }, actions) : null);
};
var $853b9746c3e42fe7$export$2e2bcd8739ae039 = $853b9746c3e42fe7$var$ResolvedHoverCardFooterBlock;

});

parcelRegister("eZzzn", function(module, exports) {
$parcel$export(module.exports, "default", () => $c7ee278149963e91$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $ajxFh = parcelRequire("ajxFh");
var $c7ee278149963e91$export$2e2bcd8739ae039 = (0, $ajxFh.MetadataBlock);

});
parcelRegister("ajxFh", function(module, exports) {
$parcel$export(module.exports, "MetadataBlock", () => $2ea54971359e0054$export$2e4ce4ce734f69e1);
/* MetadataBlock.tsx generated by @compiled/babel-plugin v3.0.2 */ /* eslint-disable @atlaskit/design-system/use-tokens-typography */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $gndj3 = parcelRequire("gndj3");

var $2UGy7 = parcelRequire("2UGy7");

var $ddON5 = parcelRequire("ddON5");

var $h9b8V = parcelRequire("h9b8V");
const $2ea54971359e0054$var$truncateStyles = {
    '1': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjkb7n _sudp1e54",
    '2': "_1reo15vq _18m915vq _1e0ccj1k _1bto1l2s _1nmz1hna _1yyjcs5v _sudp1e54"
};
const $2ea54971359e0054$var$sizeStyles = {
    xlarge: "_102k8vuz",
    large: "_102k8vuz",
    medium: "_102kckbl",
    small: "_102kckbl"
};
const $2ea54971359e0054$var$getMaxLines = (maxLines)=>{
    if (maxLines > (0, $h9b8V.METADATA_BLOCK_CONSTANTS).MAXIMUM_MAX_LINES) return (0, $h9b8V.METADATA_BLOCK_CONSTANTS).DEFAULT_MAX_LINES;
    if (maxLines < (0, $h9b8V.METADATA_BLOCK_CONSTANTS).MINIMUM_MAX_LINES) return (0, $h9b8V.METADATA_BLOCK_CONSTANTS).MINIMUM_MAX_LINES;
    return maxLines;
};
const $2ea54971359e0054$var$ElementItemRenderer = ({ align: align = (0, $j9rqA.SmartLinkAlignment).Left, items: items = [], display: display = 'inline', size: size = (0, $j9rqA.SmartLinkSize).Medium, maxLines: maxLines = (0, $h9b8V.METADATA_BLOCK_CONSTANTS).DEFAULT_MAX_LINES })=>{
    const elements = (0, $ddON5.renderElementItems)(items, display);
    return elements && /*#__PURE__*/ $fc4bM.createElement((0, $2UGy7.default), {
        align: align,
        direction: (0, $j9rqA.SmartLinkDirection).Horizontal,
        width: (0, $j9rqA.SmartLinkWidth).Flexible,
        size: size,
        className: (0, $2R2iS.default)([
            $2ea54971359e0054$var$truncateStyles[maxLines],
            $2ea54971359e0054$var$sizeStyles[size]
        ])
    }, elements);
};
const $2ea54971359e0054$export$2e4ce4ce734f69e1 = ({ maxLines: maxLines = (0, $h9b8V.METADATA_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, testId: testId = 'smart-block-metadata', primary: primary = [], secondary: secondary = [], ...blockProps })=>{
    var _cardContext$ui;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    if (primary.length === 0 && secondary.length === 0 || (cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $j9rqA.SmartLinkStatus).Resolved) return null;
    const size = (blockProps === null || blockProps === void 0 ? void 0 : blockProps.size) ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size) ?? (0, $j9rqA.SmartLinkSize).Medium;
    const maxLinesTotal = $2ea54971359e0054$var$getMaxLines(maxLines);
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...blockProps,
        size: size,
        testId: `${testId}-resolved-view`
    }, /*#__PURE__*/ $fc4bM.createElement($2ea54971359e0054$var$ElementItemRenderer, {
        items: primary,
        size: size,
        maxLines: maxLinesTotal
    }), /*#__PURE__*/ $fc4bM.createElement($2ea54971359e0054$var$ElementItemRenderer, {
        align: (0, $j9rqA.SmartLinkAlignment).Right,
        items: secondary,
        size: size,
        maxLines: maxLinesTotal
    }));
};

});
parcelRegister("h9b8V", function(module, exports) {
$parcel$export(module.exports, "METADATA_BLOCK_CONSTANTS", () => $7a3c4ecb1fd46475$export$13bf823ad4713393);
const $7a3c4ecb1fd46475$export$13bf823ad4713393 = {
    DEFAULT_MAX_LINES: 2,
    MAXIMUM_MAX_LINES: 2,
    MINIMUM_MAX_LINES: 1
};

});



parcelRegister("8DLmm", function(module, exports) {
$parcel$export(module.exports, "default", () => $da1047e291cd9a3f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $6OQbK = parcelRequire("6OQbK");
var $da1047e291cd9a3f$export$2e2bcd8739ae039 = (0, $6OQbK.PreviewBlock);

});
parcelRegister("6OQbK", function(module, exports) {
$parcel$export(module.exports, "PreviewBlock", () => $c25101c9ad6f0287$export$fff1c9c894fd3e9c);

var $fc4bM = parcelRequire("fc4bM");

var $5QRjl = parcelRequire("5QRjl");

var $1KCWZ = parcelRequire("1KCWZ");
const $c25101c9ad6f0287$export$fff1c9c894fd3e9c = ({ testId: testId = 'smart-block-preview', overrideUrl: overrideUrl, ...blockProps })=>{
    const ui = (0, $5QRjl.useFlexibleUiOptionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1KCWZ.default), {
        ...blockProps,
        size: blockProps.size ?? (ui === null || ui === void 0 ? void 0 : ui.size),
        testId: testId,
        overrideUrl: overrideUrl
    });
};

});
parcelRegister("1KCWZ", function(module, exports) {
$parcel$export(module.exports, "default", () => $5d2e1aa464dc1659$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $7L0w2 = parcelRequire("7L0w2");

var $gndj3 = parcelRequire("gndj3");
const $5d2e1aa464dc1659$var$previewBlockStyleCommon = null;
const $5d2e1aa464dc1659$var$ignoreContainerPaddingStyle = null;
/**
 * Represents a resolved PreviewBlock, which typically contains media or other large format content.
 * @public
 * @param {PreviewBlock} PreviewBlock
 * @see Block
 */ const $5d2e1aa464dc1659$var$PreviewBlockResolvedView = ({ ignoreContainerPadding: ignoreContainerPadding = false, onError: onError, placement: placement, testId: testId, overrideUrl: overrideUrl, style: style, className: className, ...blockProps })=>{
    const [dynamicStyles, setDynamicStyles] = (0, $fc4bM.useState)(style ?? {});
    const updateStyles = (0, $fc4bM.useCallback)(()=>{
        if (placement === (0, $j9rqA.MediaPlacement).Left || placement === (0, $j9rqA.MediaPlacement).Right) {
            const containerPadding = ignoreContainerPadding ? '0px' : 'var(--container-padding)';
            const newStyle = {
                ...style,
                position: 'absolute',
                top: containerPadding,
                bottom: containerPadding,
                width: `calc(var(--preview-block-width) - ${containerPadding})`,
                ...placement === (0, $j9rqA.MediaPlacement).Left ? {
                    left: containerPadding
                } : {},
                ...placement === (0, $j9rqA.MediaPlacement).Right ? {
                    right: containerPadding
                } : {}
            };
            setDynamicStyles(newStyle);
        } else if (ignoreContainerPadding) setDynamicStyles({
            ...style
        });
    }, [
        ignoreContainerPadding,
        placement,
        style
    ]);
    // Should be useLayoutEffect to avoid flicker.
    // Styles should be set before paint.
    (0, $fc4bM.useLayoutEffect)(()=>{
        updateStyles();
    }, [
        ignoreContainerPadding,
        placement,
        updateStyles,
        className
    ]);
    const handleOnLoad = (0, $fc4bM.useCallback)(()=>{
        updateStyles();
    }, [
        updateStyles
    ]);
    const handleOnError = (0, $fc4bM.useCallback)(()=>{
        if (onError) onError();
    }, [
        onError
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...blockProps,
        testId: `${testId}-resolved-view`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            placement && "_1t26n7od _ze72n7od _10aa1osq _rjuj1osq _mr051dfr",
            !placement && ignoreContainerPadding && "_18u01ivi _2hwxc10g _e0oi1ya9 _dmhj1ya9",
            className
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $7L0w2.default), {
        onError: handleOnError,
        onLoad: handleOnLoad,
        overrideUrl: overrideUrl
    }));
};
var $5d2e1aa464dc1659$export$2e2bcd8739ae039 = $5d2e1aa464dc1659$var$PreviewBlockResolvedView;

});



parcelRegister("PBikU", function(module, exports) {
$parcel$export(module.exports, "default", () => $91389697cb4ba794$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/deprecations/deprecation-ticket-required -- VOLTC-139 tracks removal of these deprecated re-export shims. */ 
var $h7QOk = parcelRequire("h7QOk");
var $91389697cb4ba794$export$2e2bcd8739ae039 = (0, $h7QOk.SnippetBlock);

});
parcelRegister("h7QOk", function(module, exports) {
$parcel$export(module.exports, "SnippetBlock", () => $52a254717d435ca0$export$ababd1478ac17bc0);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $dweer = parcelRequire("dweer");

var $5QRjl = parcelRequire("5QRjl");

var $eANHk = parcelRequire("eANHk");

var $e1ITO = parcelRequire("e1ITO");

var $gjAHJ = parcelRequire("gjAHJ");

var $gndj3 = parcelRequire("gndj3");

var $h4iCs = parcelRequire("h4iCs");
const $52a254717d435ca0$export$ababd1478ac17bc0 = ({ maxLines: maxLines = (0, $h4iCs.SNIPPET_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, testId: testId = 'smart-block-snippet', text: text, isHidden: isHidden = false, showFooter: showFooter = true, ...blockProps })=>{
    var _useFlexibleUiOptionC, _cardContext$ui2, _context$meta, _context$meta2, _context$meta3;
    const context = (0, $dweer.useFlexibleUiContext)();
    const renderers = (0, $eANHk.useSmartLinkRenderers)();
    const enableSnippetRenderer = (_useFlexibleUiOptionC = (0, $5QRjl.useFlexibleUiOptionContext)()) === null || _useFlexibleUiOptionC === void 0 ? void 0 : _useFlexibleUiOptionC.enableSnippetRenderer;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $j9rqA.SmartLinkStatus).Resolved && !text) return null;
    const snippetMaxLines = (0, $gjAHJ.getMaxLines)(maxLines, (0, $h4iCs.SNIPPET_BLOCK_CONSTANTS).DEFAULT_MAX_LINES, (0, $h4iCs.SNIPPET_BLOCK_CONSTANTS).MAXIMUM_MAX_LINES, (0, $h4iCs.SNIPPET_BLOCK_CONSTANTS).MINIMUM_MAX_LINES);
    const statusTestId = !text ? 'resolved' : 'non-resolved';
    const snippet = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $e1ITO.default), {
        maxLines: snippetMaxLines,
        content: text
    });
    if (!enableSnippetRenderer) {
        var _cardContext$ui;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gndj3.default), {
            ...blockProps,
            size: blockProps.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
            testId: `${testId}-${statusTestId}-view`
        }, snippet);
    }
    const SnippetReplacement = renderers === null || renderers === void 0 ? void 0 : renderers.snippet;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gndj3.default), {
        ...blockProps,
        size: blockProps.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui2 = cardContext.ui) === null || _cardContext$ui2 === void 0 ? void 0 : _cardContext$ui2.size),
        testId: `${testId}-${statusTestId}-view`
    }, SnippetReplacement ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(SnippetReplacement, {
        fallbackText: (text || (context === null || context === void 0 ? void 0 : context.snippet)) ?? '',
        fallbackComponent: snippet,
        contentId: (context === null || context === void 0 || (_context$meta = context.meta) === null || _context$meta === void 0 ? void 0 : _context$meta.objectId) ?? '',
        contentType: (context === null || context === void 0 || (_context$meta2 = context.meta) === null || _context$meta2 === void 0 ? void 0 : _context$meta2.resourceType) ?? '',
        cloudId: (context === null || context === void 0 || (_context$meta3 = context.meta) === null || _context$meta3 === void 0 ? void 0 : _context$meta3.tenantId) ?? '',
        maxLines: snippetMaxLines,
        isHidden: isHidden,
        showFooter: showFooter
    }) : snippet);
};

});
parcelRegister("gjAHJ", function(module, exports) {
$parcel$export(module.exports, "getMaxLines", () => $c6919cba34e210fe$export$c2293adf1794c09);
const $c6919cba34e210fe$export$c2293adf1794c09 = (value, defaultValue, max, min)=>{
    if (value > max) return defaultValue;
    if (value < min) return min;
    return value;
};

});

parcelRegister("h4iCs", function(module, exports) {
$parcel$export(module.exports, "SNIPPET_BLOCK_CONSTANTS", () => $15d4dbb9fa4cdd33$export$ca3749285a470843);
const $15d4dbb9fa4cdd33$export$ca3749285a470843 = {
    DEFAULT_MAX_LINES: 3,
    MAXIMUM_MAX_LINES: 6,
    MINIMUM_MAX_LINES: 1
};

});




parcelRegister("bfu8W", function(module, exports) {
$parcel$export(module.exports, "getChildrenOptions", () => $c9fbf0a0c8c97a3c$export$6f4e0540a2f2295a);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $lHmlC = parcelRequire("lHmlC");

var $ceElf = parcelRequire("ceElf");
const $c9fbf0a0c8c97a3c$export$6f4e0540a2f2295a = (children, context)=>{
    let options = {};
    if ((0, $lHmlC.isFlexUiPreviewPresent)(context)) (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(children, (child)=>{
        if (/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) {
            if ((0, $ceElf.isFlexibleUiPreviewBlock)(child)) {
                const { placement: placement } = child.props;
                if (placement === (0, $j9rqA.MediaPlacement).Left) options.previewOnLeft = true;
                if (placement === (0, $j9rqA.MediaPlacement).Right) options.previewOnRight = true;
            }
        }
    });
    return options;
};

});
parcelRegister("lHmlC", function(module, exports) {
$parcel$export(module.exports, "isFlexUiPreviewPresent", () => $946280e9d3d365ce$export$783c1bf8fee63f80);
const $946280e9d3d365ce$export$783c1bf8fee63f80 = (context)=>Boolean(context && context.preview);

});

parcelRegister("ceElf", function(module, exports) {
$parcel$export(module.exports, "isFlexibleUiPreviewBlock", () => $232e896c492be60e$export$c0547b4405cae584);

var $fc4bM = parcelRequire("fc4bM");

var $8DLmm = parcelRequire("8DLmm");

var $8AeTQ = parcelRequire("8AeTQ");
const $232e896c492be60e$export$c0547b4405cae584 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node)) return false;
    if (node.type === (0, $8DLmm.default)) return true;
    if ((0, $8AeTQ.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid = true;
        (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(child)) {
                isChildrenValid = false;
                return;
            }
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $232e896c492be60e$export$c0547b4405cae584(child);
        });
        return isChildrenValid;
    }
    return false;
};

});


parcelRegister("3vVf0", function(module, exports) {
$parcel$export(module.exports, "getFlexibleUiBlock", () => $feb6ed2bc6c452ca$export$f6c7a950371733c8);
/* eslint-disable @atlaskit/design-system/consistent-css-prop-usage */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-values */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $fc4bM = parcelRequire("fc4bM");

var $8AeTQ = parcelRequire("8AeTQ");

var $htqFW = parcelRequire("htqFW");
const $feb6ed2bc6c452ca$export$f6c7a950371733c8 = (node)=>{
    if (!/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).isValidElement(node)) return undefined;
    if (node.type === (0, $htqFW.default)) return node;
    if ((0, $8AeTQ.isStyleCacheProvider)(node)) {
        // Component wrapped with compiled at runtime, check for children
        let isChildrenValid;
        (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Children.map(node.props.children, (child)=>{
            var _child$type;
            if (typeof child.type !== 'string' && ((_child$type = child.type) === null || _child$type === void 0 ? void 0 : _child$type.name) !== 'Style') isChildrenValid = $feb6ed2bc6c452ca$export$f6c7a950371733c8(child);
        });
        return isChildrenValid;
    }
    return undefined;
};

});

parcelRegister("le6AR", function(module, exports) {
$parcel$export(module.exports, "default", () => $c9e5abe6b207b666$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $9VWR7 = parcelRequire("9VWR7");

var $jjsJ4 = parcelRequire("jjsJ4");
const $c9e5abe6b207b666$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY = 100;
const $c9e5abe6b207b666$var$HoverCardControl = ({ children: children, isHoverPreview: isHoverPreview, isAuthTooltip: isAuthTooltip, actionOptions: actionOptions, testId: testId, url: url, delay: delay = $c9e5abe6b207b666$var$FLEXIBLE_HOVER_CARD_CAN_OPEN_DELAY, hoverPreviewOptions: hoverPreviewOptions })=>{
    const [canOpen, setCanOpen] = (0, $fc4bM.useState)(true);
    const mouseStopTimer = (0, $fc4bM.useRef)();
    (0, $fc4bM.useEffect)(()=>{
        return ()=>{
            if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        };
    }, []);
    const onMouseLeave = (0, $fc4bM.useCallback)(()=>{
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
    }, []);
    const onMouseMove = (0, $fc4bM.useCallback)((e)=>{
        var _e$target$closest;
        if (mouseStopTimer.current) clearTimeout(mouseStopTimer.current);
        // Never show hover card on action or when action dropdown opens.
        // The code below can be simplified by using :is() and :has()
        // but the pseudo-class isn't support by Firefox yet.
        const action = // Any action button group (title/footer block)
        e.target.closest('.actions-button-group') || ((_e$target$closest = e.target.closest('[data-smart-link-container]')) === null || _e$target$closest === void 0 ? void 0 : _e$target$closest.querySelector('[data-action-open="true"]'));
        const canOpenOnElement = isAuthTooltip && !action || // EDM-7060: For hover preview, also hide hover card on all elements
        // except title element (link title)
        isHoverPreview && !action && !e.target.closest(`[data-smart-element]:not([data-smart-element="${(0, $j9rqA.ElementName).Title}"])`);
        mouseStopTimer.current = setTimeout(()=>{
            if (canOpen !== canOpenOnElement) setCanOpen(Boolean(canOpenOnElement));
        }, delay);
    }, [
        isAuthTooltip,
        isHoverPreview,
        canOpen,
        delay
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $jjsJ4.HoverCard), {
        allowEventPropagation: true,
        canOpen: canOpen,
        closeOnChildClick: true,
        actionOptions: actionOptions,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        onBlur: (0, $9VWR7.noop),
        onMouseLeave: onMouseLeave,
        onMouseMove: onMouseMove,
        "data-testid": `${testId}-hover-card-wrapper`,
        role: 'presentation'
    }, children));
};
var $c9e5abe6b207b666$export$2e2bcd8739ae039 = $c9e5abe6b207b666$var$HoverCardControl;

});
parcelRegister("9VWR7", function(module, exports) {
$parcel$export(module.exports, "noop", () => $469a1a46f7555ab8$export$8793edee2d425525);
const $469a1a46f7555ab8$export$8793edee2d425525 = ()=>undefined;

});

parcelRegister("jjsJ4", function(module, exports) {
$parcel$export(module.exports, "HoverCard", () => $68729290226a60f9$export$57a077cc9fbe653e);

var $fc4bM = parcelRequire("fc4bM");

var $1VpRA = parcelRequire("1VpRA");

var $azARG = parcelRequire("azARG");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $gvrpl = parcelRequire("gvrpl");

var $k7o0P = parcelRequire("k7o0P");

var $8K8sp = parcelRequire("8K8sp");

var $cXmqe = parcelRequire("cXmqe");

var $5Vq8E = parcelRequire("5Vq8E");
const $68729290226a60f9$var$HoverCardWithErrorBoundary = (props)=>{
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const { url: url, id: id, children: children } = props;
    const analyticsContext = (0, $cXmqe.useSmartLinkAnalyticsContext)({
        display: (0, $j9rqA.CardDisplay).HoverCardPreview,
        id: id,
        source: (0, $5Vq8E.HOVER_CARD_SOURCE),
        url: url
    });
    const onError = (0, $fc4bM.useCallback)((error, info)=>{
        (0, $k7o0P.startUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $gvrpl.failUfoExperience)('smart-link-rendered', id || 'NULL');
        (0, $gvrpl.failUfoExperience)('smart-link-authenticated', id || 'NULL');
        fireEvent('ui.smartLink.renderFailed', {
            ...analyticsContext === null || analyticsContext === void 0 ? void 0 : analyticsContext.attributes,
            display: (0, $j9rqA.CardDisplay).HoverCardPreview,
            id: id ?? null,
            error: error,
            errorInfo: info
        });
    }, [
        analyticsContext,
        id,
        fireEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1VpRA.ErrorBoundary), {
        fallback: children,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8K8sp.SmartLinkModalProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5Vq8E.HoverCardComponent), props, children)));
};
const $68729290226a60f9$var$HoverCardWithoutAnalyticsContext = (0, $azARG.default)()($68729290226a60f9$var$HoverCardWithErrorBoundary);
const $68729290226a60f9$export$57a077cc9fbe653e = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($68729290226a60f9$var$HoverCardWithoutAnalyticsContext, props);
};

});
parcelRegister("5Vq8E", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_SOURCE", () => $2dd97ff49a59163a$export$421dbc3834daf261);
$parcel$export(module.exports, "HoverCardComponent", () => $2dd97ff49a59163a$export$e2173dafa6a751bb);

var $fc4bM = parcelRequire("fc4bM");

var $bKWnN = parcelRequire("bKWnN");

var $dRkX9 = parcelRequire("dRkX9");

var $4EPUx = parcelRequire("4EPUx");

var $j9rqA = parcelRequire("j9rqA");

var $lBTn5 = parcelRequire("lBTn5");

var $5tDJ2 = parcelRequire("5tDJ2");

var $eANHk = parcelRequire("eANHk");

var $fzYCU = parcelRequire("fzYCU");

var $baiO5 = parcelRequire("baiO5");

var $9VWR7 = parcelRequire("9VWR7");

var $c00sc = parcelRequire("c00sc");

var $eHCJ9 = parcelRequire("eHCJ9");

var $8CWF9 = parcelRequire("8CWF9");
const $2dd97ff49a59163a$export$421dbc3834daf261 = 'smartLinkPreviewHoverCard';
const $2dd97ff49a59163a$var$HOVER_CARD_TRIGGER_WRAPPER = 'hover-card-trigger-wrapper';
const $2dd97ff49a59163a$var$FADE_IN_DELAY = 500;
const $2dd97ff49a59163a$var$FADE_OUT_DELAY = 300;
const $2dd97ff49a59163a$var$RESOLVE_DELAY = 100;
const $2dd97ff49a59163a$export$e2173dafa6a751bb = ({ children: children, url: url, id: id = '', canOpen: canOpen = true, closeOnChildClick: closeOnChildClick = false, actionOptions: actionOptions, allowEventPropagation: allowEventPropagation = false, zIndex: zIndex = (0, $eHCJ9.HOVER_CARD_Z_INDEX), noFadeDelay: noFadeDelay = false, hoverPreviewOptions: hoverPreviewOptions, placement: placement, role: role, shouldRenderToParent: shouldRenderToParent = false, label: label, titleId: titleId, onVisibilityChange: onVisibilityChange })=>{
    const fadeInDelay = (hoverPreviewOptions === null || hoverPreviewOptions === void 0 ? void 0 : hoverPreviewOptions.fadeInDelay) ?? $2dd97ff49a59163a$var$FADE_IN_DELAY;
    const gatedPlacement = placement && (0, $bKWnN.UNSAFE_expValNoExposure)('confluence_1p_and_3p_connection_byline_experiment', 'isEnabled', false) ? placement : undefined;
    const [isOpen, setIsOpen] = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useState(false);
    const fadeOutTimeoutId = (0, $fc4bM.useRef)();
    const fadeInTimeoutId = (0, $fc4bM.useRef)();
    const resolveTimeOutId = (0, $fc4bM.useRef)();
    const mousePos = (0, $fc4bM.useRef)();
    const popupOffset = (0, $fc4bM.useRef)();
    const parentSpan = (0, $fc4bM.useRef)(null);
    const renderers = (0, $eANHk.useSmartLinkRenderers)();
    const linkState = (0, $fzYCU.useSmartCardState)(url);
    const handleSetIsOpen = (0, $fc4bM.useCallback)((isOpen)=>{
        setIsOpen(isOpen);
        onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(isOpen);
    }, [
        onVisibilityChange
    ]);
    const { loadMetadata: loadMetadata, register: register } = (0, $lBTn5.useSmartCardActions)(id, url);
    const setMousePosition = (0, $fc4bM.useCallback)((event)=>{
        if (isOpen && canOpen) return;
        mousePos.current = {
            x: event.clientX,
            y: event.clientY
        };
        // A caller-chosen placement anchors the card to the trigger, so a cursor-relative offset
        // would drag it back over the element the placement was picked to keep clear of.
        if (gatedPlacement) return;
        //If these are undefined then popupOffset is undefined and we fallback to default bottom-start placement
        if ((!isOpen || !canOpen) && parentSpan.current && mousePos.current) {
            const { bottom: bottom, left: left } = parentSpan.current.getBoundingClientRect();
            popupOffset.current = [
                mousePos.current.x - left + (0, $eHCJ9.CARD_GAP_PX),
                mousePos.current.y - bottom + (0, $eHCJ9.CARD_GAP_PX)
            ];
        }
    }, [
        canOpen,
        isOpen,
        gatedPlacement
    ]);
    const hideCard = (0, $fc4bM.useCallback)(()=>{
        if (handleSetIsOpen) handleSetIsOpen(false);
        else setIsOpen(false);
    }, [
        handleSetIsOpen
    ]);
    const initHideCard = (0, $fc4bM.useCallback)(()=>{
        if (fadeInTimeoutId.current) {
            clearTimeout(fadeInTimeoutId.current);
            // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress fade in event
            fadeInTimeoutId.current = undefined;
        }
        if (resolveTimeOutId.current) {
            clearTimeout(resolveTimeOutId.current);
            // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
            // we want to clear out the reference to signify that there's no in-progress resolve event
            resolveTimeOutId.current = undefined;
        }
        if (noFadeDelay) hideCard();
        else fadeOutTimeoutId.current = setTimeout(()=>hideCard(), $2dd97ff49a59163a$var$FADE_OUT_DELAY);
    }, [
        hideCard,
        noFadeDelay
    ]);
    // clearing out the timeouts in order to avoid memory leaks
    // in case the component unmounts before they execute
    (0, $fc4bM.useEffect)(()=>()=>{
            if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
            if (fadeInTimeoutId.current) {
                clearTimeout(fadeInTimeoutId.current);
                // because fadeInTimeoutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress fade in event
                fadeInTimeoutId.current = undefined;
            }
            if (resolveTimeOutId.current) {
                clearTimeout(resolveTimeOutId.current);
                // because resolveTimeOutId.current is set by mouseOver which triggers multiple times in a hover,
                // we want to clear out the reference to signify that there's no in-progress resolve event
                resolveTimeOutId.current = undefined;
            }
        }, []);
    // we want to initiate resolve a bit earlier for standalone cards
    // to minimize the loading state
    const initResolve = (0, $fc4bM.useCallback)(()=>{
        // this check covers both non-SSR (status) & SSR case (metadataStatus)
        const isLinkUnresolved = linkState.status === 'pending' || !linkState.metadataStatus || linkState.status === 'resolved' && linkState.metadataStatus === 'pending' && (0, $dRkX9.fg)('platform_smartlink_inline_resolve_optimization');
        if (!resolveTimeOutId.current && isLinkUnresolved) resolveTimeOutId.current = setTimeout(()=>{
            if (linkState.status === 'pending') // Link hasn't been registered yet. Register and resolve link.
            register();
            else // Link has been already been partially resolved. Load metadata.
            loadMetadata();
        }, $2dd97ff49a59163a$var$RESOLVE_DELAY);
    }, [
        linkState.metadataStatus,
        linkState.status,
        loadMetadata,
        register
    ]);
    const initShowCard = (0, $fc4bM.useCallback)((event)=>{
        // Popup events bubble through the enclosing Smart Link, including portals.
        // A second top-layer popup can light-dismiss the spotlight before its click runs.
        if ((0, $dRkX9.fg)('platform_sl_one_click_chat_spotlight_v2_fg') && (0, $5tDJ2.isSpotlightActive)()) {
            initHideCard();
            hideCard();
            return;
        }
        // clearing out fadeOutTimeoutId in case it's already counting down to hide the card
        if (fadeOutTimeoutId.current) clearTimeout(fadeOutTimeoutId.current);
        // starting to resolve the hover card if the store doesn't have data about the link yet
        initResolve();
        //Set mouse position in the case it's not already set by onMouseMove, as in the case of scrolling
        setMousePosition(event);
        if (!isOpen && !fadeInTimeoutId.current) {
            // setting a timeout to show a Hover Card after delay runs out
            if (noFadeDelay) {
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            } else fadeInTimeoutId.current = setTimeout(()=>{
                // The spotlight may mount while this hover delay is pending.
                if ((0, $dRkX9.fg)('platform_sl_one_click_chat_spotlight_v2_fg') && (0, $5tDJ2.isSpotlightActive)()) {
                    fadeInTimeoutId.current = undefined;
                    return;
                }
                if (handleSetIsOpen) handleSetIsOpen(true);
                else setIsOpen(true);
            }, fadeInDelay);
        }
    }, [
        initResolve,
        isOpen,
        setMousePosition,
        noFadeDelay,
        fadeInDelay,
        handleSetIsOpen,
        initHideCard,
        hideCard
    ]);
    const onActionClick = (0, $fc4bM.useCallback)((actionId)=>{
        if (actionId === (0, $j9rqA.ActionName).PreviewAction || actionId === (0, $j9rqA.ActionName).AutomationAction) hideCard();
    }, [
        hideCard
    ]);
    // Stop hover preview content to propagate event to parent.
    const handleChildClick = (0, $fc4bM.useCallback)((e, closeOnClick)=>{
        if (!allowEventPropagation) e.stopPropagation();
        if (closeOnClick) hideCard();
    }, [
        allowEventPropagation,
        hideCard
    ]);
    const onContextMenuClick = (0, $fc4bM.useCallback)((e)=>handleChildClick(e, true), [
        handleChildClick
    ]);
    const onChildClick = (0, $fc4bM.useCallback)((e)=>handleChildClick(e, closeOnChildClick), [
        closeOnChildClick,
        handleChildClick
    ]);
    const content = (0, $fc4bM.useCallback)(({ update: update })=>{
        const hoverCardContentProps = {
            onMouseEnter: initShowCard,
            onMouseLeave: initHideCard,
            cardState: linkState,
            onActionClick: onActionClick,
            onDismiss: hideCard,
            onResolve: update,
            renderers: renderers,
            actionOptions: actionOptions,
            url: url,
            id: id,
            hoverPreviewOptions: hoverPreviewOptions
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $baiO5.SmartLinkAnalyticsContext), {
            url: url,
            display: (0, $j9rqA.CardDisplay).HoverCardPreview,
            id: id,
            source: $2dd97ff49a59163a$export$421dbc3834daf261
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $c00sc.default), hoverCardContentProps));
    }, [
        initShowCard,
        initHideCard,
        linkState,
        onActionClick,
        hideCard,
        renderers,
        actionOptions,
        url,
        id,
        hoverPreviewOptions
    ]);
    const handleKeyDown = (0, $fc4bM.useCallback)((e)=>{
        if (e.key === ' ') {
            e.preventDefault();
            initShowCard(e);
        }
    }, [
        initShowCard
    ]);
    const trigger = (0, $fc4bM.useCallback)(({ 'aria-haspopup': _ariaHasPopup, 'aria-expanded': _ariaExpanded, // `aria-controls` is also stripped because the trigger wrapper renders
    // with `role="none"`. axe's `aria-valid-attr-value` rule flags any
    // `aria-controls` value sitting on a presentational element, since the
    // element has no semantic role to control. Removing the attribute
    // keeps the trigger semantically inert without losing functionality.
    'aria-controls': _ariaControls, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
            ref: parentSpan
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
            ...triggerProps,
            onMouseOver: initShowCard,
            onMouseLeave: initHideCard,
            onMouseMove: setMousePosition,
            onKeyDown: handleKeyDown,
            onClick: onChildClick,
            onContextMenu: onContextMenuClick,
            "data-testid": $2dd97ff49a59163a$var$HOVER_CARD_TRIGGER_WRAPPER,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: $2dd97ff49a59163a$var$HOVER_CARD_TRIGGER_WRAPPER,
            onFocus: (0, $9VWR7.noop),
            onBlur: (0, $9VWR7.noop),
            role: "none"
        }, children)), [
        children,
        initHideCard,
        initShowCard,
        onChildClick,
        onContextMenuClick,
        setMousePosition,
        handleKeyDown
    ]);
    const popupComponent = (0, $fc4bM.useMemo)(// Within the Popup component, if shouldRenderToParent, the zIndex prop is ignored
    // as it is assumed that the custom popup container has the desired styles
    ()=>(0, $8CWF9.createCustomPopupContainer)(shouldRenderToParent ? zIndex : undefined), [
        zIndex,
        shouldRenderToParent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4EPUx.Popup), {
        testId: "hover-card",
        isOpen: isOpen && canOpen,
        onClose: initHideCard,
        placement: gatedPlacement ?? 'bottom-start',
        // A trigger-anchored card keeps the same gap the cursor-anchored one leaves.
        offset: gatedPlacement ? [
            0,
            (0, $eHCJ9.CARD_GAP_PX)
        ] : popupOffset.current,
        autoFocus: false,
        content: content,
        trigger: trigger,
        zIndex: zIndex,
        role: role,
        titleId: titleId,
        label: label,
        shouldRenderToParent: shouldRenderToParent,
        popupComponent: popupComponent
    });
};

});
parcelRegister("5tDJ2", function(module, exports) {
$parcel$export(module.exports, "getSuppressionStore", () => $e9efc27dfca51d80$export$b7f6300f47ea9879);
$parcel$export(module.exports, "claimSpotlight", () => $e9efc27dfca51d80$export$3d9b03f5435b5d3b);
$parcel$export(module.exports, "releaseSpotlight", () => $e9efc27dfca51d80$export$3c330b89b4731e96);
$parcel$export(module.exports, "isSpotlightActive", () => $e9efc27dfca51d80$export$e96d0e85290a3727);

var $bhV4A = parcelRequire("bhV4A");

var $kjJS9 = parcelRequire("kjJS9");
/** Shared across inline cards and accounts on this browser origin. */ let $e9efc27dfca51d80$var$store;
let $e9efc27dfca51d80$var$activeSpotlight;
const $e9efc27dfca51d80$var$isHistory = (value)=>{
    if (typeof value !== 'object' || value === null || !('impressions' in value)) return false;
    return Array.isArray(value.impressions) && value.impressions.every((timestamp)=>typeof timestamp === 'number' && Number.isFinite(timestamp)) && (!('dismissedAt' in value) || value.dismissedAt === undefined || typeof value.dismissedAt === 'number' && Number.isFinite(value.dismissedAt));
};
function $e9efc27dfca51d80$export$ef36f29e38816de4(storage, isAvailable = ()=>true) {
    let blocked = false;
    const read = ()=>{
        try {
            const value = storage.getItem('history');
            if (blocked || !isAvailable()) return undefined;
            return value === undefined ? {
                impressions: []
            } : $e9efc27dfca51d80$var$isHistory(value) ? value : undefined;
        } catch  {
            return undefined;
        }
    };
    const write = (history)=>{
        try {
            storage.setItemWithExpiry('history', history, (0, $kjJS9.SEVEN_DAYS_MS));
            // StorageClient can swallow write failures. Verify persistence before counting delivery.
            const persisted = isAvailable() && JSON.stringify(storage.getItem('history')) === JSON.stringify(history);
            blocked = !persisted;
            return persisted;
        } catch  {
            blocked = true;
            return false;
        }
    };
    return {
        read: read,
        impress: (now)=>{
            const history = read();
            return !!history && write({
                ...history,
                impressions: [
                    ...history.impressions.filter((timestamp)=>timestamp > now - (0, $kjJS9.SEVEN_DAYS_MS)),
                    now
                ]
            });
        },
        dismiss: (now)=>{
            const history = read();
            return !!history && write({
                ...history,
                dismissedAt: now
            });
        }
    };
}
function $e9efc27dfca51d80$export$b7f6300f47ea9879() {
    if (typeof window === 'undefined') return undefined;
    if (!$e9efc27dfca51d80$var$store) try {
        let available = true;
        const storage = new (0, $bhV4A.StorageClient)('one-click-chat-spotlight-v2', {
            handlers: {
                captureException: ()=>{
                    available = false;
                }
            }
        });
        $e9efc27dfca51d80$var$store = $e9efc27dfca51d80$export$ef36f29e38816de4(storage, ()=>available);
    } catch  {
        return undefined;
    }
    return $e9efc27dfca51d80$var$store;
}
function $e9efc27dfca51d80$export$3d9b03f5435b5d3b(owner) {
    if ($e9efc27dfca51d80$var$activeSpotlight && $e9efc27dfca51d80$var$activeSpotlight !== owner) return false;
    $e9efc27dfca51d80$var$activeSpotlight = owner;
    return true;
}
function $e9efc27dfca51d80$export$3c330b89b4731e96(owner) {
    if ($e9efc27dfca51d80$var$activeSpotlight === owner) $e9efc27dfca51d80$var$activeSpotlight = undefined;
}
function $e9efc27dfca51d80$export$e96d0e85290a3727(owner) {
    return $e9efc27dfca51d80$var$activeSpotlight !== undefined && $e9efc27dfca51d80$var$activeSpotlight !== owner;
}

});
parcelRegister("kjJS9", function(module, exports) {
$parcel$export(module.exports, "SEVEN_DAYS_MS", () => $53e91944b2f8d69c$export$2e4bc55597d730e0);
$parcel$export(module.exports, "evaluateOpportunity", () => $53e91944b2f8d69c$export$c93023cad6a196ea);
$parcel$export(module.exports, "evaluateExperiment", () => $53e91944b2f8d69c$export$8ac194ac22681b4f);
/** No link, content, or account identifiers belong in eligibility diagnostics. */ const $53e91944b2f8d69c$export$2e4bc55597d730e0 = 604800000;
const $53e91944b2f8d69c$var$result = (reason)=>({
        isEligible: reason === 'eligible',
        reason: reason
    });
function $53e91944b2f8d69c$export$c93023cad6a196ea(input) {
    if (!input.gateEnabled) return $53e91944b2f8d69c$var$result('gate_off');
    if (input.appearance !== 'inline' || input.status !== 'resolved') return $53e91944b2f8d69c$var$result('not_resolved_inline');
    if (input.provider !== 'google-object-provider' && input.provider !== 'github-object-provider') return $53e91944b2f8d69c$var$result('unsupported_provider');
    if (!input.authorized) return $53e91944b2f8d69c$var$result('provider_unauthorized');
    if (!input.hasAccess) return $53e91944b2f8d69c$var$result('object_inaccessible');
    if (!input.rovoAvailable) return $53e91944b2f8d69c$var$result('rovo_unavailable');
    if (!input.consumerOptedIn) return $53e91944b2f8d69c$var$result('consumer_not_opted_in');
    if (input.product !== 'jira_web' && input.product !== 'confluence_web') return $53e91944b2f8d69c$var$result('unsupported_product');
    if (!input.history) return $53e91944b2f8d69c$var$result('suppression_unavailable');
    if (input.spotlightActive) return $53e91944b2f8d69c$var$result('spotlight_active');
    const { dismissedAt: dismissedAt, impressions: impressions } = input.history;
    const cutoff = input.now - $53e91944b2f8d69c$export$2e4bc55597d730e0;
    if (dismissedAt !== undefined && dismissedAt > cutoff) return $53e91944b2f8d69c$var$result('dismissal_cooldown');
    const startOfDay = new Date(input.now);
    startOfDay.setHours(0, 0, 0, 0);
    if (impressions.some((timestamp)=>timestamp >= startOfDay.getTime())) return $53e91944b2f8d69c$var$result('shown_today');
    if (impressions.filter((timestamp)=>timestamp > cutoff).length >= 3) return $53e91944b2f8d69c$var$result('weekly_limit');
    return $53e91944b2f8d69c$var$result('eligible');
}
function $53e91944b2f8d69c$export$8ac194ac22681b4f(value) {
    return $53e91944b2f8d69c$var$result(value === true ? 'eligible' : value === false ? 'control' : 'experiment_unavailable');
}

});


parcelRegister("c00sc", function(module, exports) {
$parcel$export(module.exports, "hoverCardClassName", () => $3322f812a340099e$export$34883cbaea18402d);
$parcel$export(module.exports, "default", () => $3322f812a340099e$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $3TJLC = parcelRequire("3TJLC");

var $jEubQ = parcelRequire("jEubQ");

var $fnEFU = parcelRequire("fnEFU");

var $fzRvL = parcelRequire("fzRvL");

var $bHDho = parcelRequire("bHDho");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $jQwFa = parcelRequire("jQwFa");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $9pwnX = parcelRequire("9pwnX");

var $gysdQ = parcelRequire("gysdQ");

var $jpYbX = parcelRequire("jpYbX");

var $fzYCU = parcelRequire("fzYCU");

var $9VWuO = parcelRequire("9VWuO");

var $aNEya = parcelRequire("aNEya");

var $jqXyW = parcelRequire("jqXyW");

var $kTSf6 = parcelRequire("kTSf6");

var $8jRNm = parcelRequire("8jRNm");

var $eHCJ9 = parcelRequire("eHCJ9");

var $6pxZ4 = parcelRequire("6pxZ4");

var $dwMYM = parcelRequire("dwMYM");

var $6p49A = parcelRequire("6p49A");

var $gUgbH = parcelRequire("gUgbH");

var $cWM5n = parcelRequire("cWM5n");

var $1EYsK = parcelRequire("1EYsK");

var $sCfVT = parcelRequire("sCfVT");
const $3322f812a340099e$export$34883cbaea18402d = 'smart-links-hover-preview';
const $3322f812a340099e$var$useIsResolvedView = ({ cardState: cardState, hoverPreviewOptions: hoverPreviewOptions })=>{
    var _hoverPreviewOptions$;
    return !(hoverPreviewOptions !== null && hoverPreviewOptions !== void 0 && (_hoverPreviewOptions$ = hoverPreviewOptions.render) !== null && _hoverPreviewOptions$ !== void 0 && _hoverPreviewOptions$.call(hoverPreviewOptions)) && cardState.status === 'resolved';
};
const $3322f812a340099e$var$useServices = ({ url: url })=>{
    const linkState = (0, $fzYCU.useSmartCardState)(url);
    const services = (0, $9pwnX.getServices)(linkState.details);
    return services;
};
const $3322f812a340099e$var$useIsUnauthorisedView = ({ cardState: cardState, url: url, hoverPreviewOptions: hoverPreviewOptions })=>{
    var _hoverPreviewOptions$2;
    const services = $3322f812a340099e$var$useServices({
        url: url
    });
    return !(hoverPreviewOptions !== null && hoverPreviewOptions !== void 0 && (_hoverPreviewOptions$2 = hoverPreviewOptions.render) !== null && _hoverPreviewOptions$2 !== void 0 && _hoverPreviewOptions$2.call(hoverPreviewOptions)) && cardState.status === 'unauthorized' && Boolean(services === null || services === void 0 ? void 0 : services.length);
};
const $3322f812a340099e$var$useIsShowPreauthBetterHovercard = (props)=>{
    const { rovoOptions: rovoConfig } = (0, $gysdQ.default)();
    return Boolean($3322f812a340099e$var$useIsUnauthorisedView(props) && (rovoConfig === null || rovoConfig === void 0 ? void 0 : rovoConfig.isRovoEnabled) && (0, $aEmSo.expValEquals)('platform_sl_3p_preauth_better_hovercard', 'isEnabled', true));
};
const $3322f812a340099e$var$HoverCardContent = ({ id: id = '', cardState: cardState, onActionClick: onActionClick, onResolve: onResolve, renderers: renderers, url: url, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onDismiss: onDismiss, actionOptions: actionOptions, hoverPreviewOptions: hoverPreviewOptions })=>{
    var _cardState$details;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const extensionKey = (0, $fc4bM.useMemo)(()=>(0, $96gGh.getExtensionKey)(cardState.details), [
        cardState.details
    ]);
    const linkState = (0, $fzYCU.useSmartCardState)(url);
    const linkStatus = linkState.status ?? 'pending';
    const definitionId = (0, $fc4bM.useMemo)(()=>(0, $6ZxOX.getDefinitionId)(cardState.details), [
        cardState.details
    ]);
    const { isAdminHubAIEnabled: isAdminHubAIEnabled, product: product } = (0, $fnEFU.useSmartLinkContext)();
    const isAISummaryEnabled = (0, $jqXyW.getIsAISummaryEnabled)(isAdminHubAIEnabled, cardState.details);
    const services = (0, $9pwnX.getServices)(linkState.details);
    const appendCrossProductAnalyticsParams = (0, $jpYbX.useSmartLinkCrossProductUrlWrapper)({
        details: linkState.details
    });
    const statusRef = (0, $fc4bM.useRef)(linkStatus);
    const fireEventRef = (0, $fc4bM.useRef)(fireEvent);
    const definitionIdRef = (0, $fc4bM.useRef)(definitionId);
    (0, $fc4bM.useEffect)(()=>{
        /**
     * Must access object value via ref because its not stable
     * and it can trigger useEffect to re-run below
     */ if (statusRef.current !== linkStatus) statusRef.current = linkStatus;
        if (fireEventRef.current !== fireEvent) fireEventRef.current = fireEvent;
        if (definitionIdRef.current !== definitionId) definitionIdRef.current = definitionId;
    }, [
        linkStatus,
        fireEvent,
        definitionId
    ]);
    (0, $fc4bM.useEffect)(()=>{
        const previewDisplay = 'card';
        const previewInvokeMethod = 'mouse_hover';
        const cardOpenTime = Date.now();
        const fireEventCurrent = fireEventRef.current;
        fireEventCurrent('ui.hoverCard.viewed', {
            previewDisplay: previewDisplay,
            previewInvokeMethod: previewInvokeMethod,
            definitionId: definitionIdRef.current ?? null
        });
        return ()=>{
            const hoverTime = Date.now() - cardOpenTime;
            fireEventCurrent('ui.hoverCard.dismissed', {
                previewDisplay: previewDisplay,
                previewInvokeMethod: previewInvokeMethod,
                hoverTime: hoverTime,
                definitionId: definitionIdRef.current ?? null
            });
        };
    }, []);
    const getDestinationUrl = (0, $fc4bM.useCallback)(()=>{
        // FIXME: destinationUrl should be rendered in the DOM anchor href instead of derived at click time
        const preferredUrl = (0, $jQwFa.getClickUrl)(url, linkState.details) ?? url;
        return appendCrossProductAnalyticsParams(preferredUrl) ?? preferredUrl;
    }, [
        appendCrossProductAnalyticsParams,
        linkState.details,
        url
    ]);
    // Middle-click handler to trigger fire3PClickEvent on middle-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onAuxClick = (0, $fc4bM.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $8jRNm.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    // Right-click handler to trigger fire3PClickEvent on right-clicks.
    // Scope is limited to 3P click analytics to keep the experiment focused.
    const onContextMenu = (0, $fc4bM.useCallback)((event)=>{
        const destinationUrl = getDestinationUrl();
        (0, $8jRNm.updateAnchorHref)(event, destinationUrl);
    }, [
        getDestinationUrl
    ]);
    const onClick = (0, $fc4bM.useCallback)((event)=>{
        // Prevent the anchor's native navigation so we can open the destination URL
        // with cross-product analytics query parameters appended.
        // The cross-product params are client-only and cannot be rendered
        // server-side. Falls back to the original `url` prop if the event target is
        // not an anchor element.
        event.preventDefault();
        const { target: target } = (0, $aNEya.getAnchorAttributesFromEvent)(event);
        const destinationUrl = getDestinationUrl();
        (0, $8jRNm.updateAnchorHref)(event, destinationUrl);
        window.open(destinationUrl, target);
        const isModifierKeyPressed = (0, $kTSf6.isSpecialEvent)(event);
        fireEvent('ui.smartLink.clicked.titleGoToLink', {
            id: id,
            display: (0, $j9rqA.CardDisplay).HoverCardPreview,
            isModifierKeyPressed: isModifierKeyPressed,
            definitionId: definitionId ?? null
        });
        (0, $9VWuO.fireLinkClickedEvent)(createAnalyticsEvent)(event);
    }, [
        createAnalyticsEvent,
        getDestinationUrl,
        id,
        fireEvent,
        definitionId
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { subtitle: subtitle } = (0, $6pxZ4.getMetadata)(extensionKey, data);
    const titleMaxLines = subtitle && subtitle.length > 0 ? 1 : 2;
    const titleBlockProps = {
        maxLines: titleMaxLines,
        size: (0, $j9rqA.SmartLinkSize).Large,
        position: (0, $j9rqA.SmartLinkPosition).Center,
        subtitle: subtitle,
        anchorTarget: product === 'ATLAS' ? '_self' : undefined
    };
    const uiOptions = (0, $eHCJ9.flexibleUiOptions);
    uiOptions.enableSnippetRenderer = true;
    const flexibleCardProps = {
        appearance: (0, $j9rqA.CardDisplay).HoverCardPreview,
        cardState: cardState,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onResolve: onResolve,
        origin: 'smartLinkPreviewHoverCard',
        renderers: renderers,
        actionOptions: actionOptions,
        ui: uiOptions,
        url: url,
        children: null
    };
    const onClickStopPropagation = (0, $fc4bM.useCallback)((e)=>e.stopPropagation(), []);
    const useIsResolvedViewGated = (0, $bHDho.functionUnionWithCondition)(()=>(0, $dRkX9.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $3322f812a340099e$var$useIsResolvedView, ()=>undefined);
    const useIsUnauthorisedViewGated = (0, $bHDho.functionUnionWithCondition)(()=>(0, $dRkX9.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $3322f812a340099e$var$useIsUnauthorisedView, ()=>undefined);
    const useIsShowPreauthBetterHovercardGated = (0, $bHDho.functionUnionWithCondition)(()=>(0, $dRkX9.fg)('platform_sl_3p_preauth_better_hovercard_killswitch'), $3322f812a340099e$var$useIsShowPreauthBetterHovercard, ()=>undefined);
    const isResolved = useIsResolvedViewGated({
        cardState: cardState,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const isUnauthorised = useIsUnauthorisedViewGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    const showPreauthBetterHovercard = useIsShowPreauthBetterHovercardGated({
        cardState: cardState,
        url: url,
        hoverPreviewOptions: hoverPreviewOptions
    });
    if ((0, $dRkX9.fg)('platform_sl_3p_preauth_better_hovercard_killswitch')) {
        const cardView = ((_hoverPreviewOptions$3)=>{
            const overrideView = hoverPreviewOptions === null || hoverPreviewOptions === void 0 || (_hoverPreviewOptions$3 = hoverPreviewOptions.render) === null || _hoverPreviewOptions$3 === void 0 ? void 0 : _hoverPreviewOptions$3.call(hoverPreviewOptions);
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWM5n.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (isUnauthorised) {
                if (showPreauthBetterHovercard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $sCfVT.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    onDismiss: onDismiss,
                    url: url
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1EYsK.default), {
                    extensionKey: extensionKey,
                    id: id,
                    flexibleCardProps: flexibleCardProps,
                    url: url
                });
            }
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6p49A.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (isResolved) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gUgbH.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        })();
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dwMYM.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            widthAppearance: showPreauthBetterHovercard ? 'slim' : undefined,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    } else {
        const getCardView = (cardState)=>{
            var _hoverPreviewOptions$4;
            const overrideView = hoverPreviewOptions === null || hoverPreviewOptions === void 0 || (_hoverPreviewOptions$4 = hoverPreviewOptions.render) === null || _hoverPreviewOptions$4 === void 0 ? void 0 : _hoverPreviewOptions$4.call(hoverPreviewOptions);
            if (overrideView) return overrideView;
            if (cardState.status === 'errored') return null;
            if (cardState.status === 'resolving' || cardState.metadataStatus === 'pending') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $cWM5n.default), {
                flexibleCardProps: flexibleCardProps,
                titleBlockProps: titleBlockProps
            });
            if (cardState.status === 'unauthorized' && services !== null && services !== void 0 && services.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $1EYsK.default), {
                extensionKey: extensionKey,
                id: id,
                flexibleCardProps: flexibleCardProps,
                url: url
            });
            if (cardState.status === 'forbidden' || cardState.status === 'not_found') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6p49A.default), {
                flexibleCardProps: flexibleCardProps
            });
            if (cardState.status === 'resolved') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gUgbH.default), {
                cardState: cardState,
                extensionKey: extensionKey,
                flexibleCardProps: flexibleCardProps,
                isAISummaryEnabled: isAISummaryEnabled,
                onActionClick: onActionClick,
                titleBlockProps: titleBlockProps
            });
            return null;
        };
        const cardView = getCardView(cardState);
        return cardView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $dwMYM.default), {
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onClick: onClickStopPropagation,
            isAIEnabled: isAISummaryEnabled,
            url: url
        }, cardView) : null;
    }
};
const $3322f812a340099e$var$HoverCardContentWithViewVariant = (props)=>{
    const showPreauthBetterHovercard = $3322f812a340099e$var$useIsShowPreauthBetterHovercard(props);
    const data = (0, $fc4bM.useMemo)(()=>{
        let viewVariant = 'default';
        if (showPreauthBetterHovercard) viewVariant = 'rovo-unauthorised-view';
        return {
            attributes: {
                viewVariant: viewVariant
            }
        };
    }, [
        showPreauthBetterHovercard
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $3TJLC.default), {
        data: data
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement($3322f812a340099e$var$HoverCardContent, props));
};
const $3322f812a340099e$var$_default_1 = (0, $fzRvL.componentWithCondition)(()=>{
    return (0, $dRkX9.fg)('platform_sl_3p_preauth_better_hovercard_killswitch');
}, $3322f812a340099e$var$HoverCardContentWithViewVariant, $3322f812a340099e$var$HoverCardContent);
var $3322f812a340099e$export$2e2bcd8739ae039 = $3322f812a340099e$var$_default_1;

});
parcelRegister("bHDho", function(module, exports) {
$parcel$export(module.exports, "functionUnionWithCondition", () => $2194b9e1893042c9$export$c41c28c1d883fcd5);

var $7LU44 = parcelRequire("7LU44");
function $2194b9e1893042c9$export$c41c28c1d883fcd5(condition, functionTrue, functionFalse) {
    // @ts-expect-error TS2345: Argument of type '(...args: C) => R2' is not assignable to parameter of type '(...args: C) => R1'.
    return (0, $7LU44.functionWithCondition)(condition, functionTrue, functionFalse);
}

});

parcelRegister("jqXyW", function(module, exports) {
$parcel$export(module.exports, "getIsAISummaryEnabled", () => $170592e52a67fece$export$d439c74cb206ff29);
const $170592e52a67fece$export$d439c74cb206ff29 = (isAdminHubAIEnabled = false, response)=>{
    var _response$meta;
    return Boolean(isAdminHubAIEnabled && (response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.supportedFeature) === null || _response$meta === void 0 ? void 0 : _response$meta.includes('AISummary')));
};

});

parcelRegister("eHCJ9", function(module, exports) {
$parcel$export(module.exports, "HOVER_CARD_Z_INDEX", () => $fa3529eb9f2a1d93$export$8245b0eaabf3440c);
$parcel$export(module.exports, "flexibleUiOptions", () => $fa3529eb9f2a1d93$export$8e022b7269e8199a);
$parcel$export(module.exports, "CARD_WIDTH_REM", () => $fa3529eb9f2a1d93$export$a0a37c997fbcd678);
$parcel$export(module.exports, "CARD_GAP_PX", () => $fa3529eb9f2a1d93$export$e7cae8c75d768024);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-atlaskit-theme

var $2SWSA = parcelRequire("2SWSA");

var $j9rqA = parcelRequire("j9rqA");
const $fa3529eb9f2a1d93$export$8245b0eaabf3440c = (0, $2SWSA.layers).modal();
const $fa3529eb9f2a1d93$export$8e022b7269e8199a = {
    hideBackground: true,
    hideElevation: true,
    hideLegacyButton: true,
    removeBlockRestriction: true,
    size: (0, $j9rqA.SmartLinkSize).Medium,
    zIndex: $fa3529eb9f2a1d93$export$8245b0eaabf3440c + 1
};
const $fa3529eb9f2a1d93$export$a0a37c997fbcd678 = 24;
const $fa3529eb9f2a1d93$export$e7cae8c75d768024 = 10; // gap between mouse cursor and hover card

});

parcelRegister("6pxZ4", function(module, exports) {
$parcel$export(module.exports, "getMetadata", () => $080f3e572a733fa3$export$8548546c0aa631e6);

var $lOxou = parcelRequire("lOxou");

var $j9rqA = parcelRequire("j9rqA");

var $8FBNQ = parcelRequire("8FBNQ");
const $080f3e572a733fa3$var$getSimulatedBetterMetadata = (extensionKey, data)=>{
    var _data$Type;
    const types = data ? (0, $lOxou.extractType)(data) : undefined;
    const defaultMetadata = {
        primary: [
            (0, $j9rqA.ElementName).AuthorGroup,
            (0, $j9rqA.ElementName).ModifiedOn
        ]
    };
    switch(extensionKey){
        case 'bitbucket-object-provider':
        case 'native-bitbucket-object-provider':
            if (types !== null && types !== void 0 && types.includes('atlassian:SourceCodePullRequest')) return {
                primary: [
                    (0, $j9rqA.ElementName).AuthorGroup,
                    (0, $j9rqA.ElementName).ModifiedOn,
                    (0, $j9rqA.ElementName).SubscriberCount,
                    (0, $j9rqA.ElementName).State
                ],
                subtitle: [
                    (0, $j9rqA.ElementName).SourceBranch,
                    (0, $j9rqA.ElementName).TargetBranch
                ]
            };
            if (types !== null && types !== void 0 && types.includes('schema:DigitalDocument')) return {
                primary: [
                    (0, $j9rqA.ElementName).LatestCommit,
                    (0, $j9rqA.ElementName).CollaboratorGroup,
                    (0, $j9rqA.ElementName).ModifiedOn
                ]
            };
            return {
                primary: [
                    (0, $j9rqA.ElementName).AuthorGroup,
                    (0, $j9rqA.ElementName).ModifiedOn
                ]
            };
        case 'confluence-object-provider':
            const primaryAttribution = data && (0, $8FBNQ.extractOwnedBy)(data) ? (0, $j9rqA.ElementName).OwnedByGroup : (0, $j9rqA.ElementName).AuthorGroup;
            return {
                primary: [
                    primaryAttribution,
                    (0, $j9rqA.ElementName).ModifiedOn
                ],
                tertiary: [
                    (0, $j9rqA.ElementName).ReactCount,
                    (0, $j9rqA.ElementName).CommentCount,
                    (0, $j9rqA.ElementName).ViewCount
                ]
            };
        case 'jira-object-provider':
            const isJiraTask = (data === null || data === void 0 || (_data$Type = data['@type']) === null || _data$Type === void 0 ? void 0 : _data$Type.includes('atlassian:Task')) ?? false;
            return {
                ...defaultMetadata,
                ...isJiraTask && {
                    primary: [
                        (0, $j9rqA.ElementName).AssignedToGroup,
                        (0, $j9rqA.ElementName).State,
                        (0, $j9rqA.ElementName).StoryPoints,
                        (0, $j9rqA.ElementName).Priority
                    ]
                }
            };
        case 'trello-object-provider':
            return {
                primary: [
                    (0, $j9rqA.ElementName).CollaboratorGroup,
                    (0, $j9rqA.ElementName).State,
                    (0, $j9rqA.ElementName).DueOn
                ],
                secondary: [
                    (0, $j9rqA.ElementName).ReactCount,
                    (0, $j9rqA.ElementName).CommentCount,
                    (0, $j9rqA.ElementName).AttachmentCount,
                    (0, $j9rqA.ElementName).ChecklistProgress
                ],
                subtitle: [
                    (0, $j9rqA.ElementName).Location
                ]
            };
        case 'watermelon-object-provider':
            if (types !== null && types !== void 0 && types.includes('atlassian:Project')) return {
                primary: [
                    (0, $j9rqA.ElementName).AuthorGroup,
                    (0, $j9rqA.ElementName).ModifiedOn,
                    (0, $j9rqA.ElementName).State,
                    (0, $j9rqA.ElementName).DueOn
                ]
            };
            return {
                primary: [
                    (0, $j9rqA.ElementName).AuthorGroup,
                    (0, $j9rqA.ElementName).State,
                    (0, $j9rqA.ElementName).DueOn
                ]
            };
        case 'slack-object-provider':
            return {
                primary: [
                    (0, $j9rqA.ElementName).AuthorGroup,
                    (0, $j9rqA.ElementName).SentOn
                ],
                tertiary: [
                    (0, $j9rqA.ElementName).ReactCount,
                    (0, $j9rqA.ElementName).CommentCount
                ]
            };
        case 'google-object-provider':
        case 'figma-object-provider':
            return {
                primary: [
                    (0, $j9rqA.ElementName).AuthorGroup,
                    (0, $j9rqA.ElementName).ModifiedOn
                ]
            };
        default:
            return defaultMetadata;
    }
};
const $080f3e572a733fa3$var$AvatarGroupsWithNamePrefix = [
    (0, $j9rqA.ElementName).AssignedToGroup,
    (0, $j9rqA.ElementName).OwnedByGroup,
    (0, $j9rqA.ElementName).AuthorGroup
];
const $080f3e572a733fa3$var$toElementItem = (name)=>{
    const showNamePrefix = $080f3e572a733fa3$var$AvatarGroupsWithNamePrefix.indexOf(name) !== -1 ? true : undefined;
    const testId = `${name.toLowerCase()}-metadata-element`;
    return {
        name: name,
        showNamePrefix: showNamePrefix,
        testId: testId
    };
};
const $080f3e572a733fa3$var$toElementItems = (elementNames)=>{
    if (!(elementNames !== null && elementNames !== void 0 && elementNames.length)) return;
    return elementNames.filter((name)=>name in (0, $j9rqA.ElementName)).map($080f3e572a733fa3$var$toElementItem);
};
const $080f3e572a733fa3$export$8548546c0aa631e6 = (extensionKey, data)=>{
    const metadata = $080f3e572a733fa3$var$getSimulatedBetterMetadata(extensionKey, data);
    const primary = [].concat(metadata.primary, metadata.tertiary);
    return {
        subtitle: $080f3e572a733fa3$var$toElementItems(metadata.subtitle),
        primary: $080f3e572a733fa3$var$toElementItems(primary),
        secondary: $080f3e572a733fa3$var$toElementItems(metadata.secondary)
    };
};

});
parcelRegister("8FBNQ", function(module, exports) {
$parcel$export(module.exports, "extractOwnedBy", () => $8cfe913a1155f8fe$export$75b4b5a156f48ff3);

var $1sniP = parcelRequire("1sniP");
const $8cfe913a1155f8fe$export$75b4b5a156f48ff3 = (data)=>{
    const persons = (0, $1sniP.extractPersonOwnedBy)(data);
    if (persons && persons.length) return persons[0].name;
};

});
parcelRegister("1sniP", function(module, exports) {
$parcel$export(module.exports, "extractPersonOwnedBy", () => $0e291ce1729d3c30$export$19ee667f3f7a6ec3);

var $lzLGl = parcelRequire("lzLGl");
const $0e291ce1729d3c30$export$19ee667f3f7a6ec3 = (jsonLd)=>{
    const ownedBy = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd['atlassian:ownedBy'];
    if (ownedBy) {
        if (Array.isArray(ownedBy)) return ownedBy.map((0, $lzLGl.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $lzLGl.extractPersonFromJsonLd)(ownedBy);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});
parcelRegister("lzLGl", function(module, exports) {
$parcel$export(module.exports, "extractPersonFromJsonLd", () => $21d087da9206922d$export$c471ae5fddcf1392);

var $6Hxqo = parcelRequire("6Hxqo");
const $21d087da9206922d$export$c471ae5fddcf1392 = (person)=>{
    if (typeof person === 'string') throw Error('Link.person needs to be an object.');
    else if (person['@type'] === 'Link') {
        if (person.name) return {
            name: person.name
        };
    } else {
        if (person.name) return {
            name: person.name,
            src: person.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(person.icon)
        };
    }
    return undefined;
};

});




parcelRegister("dwMYM", function(module, exports) {
$parcel$export(module.exports, "default", () => $014c569802bf74db$export$2e2bcd8739ae039);
/* ContentContainer.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $khHoI = parcelRequire("khHoI");

var $fkpcn = parcelRequire("fkpcn");

var $c00sc = parcelRequire("c00sc");
const $014c569802bf74db$var$HoverCardContainerStyle = null;
const $014c569802bf74db$var$hoverCardShellWidthDefault = null;
const $014c569802bf74db$var$hoverCardShellWidthSlim = null;
const $014c569802bf74db$var$hoverCardShellHideLoadingPlaceholder = null;
const $014c569802bf74db$var$popupContainerStyles = null;
const $014c569802bf74db$var$ConnectedAIPrismContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>{
    const { state: { status: status } } = (0, $khHoI.default)(url);
    const [showPrism, setShowPrism] = (0, $fc4bM.useState)(status === 'loading');
    (0, $fc4bM.useEffect)(()=>{
        setShowPrism(status === 'loading');
    }, [
        status
    ]);
    const resolvedWidthAppearance = widthAppearance ?? 'default';
    const container = /*#__PURE__*/ $fc4bM.createElement("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_11q7glyw _189eidpf _vchhusvi",
            resolvedWidthAppearance === 'slim' ? "_1bsbtye8" : "_1bsb1f23",
            "_9spsglyw",
            !isAIEnabled && "_2rko1mok _bfhk1bhr _16qs130s",
            (0, $c00sc.hoverCardClassName)
        ]),
        "data-testid": testId,
        ...props
    }, children);
    return isAIEnabled ? /*#__PURE__*/ $fc4bM.createElement((0, $fkpcn.default), {
        isVisible: showPrism,
        testId: `${testId}-prism`
    }, container) : container;
};
const $014c569802bf74db$var$ContentContainer = ({ children: children, widthAppearance: widthAppearance, isAIEnabled: isAIEnabled = false, testId: testId, url: url, ...props })=>/*#__PURE__*/ $fc4bM.createElement($014c569802bf74db$var$ConnectedAIPrismContainer, {
        widthAppearance: widthAppearance,
        isAIEnabled: isAIEnabled,
        url: url,
        testId: testId,
        ...props
    }, children);
var $014c569802bf74db$export$2e2bcd8739ae039 = $014c569802bf74db$var$ContentContainer;

});

parcelRegister("6p49A", function(module, exports) {
$parcel$export(module.exports, "default", () => $29c688c5ee2c2564$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");

var $jEubQ = parcelRequire("jEubQ");

var $5dzEI = parcelRequire("5dzEI");

var $kzNPc = parcelRequire("kzNPc");

var $hiN0m = parcelRequire("hiN0m");

var $kyL3S = parcelRequire("kyL3S");

var $ewFKq = parcelRequire("ewFKq");

var $6Sqna = parcelRequire("6Sqna");

var $gndj3 = parcelRequire("gndj3");

var $8DLmm = parcelRequire("8DLmm");
const $29c688c5ee2c2564$var$titleBlockStyles = null;
const $29c688c5ee2c2564$var$mainTextStyles = null;
const $29c688c5ee2c2564$var$connectButtonStyles = null;
const $29c688c5ee2c2564$var$basePreviewStyles = null;
const $29c688c5ee2c2564$var$HoverCardForbiddenView = ({ flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-forbidden-view' })=>{
    var _cardState$details, _extractSmartLinkProv;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jEubQ.useAnalyticsEvents)();
    const { cardState: cardState, url: url } = flexibleCardProps;
    const meta = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.meta;
    const product = ((_extractSmartLinkProv = (0, $kzNPc.extractSmartLinkProvider)(cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text) ?? '';
    const hostname = /*#__PURE__*/ $fc4bM.createElement("b", null, (0, $kyL3S.default)(url));
    const { action: action, descriptiveMessageKey: descriptiveMessageKey, titleMessageKey: titleMessageKey, buttonDisabled: buttonDisabled } = (0, $hiN0m.extractRequestAccessContextImproved)({
        jsonLd: meta,
        url: url,
        product: product,
        createAnalyticsEvent: createAnalyticsEvent
    }) ?? {};
    if (!titleMessageKey || !descriptiveMessageKey) return null;
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Sqna.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $fc4bM.createElement((0, $8DLmm.default), {
        ignoreContainerPadding: true,
        testId: testId,
        className: (0, $2R2iS.default)([
            "_13li1mok _qrwq1mok _otyru2gc"
        ])
    }), /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        testId: `${testId}-title`,
        className: (0, $2R2iS.default)([
            "_1bah1h6o _k48p1pd9 _19pku2gc"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages)[titleMessageKey],
        values: {
            product: product
        }
    })), /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        testId: `${testId}-content`,
        className: (0, $2R2iS.default)([
            "_11c8wadc _1e0c1nu9 _1bah1h6o _19pkze3t _y3gn1h6o"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages)[descriptiveMessageKey],
        values: {
            product: product,
            hostname: hostname
        }
    })), action && /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        className: (0, $2R2iS.default)([
            "_1bah1h6o _19pku2gc"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5dzEI.default), {
        testId: `${testId}-button`,
        onClick: action === null || action === void 0 ? void 0 : action.promise,
        appearance: "primary",
        isDisabled: buttonDisabled
    }, action === null || action === void 0 ? void 0 : action.text)));
};
var $29c688c5ee2c2564$export$2e2bcd8739ae039 = $29c688c5ee2c2564$var$HoverCardForbiddenView;

});
parcelRegister("hiN0m", function(module, exports) {
$parcel$export(module.exports, "extractRequestAccessContextImproved", () => $f2f354b04e77877f$export$846c1540a86749e6);

var $ewFKq = parcelRequire("ewFKq");

var $9JzR9 = parcelRequire("9JzR9");

var $kmXHN = parcelRequire("kmXHN");

var $kyL3S = parcelRequire("kyL3S");
const $f2f354b04e77877f$export$846c1540a86749e6 = ({ jsonLd: jsonLd, url: url, product: product, createAnalyticsEvent: createAnalyticsEvent })=>{
    var _jsonLd$requestAccess;
    const requestAccess = jsonLd !== null && jsonLd !== void 0 && jsonLd.requestAccess ? {
        ...jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.requestAccess,
        hostname: (0, $kyL3S.default)(url)
    } : undefined;
    switch(jsonLd === null || jsonLd === void 0 || (_jsonLd$requestAccess = jsonLd.requestAccess) === null || _jsonLd$requestAccess === void 0 ? void 0 : _jsonLd$requestAccess.accessType){
        case 'DIRECT_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'direct_access_title',
                descriptiveMessageKey: 'direct_access_description',
                callToActionMessageKey: 'direct_access',
                action: (0, $kmXHN.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'crossJoin',
                        eventType: 'ui'
                    }).fire((0, $9JzR9.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'direct_access', (0, $ewFKq.messages).direct_access, {
                    product: product
                })
            };
        case 'REQUEST_ACCESS':
            return {
                ...requestAccess,
                titleMessageKey: 'default_no_access_title',
                descriptiveMessageKey: 'request_access_description',
                callToActionMessageKey: 'request_access',
                action: (0, $kmXHN.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $9JzR9.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'request_access', (0, $ewFKq.messages).request_access)
            };
        case 'PENDING_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'request_access_pending_title',
                descriptiveMessageKey: 'request_access_pending_description',
                callToActionMessageKey: 'request_access_pending',
                action: (0, $kmXHN.ForbiddenAction)(()=>window.open(url), 'request_access_pending', (0, $ewFKq.messages).request_access_pending),
                buttonDisabled: true
            };
        case 'DENIED_REQUEST_EXISTS':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'request_denied_description'
            };
        case 'ACCESS_EXISTS':
            if ((jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.visibility) === 'not_found') return {
                ...requestAccess,
                titleMessageKey: 'not_found_title',
                descriptiveMessageKey: 'not_found_description'
            };
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'access_exists_description',
                callToActionMessageKey: 'request_access',
                action: (0, $kmXHN.ForbiddenAction)(()=>{
                    if (createAnalyticsEvent !== undefined) createAnalyticsEvent({
                        action: 'clicked',
                        actionSubject: 'button',
                        actionSubjectId: 'requestAccess',
                        eventType: 'ui'
                    }).fire((0, $9JzR9.ANALYTICS_CHANNEL));
                    window.open(url);
                }, 'access_exists', (0, $ewFKq.messages).request_access)
            };
        case 'FORBIDDEN':
            return {
                ...requestAccess,
                titleMessageKey: 'forbidden_title',
                descriptiveMessageKey: 'forbidden_description'
            };
        default:
            return requestAccess;
    }
};

});
parcelRegister("kmXHN", function(module, exports) {
$parcel$export(module.exports, "ForbiddenAction", () => $b1f1e1785a15ef0d$export$59f8830fb5467e35);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $ewFKq = parcelRequire("ewFKq");
const $b1f1e1785a15ef0d$export$59f8830fb5467e35 = (handler, id = 'connect-other-account', message = (0, $ewFKq.messages).try_another_account, values = {})=>({
        id: id,
        text: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
            ...message,
            values: values
        }),
        promise: ()=>new Promise((resolve)=>resolve(handler())),
        buttonAppearance: 'default'
    });

});

parcelRegister("kyL3S", function(module, exports) {
$parcel$export(module.exports, "default", () => $22250dad86484f8d$export$2e2bcd8739ae039);
const $22250dad86484f8d$var$extractHostname = (url)=>{
    try {
        return new URL(url).hostname;
    } catch  {
        return url;
    }
};
var $22250dad86484f8d$export$2e2bcd8739ae039 = $22250dad86484f8d$var$extractHostname;

});



parcelRegister("gUgbH", function(module, exports) {
$parcel$export(module.exports, "default", () => $10c0486cba438e31$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $eCeLl = parcelRequire("eCeLl");

var $6Sqna = parcelRequire("6Sqna");

var $aWTkn = parcelRequire("aWTkn");

var $lxogF = parcelRequire("lxogF");

var $hzOQ7 = parcelRequire("hzOQ7");

var $eZzzn = parcelRequire("eZzzn");

var $PBikU = parcelRequire("PBikU");

var $htqFW = parcelRequire("htqFW");

var $6pxZ4 = parcelRequire("6pxZ4");

var $7XQ7l = parcelRequire("7XQ7l");
const $10c0486cba438e31$var$hiddenSnippetStyles = null;
const $10c0486cba438e31$var$titleBlockStyles = null;
const $10c0486cba438e31$var$snippetBlockCss = null;
const $10c0486cba438e31$var$actionBlockCss = null;
const $10c0486cba438e31$var$HoverCardResolvedView = ({ cardState: cardState, extensionKey: extensionKey, flexibleCardProps: flexibleCardProps, isAISummaryEnabled: isAISummaryEnabled, onActionClick: onActionClick, titleBlockProps: titleBlockProps, id: id })=>{
    var _cardState$details;
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        // Since this hover view is only rendered on resolved status,
        // there is no need to check for statuses.
        (0, $eCeLl.succeedUfoExperience)('smart-link-rendered', id || 'NULL', {
            extensionKey: extensionKey,
            display: (0, $j9rqA.CardDisplay).HoverCardPreview
        });
        // UFO will disregard this if authentication experience has not yet been started
        (0, $eCeLl.succeedUfoExperience)('smart-link-authenticated', id || 'NULL', {
            display: (0, $j9rqA.CardDisplay).HoverCardPreview
        });
        fireEvent('ui.smartLink.renderSuccess', {
            display: (0, $j9rqA.CardDisplay).HoverCardPreview
        });
    }, [
        extensionKey,
        fireEvent,
        id
    ]);
    const data = (_cardState$details = cardState.details) === null || _cardState$details === void 0 ? void 0 : _cardState$details.data;
    const { primary: primary, secondary: secondary } = (0, $fc4bM.useMemo)(()=>{
        return (0, $6pxZ4.getMetadata)(extensionKey, data);
    }, [
        data,
        extensionKey
    ]);
    const snippetHeight = (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).useRef(0);
    const snippetBlockRef = (0, $fc4bM.useRef)(null);
    const onSnippetRender = (0, $fc4bM.useCallback)(()=>{
        var _snippetBlockRef$curr;
        snippetHeight.current = ((_snippetBlockRef$curr = snippetBlockRef.current) === null || _snippetBlockRef$curr === void 0 ? void 0 : _snippetBlockRef$curr.getBoundingClientRect().height) ?? 0;
    }, []);
    const imagePreview = (0, $7XQ7l.default)({
        fallbackElementHeight: snippetHeight.current,
        response: cardState.details
    });
    const snippet = imagePreview ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $PBikU.default), {
        className: (0, $2R2iS.default)([
            "_ca0q1b66"
        ])
    });
    const aiSummaryMinHeight = snippet ? snippetHeight.current : 0;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $6Sqna.default), flexibleCardProps, imagePreview, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $htqFW.default), {
        ...titleBlockProps,
        metadataPosition: (0, $j9rqA.SmartLinkPosition).Top,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _quenze3t _oebj1txw _13mh1pd9"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $eZzzn.default), {
        primary: primary,
        secondary: secondary,
        maxLines: 1,
        size: (0, $j9rqA.SmartLinkSize).Medium
    }), isAISummaryEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $hzOQ7.default), {
        aiSummaryMinHeight: aiSummaryMinHeight,
        placeholder: snippet
    }) : snippet, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $PBikU.default), {
        testId: "hidden-snippet",
        onRender: onSnippetRender,
        blockRef: snippetBlockRef,
        isHidden: true,
        className: (0, $2R2iS.default)([
            "_3um015vq _kqswstnw"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $aWTkn.default), {
        onClick: onActionClick,
        spaceInline: "space.100",
        className: (0, $2R2iS.default)([
            "_n3td1b66"
        ])
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lxogF.default), null));
};
var $10c0486cba438e31$export$2e2bcd8739ae039 = $10c0486cba438e31$var$HoverCardResolvedView;

});
parcelRegister("hzOQ7", function(module, exports) {
$parcel$export(module.exports, "default", () => $53a7cfc07579834c$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $j9rqA = parcelRequire("j9rqA");

var $bxLV6 = parcelRequire("bxLV6");

var $dweer = parcelRequire("dweer");

var $lAmp7 = parcelRequire("lAmp7");
/**
 * Represents an AISummaryBlock, designed to summarising link resource
 * content using AI.
 * @public
 * @param {AISummaryBlockProps} AISummaryBlock
 * @see Block
 */ const $53a7cfc07579834c$var$AISummaryBlock = ({ testId: testId = 'smart-ai-summary-block', ...props })=>{
    var _context$actions, _cardContext$ui;
    const cardContext = (0, $bxLV6.useFlexibleCardContext)();
    const context = (0, $dweer.useFlexibleUiContext)();
    const actionData = context === null || context === void 0 || (_context$actions = context.actions) === null || _context$actions === void 0 ? void 0 : _context$actions[(0, $j9rqA.InternalActionName).AISummaryAction];
    if ((cardContext === null || cardContext === void 0 ? void 0 : cardContext.status) !== (0, $j9rqA.SmartLinkStatus).Resolved) return null;
    if (!(actionData !== null && actionData !== void 0 && actionData.url)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $lAmp7.default), {
        ...props,
        size: props.size ?? (cardContext === null || cardContext === void 0 || (_cardContext$ui = cardContext.ui) === null || _cardContext$ui === void 0 ? void 0 : _cardContext$ui.size),
        testId: testId,
        url: actionData.url
    });
};
var $53a7cfc07579834c$export$2e2bcd8739ae039 = $53a7cfc07579834c$var$AISummaryBlock;

});
parcelRegister("lAmp7", function(module, exports) {
$parcel$export(module.exports, "default", () => $cafa3bb0758d89a8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $j9rqA = parcelRequire("j9rqA");

var $khHoI = parcelRequire("khHoI");

var $e1hDP = parcelRequire("e1hDP");

var $7isd9 = parcelRequire("7isd9");

var $gndj3 = parcelRequire("gndj3");

var $6dQUz = parcelRequire("6dQUz");
const $cafa3bb0758d89a8$var$styles = null;
const $cafa3bb0758d89a8$var$AISummaryBlockResolvedView = (props)=>{
    const { testId: testId, aiSummaryMinHeight: aiSummaryMinHeight = 0, placeholder: placeholder, url: url } = props;
    const { state: { content: content, status: status } } = (0, $khHoI.default)(url);
    const showAISummary = status === 'done' || // We want to display the AI Summary component only when there is content available during the loading process.
    status === 'loading' && !!content;
    const isSummarisedOnMountRef = (0, $fc4bM.useRef)(status === 'done');
    const minHeight = isSummarisedOnMountRef.current ? 0 : aiSummaryMinHeight;
    if (!showAISummary) return /*#__PURE__*/ $fc4bM.createElement((0, $fc4bM.Fragment), null, placeholder);
    return /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        ...props,
        direction: (0, $j9rqA.SmartLinkDirection).Vertical,
        testId: `${testId}-resolved-view`,
        className: (0, $2R2iS.default)([
            "_1reoewfl _18m9ewfl"
        ])
    }, status === 'done' && /*#__PURE__*/ $fc4bM.createElement((0, $6dQUz.default), {
        fromCache: isSummarisedOnMountRef.current
    }), /*#__PURE__*/ $fc4bM.createElement((0, $7isd9.default), {
        minHeight: minHeight,
        show: showAISummary,
        showTransition: !isSummarisedOnMountRef.current
    }, /*#__PURE__*/ $fc4bM.createElement((0, $e1hDP.default), {
        testId: `${testId}-ai-summary`,
        minHeight: minHeight,
        content: content
    })));
};
var $cafa3bb0758d89a8$export$2e2bcd8739ae039 = $cafa3bb0758d89a8$var$AISummaryBlockResolvedView;

});
parcelRegister("e1hDP", function(module, exports) {
$parcel$export(module.exports, "default", () => $88ff2f42d2e1f4ad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fPLge = parcelRequire("fPLge");

var $eDb6A = parcelRequire("eDb6A");
const $88ff2f42d2e1f4ad$var$baseStyle = null;
const $88ff2f42d2e1f4ad$var$textStyle = null;
/**
 * A component to render a response from AI in markdown text.
 * @internal
 * @param {AISummaryProps} AISummaryProps
 */ const $88ff2f42d2e1f4ad$var$AISummary = ({ content: content = '', className: className, testId: testId = 'ai-summary', minHeight: minHeight = 0 })=>{
    if (!content && minHeight === 0) return null;
    return /*#__PURE__*/ $fc4bM.createElement((0, $fPLge.default), {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: (0, $2R2iS.default)([
            "_11c8wadc _slp31hna _1nmz1hna _o5724jg8 _181u1kdv _1rkw1kdv _te171kdv _uizt1kdv",
            "_syazazsu",
            className
        ]),
        children: content,
        options: {
            forceWrapper: true,
            overrides: {
                ul: (0, $eDb6A.default)
            },
            disableParsingRawHTML: true
        },
        style: {
            minHeight: minHeight
        }
    });
};
var $88ff2f42d2e1f4ad$export$2e2bcd8739ae039 = $88ff2f42d2e1f4ad$var$AISummary;

});
parcelRegister("fPLge", function(module, exports) {
$parcel$export(module.exports, "default", () => $b8704774810853d7$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");
function $b8704774810853d7$var$n() {
    return $b8704774810853d7$var$n = Object.assign ? Object.assign.bind() : function(e) {
        for(var n = 1; n < arguments.length; n++){
            var r = arguments[n];
            for(var t in r)Object.prototype.hasOwnProperty.call(r, t) && (e[t] = r[t]);
        }
        return e;
    }, $b8704774810853d7$var$n.apply(this, arguments);
}
const $b8704774810853d7$var$r = [
    "children",
    "options"
], $b8704774810853d7$export$e0aa44767d8750d5 = {
    blockQuote: "0",
    breakLine: "1",
    breakThematic: "2",
    codeBlock: "3",
    codeFenced: "4",
    codeInline: "5",
    footnote: "6",
    footnoteReference: "7",
    gfmTask: "8",
    heading: "9",
    headingSetext: "10",
    htmlBlock: "11",
    htmlComment: "12",
    htmlSelfClosing: "13",
    image: "14",
    link: "15",
    linkAngleBraceStyleDetector: "16",
    linkBareUrlDetector: "17",
    linkMailtoDetector: "18",
    newlineCoalescer: "19",
    orderedList: "20",
    paragraph: "21",
    ref: "22",
    refImage: "23",
    refLink: "24",
    table: "25",
    tableSeparator: "26",
    text: "27",
    textBolded: "28",
    textEmphasized: "29",
    textEscaped: "30",
    textMarked: "31",
    textStrikethroughed: "32",
    unorderedList: "33"
}, $b8704774810853d7$var$o = [
    "allowFullScreen",
    "allowTransparency",
    "autoComplete",
    "autoFocus",
    "autoPlay",
    "cellPadding",
    "cellSpacing",
    "charSet",
    "classId",
    "colSpan",
    "contentEditable",
    "contextMenu",
    "crossOrigin",
    "encType",
    "formAction",
    "formEncType",
    "formMethod",
    "formNoValidate",
    "formTarget",
    "frameBorder",
    "hrefLang",
    "inputMode",
    "keyParams",
    "keyType",
    "marginHeight",
    "marginWidth",
    "maxLength",
    "mediaGroup",
    "minLength",
    "noValidate",
    "radioGroup",
    "readOnly",
    "rowSpan",
    "spellCheck",
    "srcDoc",
    "srcLang",
    "srcSet",
    "tabIndex",
    "useMap"
].reduce((e, n)=>(e[n.toLowerCase()] = n, e), {
    class: "className",
    for: "htmlFor"
}), $b8704774810853d7$var$a = {
    amp: "&",
    apos: "'",
    gt: ">",
    lt: "<",
    nbsp: "\xa0",
    quot: "\u201C"
}, $b8704774810853d7$var$c = [
    "style",
    "script",
    "pre"
], $b8704774810853d7$var$i = [
    "src",
    "href",
    "data",
    "formAction",
    "srcDoc",
    "action"
], $b8704774810853d7$var$u = /([-A-Z0-9_:]+)(?:\s*=\s*(?:(?:"((?:\\.|[^"])*)")|(?:'((?:\\.|[^'])*)')|(?:\{((?:\\.|{[^}]*?}|[^}])*)\})))?/gi, $b8704774810853d7$var$l = /\n{2,}$/, $b8704774810853d7$var$s = /^(\s*>[\s\S]*?)(?=\n\n|$)/, $b8704774810853d7$var$f = /^ *> ?/gm, $b8704774810853d7$var$_ = /^(?:\[!([^\]]*)\]\n)?([\s\S]*)/, $b8704774810853d7$var$d = /^ {2,}\n/, $b8704774810853d7$var$p = /^(?:([-*_])( *\1){2,}) *(?:\n *)+\n/, $b8704774810853d7$var$y = /^(?: {1,3})?(`{3,}|~{3,}) *(\S+)? *([^\n]*?)?\n([\s\S]*?)(?:\1\n?|$)/, $b8704774810853d7$var$h = /^(?: {4}[^\n]+\n*)+(?:\n *)+\n?/, $b8704774810853d7$var$g = /^(`+)((?:\\`|(?!\1)`|[^`])+)\1/, $b8704774810853d7$var$m = /^(?:\n *)*\n/, $b8704774810853d7$var$k = /\r\n?/g, $b8704774810853d7$var$x = /^\[\^([^\]]+)](:(.*)((\n+ {4,}.*)|(\n(?!\[\^).+))*)/, $b8704774810853d7$var$q = /^\[\^([^\]]+)]/, $b8704774810853d7$var$v = /\f/g, $b8704774810853d7$var$b = /^---[ \t]*\n(.|\n)*\n---[ \t]*\n/, $b8704774810853d7$var$$ = /^\s*?\[(x|\s)\]/, $b8704774810853d7$var$S = /^ *(#{1,6}) *([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b8704774810853d7$var$z = /^ *(#{1,6}) +([^\n]+?)(?: +#*)?(?:\n *)*(?:\n|$)/, $b8704774810853d7$var$E = /^([^\n]+)\n *(=|-)\2{2,} *\n/, $b8704774810853d7$var$A = /^ *(?!<[a-z][^ >/]* ?\/>)<([a-z][^ >/]*) ?((?:[^>]*[^/])?)>\n?(\s*(?:<\1[^>]*?>[\s\S]*?<\/\1>|(?!<\1\b)[\s\S])*?)<\/\1>(?!<\/\1>)\n*/i, $b8704774810853d7$var$R = /&([a-z0-9]+|#[0-9]{1,6}|#x[0-9a-fA-F]{1,6});/gi, $b8704774810853d7$var$B = /^<!--[\s\S]*?(?:-->)/, $b8704774810853d7$var$L = /^(data|aria|x)-[a-z_][a-z\d_.-]*$/, $b8704774810853d7$var$O = /^ *<([a-z][a-z0-9:]*)(?:\s+((?:<.*?>|[^>])*))?\/?>(?!<\/\1>)(\s*\n)?/i, $b8704774810853d7$var$j = /^\{.*\}$/, $b8704774810853d7$var$C = /^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/, $b8704774810853d7$var$I = /^<([^ >]+[:@\/][^ >]+)>/, $b8704774810853d7$var$T = /-([a-z])?/gi, $b8704774810853d7$var$M = /^(\|.*)\n(?: *(\|? *[-:]+ *\|[-| :]*)\n((?:.*\|.*\n)*))?\n?/, $b8704774810853d7$var$w = /^[^\n]+(?:  \n|\n{2,})/, $b8704774810853d7$var$D = /^\[([^\]]*)\]:\s+<?([^\s>]+)>?\s*("([^"]*)")?/, $b8704774810853d7$var$F = /^!\[([^\]]*)\] ?\[([^\]]*)\]/, $b8704774810853d7$var$P = /^\[([^\]]*)\] ?\[([^\]]*)\]/, $b8704774810853d7$var$Z = /(\n|^[-*]\s|^#|^ {2,}|^-{2,}|^>\s)/, $b8704774810853d7$var$N = /\t/g, $b8704774810853d7$var$G = /(^ *\||\| *$)/g, $b8704774810853d7$var$U = /^ *:-+: *$/, $b8704774810853d7$var$V = /^ *:-+ *$/, $b8704774810853d7$var$H = /^ *-+: *$/, $b8704774810853d7$var$Q = (e)=>`(?=[\\s\\S]+?\\1${e ? "\\1" : ""})`, $b8704774810853d7$var$W = "((?:\\[.*?\\][([].*?[)\\]]|<.*?>(?:.*?<.*?>)?|`.*?`|\\\\\\1|[\\s\\S])+?)", $b8704774810853d7$var$J = RegExp(`^([*_])\\1${$b8704774810853d7$var$Q(1)}${$b8704774810853d7$var$W}\\1\\1(?!\\1)`), $b8704774810853d7$var$K = RegExp(`^([*_])${$b8704774810853d7$var$Q(0)}${$b8704774810853d7$var$W}\\1(?!\\1)`), $b8704774810853d7$var$X = RegExp(`^(==)${$b8704774810853d7$var$Q(0)}${$b8704774810853d7$var$W}\\1`), $b8704774810853d7$var$Y = RegExp(`^(~~)${$b8704774810853d7$var$Q(0)}${$b8704774810853d7$var$W}\\1`), $b8704774810853d7$var$ee = /^(:[a-zA-Z0-9-_]+:)/, $b8704774810853d7$var$ne = /^\\([^0-9A-Za-z\s])/, $b8704774810853d7$var$re = /\\([^0-9A-Za-z\s])/g, $b8704774810853d7$var$te = /^[\s\S](?:(?!  \n|[0-9]\.|http)[^=*_~\-\n:<`\\\[!])*/, $b8704774810853d7$var$oe = /^\n+/, $b8704774810853d7$var$ae = /^([ \t]*)/, $b8704774810853d7$var$ce = /(?:^|\n)( *)$/, $b8704774810853d7$var$ie = "(?:\\d+\\.)", $b8704774810853d7$var$ue = "(?:[*+-])";
function $b8704774810853d7$var$le(e) {
    return "( *)(" + (1 === e ? $b8704774810853d7$var$ie : $b8704774810853d7$var$ue) + ") +";
}
const $b8704774810853d7$var$se = $b8704774810853d7$var$le(1), $b8704774810853d7$var$fe = $b8704774810853d7$var$le(2);
function $b8704774810853d7$var$_e(e) {
    return RegExp("^" + (1 === e ? $b8704774810853d7$var$se : $b8704774810853d7$var$fe));
}
const $b8704774810853d7$var$de = $b8704774810853d7$var$_e(1), $b8704774810853d7$var$pe = $b8704774810853d7$var$_e(2);
function $b8704774810853d7$var$ye(e) {
    return RegExp("^" + (1 === e ? $b8704774810853d7$var$se : $b8704774810853d7$var$fe) + "[^\\n]*(?:\\n(?!\\1" + (1 === e ? $b8704774810853d7$var$ie : $b8704774810853d7$var$ue) + " )[^\\n]*)*(\\n|$)", "gm");
}
const $b8704774810853d7$var$he = $b8704774810853d7$var$ye(1), $b8704774810853d7$var$ge = $b8704774810853d7$var$ye(2);
function $b8704774810853d7$var$me(e) {
    const n = 1 === e ? $b8704774810853d7$var$ie : $b8704774810853d7$var$ue;
    return RegExp("^( *)(" + n + ") [\\s\\S]+?(?:\\n{2,}(?! )(?!\\1" + n + " (?!" + n + " ))\\n*|\\s*\\n*$)");
}
const $b8704774810853d7$var$ke = $b8704774810853d7$var$me(1), $b8704774810853d7$var$xe = $b8704774810853d7$var$me(2);
function $b8704774810853d7$var$qe(e, n) {
    const r = 1 === n, t = r ? $b8704774810853d7$var$ke : $b8704774810853d7$var$xe, o = r ? $b8704774810853d7$var$he : $b8704774810853d7$var$ge, a = r ? $b8704774810853d7$var$de : $b8704774810853d7$var$pe;
    return {
        t: (e)=>a.test(e),
        o: $b8704774810853d7$var$je(function(e, n) {
            const r = $b8704774810853d7$var$ce.exec(n.prevCapture);
            return r && (n.list || !n.inline && !n.simple) ? t.exec(e = r[1] + e) : null;
        }),
        i: 1,
        u (e, n, t) {
            const c = r ? +e[2] : void 0, i = e[0].replace($b8704774810853d7$var$l, "\n").match(o);
            let u = !1;
            return {
                items: i.map(function(e, r) {
                    const o = a.exec(e)[0].length, c = RegExp("^ {1," + o + "}", "gm"), l = e.replace(c, "").replace(a, ""), s = r === i.length - 1, f = -1 !== l.indexOf("\n\n") || s && u;
                    u = f;
                    const _ = t.inline, d = t.list;
                    let p;
                    t.list = !0, f ? (t.inline = !1, p = $b8704774810853d7$var$Se(l) + "\n\n") : (t.inline = !0, p = $b8704774810853d7$var$Se(l));
                    const y = n(p, t);
                    return t.inline = _, t.list = d, y;
                }),
                ordered: r,
                start: c
            };
        },
        l: (n, r, t)=>e(n.ordered ? "ol" : "ul", {
                key: t.key,
                start: "20" === n.type ? n.start : void 0
            }, n.items.map(function(n, o) {
                return e("li", {
                    key: o
                }, r(n, t));
            }))
    };
}
const $b8704774810853d7$var$ve = RegExp("^\\[((?:\\[[^\\[\\]]*(?:\\[[^\\[\\]]*\\][^\\[\\]]*)*\\]|[^\\[\\]])*)\\]\\(\\s*<?((?:\\([^)]*\\)|[^\\s\\\\]|\\\\.)*?)>?(?:\\s+['\"]([\\s\\S]*?)['\"])?\\s*\\)"), $b8704774810853d7$var$be = /^!\[(.*?)\]\( *((?:\([^)]*\)|[^() ])*) *"?([^)"]*)?"?\)/;
function $b8704774810853d7$var$$e(e) {
    return "string" == typeof e;
}
function $b8704774810853d7$var$Se(e) {
    let n = e.length;
    for(; n > 0 && e[n - 1] <= " ";)n--;
    return e.slice(0, n);
}
function $b8704774810853d7$var$ze(e, n) {
    return e.startsWith(n);
}
function $b8704774810853d7$var$Ee(e, n, r) {
    if (Array.isArray(r)) {
        for(let n = 0; n < r.length; n++)if ($b8704774810853d7$var$ze(e, r[n])) return !0;
        return !1;
    }
    return r(e, n);
}
function $b8704774810853d7$export$c383cdd2a518017a(e) {
    return e.replace(/[ÀÁÂÃÄÅàáâãäåæÆ]/g, "a").replace(/[çÇ]/g, "c").replace(/[ðÐ]/g, "d").replace(/[ÈÉÊËéèêë]/g, "e").replace(/[ÏïÎîÍíÌì]/g, "i").replace(/[Ññ]/g, "n").replace(/[øØœŒÕõÔôÓóÒò]/g, "o").replace(/[ÜüÛûÚúÙù]/g, "u").replace(/[ŸÿÝý]/g, "y").replace(/[^a-z0-9- ]/gi, "").replace(/ /gi, "-").toLowerCase();
}
function $b8704774810853d7$var$Re(e) {
    return $b8704774810853d7$var$H.test(e) ? "right" : $b8704774810853d7$var$U.test(e) ? "center" : $b8704774810853d7$var$V.test(e) ? "left" : null;
}
function $b8704774810853d7$var$Be(e, n, r, t) {
    const o = r.inTable;
    r.inTable = !0;
    let a = [
        []
    ], c = "";
    function i() {
        if (!c) return;
        const e = a[a.length - 1];
        e.push.apply(e, n(c, r)), c = "";
    }
    return e.trim().split(/(`[^`]*`|\\\||\|)/).filter(Boolean).forEach((e, n, r)=>{
        "|" === e.trim() && (i(), t) ? 0 !== n && n !== r.length - 1 && a.push([]) : c += e;
    }), i(), r.inTable = o, a;
}
function $b8704774810853d7$var$Le(e, n, r) {
    r.inline = !0;
    const t = e[2] ? e[2].replace($b8704774810853d7$var$G, "").split("|").map($b8704774810853d7$var$Re) : [], o = e[3] ? function(e, n, r) {
        return e.trim().split("\n").map(function(e) {
            return $b8704774810853d7$var$Be(e, n, r, !0);
        });
    }(e[3], n, r) : [], a = $b8704774810853d7$var$Be(e[1], n, r, !!o.length);
    return r.inline = !1, o.length ? {
        align: t,
        cells: o,
        header: a,
        type: "25"
    } : {
        children: a,
        type: "21"
    };
}
function $b8704774810853d7$var$Oe(e, n) {
    return null == e.align[n] ? {} : {
        textAlign: e.align[n]
    };
}
function $b8704774810853d7$var$je(e) {
    return e.inline = 1, e;
}
function $b8704774810853d7$var$Ce(e) {
    return $b8704774810853d7$var$je(function(n, r) {
        return r.inline ? e.exec(n) : null;
    });
}
function $b8704774810853d7$var$Ie(e) {
    return $b8704774810853d7$var$je(function(n, r) {
        return r.inline || r.simple ? e.exec(n) : null;
    });
}
function $b8704774810853d7$var$Te(e) {
    return function(n, r) {
        return r.inline || r.simple ? null : e.exec(n);
    };
}
function $b8704774810853d7$var$Me(e) {
    return $b8704774810853d7$var$je(function(n) {
        return e.exec(n);
    });
}
const $b8704774810853d7$var$we = /(javascript|vbscript|data(?!:image)):/i;
function $b8704774810853d7$export$3e2338ea76b578c9(e) {
    try {
        const n = decodeURIComponent(e).replace(/[^A-Za-z0-9/:]/g, "");
        if ($b8704774810853d7$var$we.test(n)) return null;
    } catch (e) {
        return null;
    }
    return e;
}
function $b8704774810853d7$var$Fe(e) {
    return e ? e.replace($b8704774810853d7$var$re, "$1") : e;
}
function $b8704774810853d7$var$Pe(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !0, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $b8704774810853d7$var$Ze(e, n, r) {
    const t = r.inline || !1, o = r.simple || !1;
    r.inline = !1, r.simple = !0;
    const a = e(n, r);
    return r.inline = t, r.simple = o, a;
}
function $b8704774810853d7$var$Ne(e, n, r) {
    const t = r.inline || !1;
    r.inline = !1;
    const o = e(n, r);
    return r.inline = t, o;
}
const $b8704774810853d7$var$Ge = (e, n, r)=>({
        children: $b8704774810853d7$var$Pe(n, e[2], r)
    });
function $b8704774810853d7$var$Ue() {
    return {};
}
function $b8704774810853d7$var$Ve() {
    return null;
}
function $b8704774810853d7$var$He(...e) {
    return e.filter(Boolean).join(" ");
}
function $b8704774810853d7$var$Qe(e, n, r) {
    let t = e;
    const o = n.split(".");
    for(; o.length && (t = t[o[0]], void 0 !== t);)o.shift();
    return t || r;
}
function $b8704774810853d7$export$69f434acfbdb0b32(r = "", t = {}) {
    t.overrides = t.overrides || {}, t.namedCodesToUnicode = t.namedCodesToUnicode ? $b8704774810853d7$var$n({}, $b8704774810853d7$var$a, t.namedCodesToUnicode) : $b8704774810853d7$var$a;
    const l = t.slugify || $b8704774810853d7$export$c383cdd2a518017a, G = t.sanitizer || $b8704774810853d7$export$3e2338ea76b578c9, U = t.createElement || $fc4bM.createElement, V = [
        $b8704774810853d7$var$s,
        $b8704774810853d7$var$y,
        $b8704774810853d7$var$h,
        t.enforceAtxHeadings ? $b8704774810853d7$var$z : $b8704774810853d7$var$S,
        $b8704774810853d7$var$E,
        $b8704774810853d7$var$M,
        $b8704774810853d7$var$ke,
        $b8704774810853d7$var$xe
    ], H = [
        ...V,
        $b8704774810853d7$var$w,
        $b8704774810853d7$var$A,
        $b8704774810853d7$var$B,
        $b8704774810853d7$var$O
    ];
    function Q(e, n) {
        for(let r = 0; r < e.length; r++)if (e[r].test(n)) return !0;
        return !1;
    }
    function W(e, r, ...o) {
        const a = $b8704774810853d7$var$Qe(t.overrides, e + ".props", {});
        return U(function(e, n) {
            const r = $b8704774810853d7$var$Qe(n, e);
            return r ? "function" == typeof r || "object" == typeof r && "render" in r ? r : $b8704774810853d7$var$Qe(n, e + ".component", e) : e;
        }(e, t.overrides), $b8704774810853d7$var$n({}, r, a, {
            className: $b8704774810853d7$var$He(null == r ? void 0 : r.className, a.className) || void 0
        }), ...o);
    }
    function re(e) {
        e = e.replace($b8704774810853d7$var$b, "");
        let n = !1;
        t.forceInline ? n = !0 : t.forceBlock || (n = !1 === $b8704774810853d7$var$Z.test(e));
        const r = fe(se(n ? e : $b8704774810853d7$var$Se(e).replace($b8704774810853d7$var$oe, "") + "\n\n", {
            inline: n
        }));
        for(; $b8704774810853d7$var$$e(r[r.length - 1]) && !r[r.length - 1].trim();)r.pop();
        if (null === t.wrapper) return r;
        const o = t.wrapper || (n ? "span" : "div");
        let a;
        if (r.length > 1 || t.forceWrapper) a = r;
        else {
            if (1 === r.length) return a = r[0], "string" == typeof a ? W("span", {
                key: "outer"
            }, a) : a;
            a = null;
        }
        return U(o, {
            key: "outer"
        }, a);
    }
    function ce(e, n) {
        if (!n || !n.trim()) return null;
        const r = n.match($b8704774810853d7$var$u);
        return r ? r.reduce(function(n, r) {
            const t = r.indexOf("=");
            if (-1 !== t) {
                const a = (function(e) {
                    return -1 !== e.indexOf("-") && null === e.match($b8704774810853d7$var$L) && (e = e.replace($b8704774810853d7$var$T, function(e, n) {
                        return n.toUpperCase();
                    })), e;
                })(r.slice(0, t)).trim(), c = function(e) {
                    const n = e[0];
                    return ('"' === n || "'" === n) && e.length >= 2 && e[e.length - 1] === n ? e.slice(1, -1) : e;
                }(r.slice(t + 1).trim()), u = $b8704774810853d7$var$o[a] || a;
                if ("ref" === u) return n;
                const l = n[u] = function(e, n, r, t) {
                    return "style" === n ? (function(e) {
                        const n = [];
                        let r = "", t = !1, o = !1, a = "";
                        if (!e) return n;
                        for(let c = 0; c < e.length; c++){
                            const i = e[c];
                            if ('"' !== i && "'" !== i || t || (o ? i === a && (o = !1, a = "") : (o = !0, a = i)), "(" === i && r.endsWith("url") ? t = !0 : ")" === i && t && (t = !1), ";" !== i || o || t) r += i;
                            else {
                                const e = r.trim();
                                if (e) {
                                    const r = e.indexOf(":");
                                    if (r > 0) {
                                        const t = e.slice(0, r).trim(), o = e.slice(r + 1).trim();
                                        n.push([
                                            t,
                                            o
                                        ]);
                                    }
                                }
                                r = "";
                            }
                        }
                        const c = r.trim();
                        if (c) {
                            const e = c.indexOf(":");
                            if (e > 0) {
                                const r = c.slice(0, e).trim(), t = c.slice(e + 1).trim();
                                n.push([
                                    r,
                                    t
                                ]);
                            }
                        }
                        return n;
                    })(r).reduce(function(n, [r, o]) {
                        return n[r.replace(/(-[a-z])/g, (e)=>e[1].toUpperCase())] = t(o, e, r), n;
                    }, {}) : -1 !== $b8704774810853d7$var$i.indexOf(n) ? t($b8704774810853d7$var$Fe(r), e, n) : (r.match($b8704774810853d7$var$j) && (r = $b8704774810853d7$var$Fe(r.slice(1, r.length - 1))), "true" === r || "false" !== r && r);
                }(e, a, c, G);
                "string" == typeof l && ($b8704774810853d7$var$A.test(l) || $b8704774810853d7$var$O.test(l)) && (n[u] = re(l.trim()));
            } else "style" !== r && (n[$b8704774810853d7$var$o[r] || r] = !0);
            return n;
        }, {}) : null;
    }
    const ie = [], ue = {}, le = {
        0: {
            t: [
                ">"
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$s),
            i: 1,
            u (e, n, r) {
                const [, t, o] = e[0].replace($b8704774810853d7$var$f, "").match($b8704774810853d7$var$_);
                return {
                    alert: t,
                    children: n(o, r)
                };
            },
            l (e, n, r) {
                const t = {
                    key: r.key
                };
                return e.alert && (t.className = "markdown-alert-" + l(e.alert.toLowerCase(), $b8704774810853d7$export$c383cdd2a518017a), e.children.unshift({
                    attrs: {},
                    children: [
                        {
                            type: "27",
                            text: e.alert
                        }
                    ],
                    noInnerParse: !0,
                    type: "11",
                    tag: "header"
                })), W("blockquote", t, n(e.children, r));
            }
        },
        1: {
            t: [
                "  "
            ],
            o: $b8704774810853d7$var$Me($b8704774810853d7$var$d),
            i: 1,
            u: $b8704774810853d7$var$Ue,
            l: (e, n, r)=>W("br", {
                    key: r.key
                })
        },
        2: {
            t: [
                "--",
                "__",
                "**",
                "- ",
                "* ",
                "_ "
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$p),
            i: 1,
            u: $b8704774810853d7$var$Ue,
            l: (e, n, r)=>W("hr", {
                    key: r.key
                })
        },
        3: {
            t: [
                "    "
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$h),
            i: 0,
            u: (e)=>({
                    lang: void 0,
                    text: $b8704774810853d7$var$Fe($b8704774810853d7$var$Se(e[0].replace(/^ {4}/gm, "")))
                }),
            l: (e, r, t)=>W("pre", {
                    key: t.key
                }, W("code", $b8704774810853d7$var$n({}, e.attrs, {
                    className: e.lang ? "lang-" + e.lang : ""
                }), e.text))
        },
        4: {
            t: [
                "```",
                "~~~"
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$y),
            i: 0,
            u: (e)=>({
                    attrs: ce("code", e[3] || ""),
                    lang: e[2] || void 0,
                    text: e[4],
                    type: "3"
                })
        },
        5: {
            t: [
                "`"
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$g),
            i: 3,
            u: (e)=>({
                    text: $b8704774810853d7$var$Fe(e[2])
                }),
            l: (e, n, r)=>W("code", {
                    key: r.key
                }, e.text)
        },
        6: {
            t: [
                "[^"
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$x),
            i: 0,
            u: (e)=>(ie.push({
                    footnote: e[2],
                    identifier: e[1]
                }), {}),
            l: $b8704774810853d7$var$Ve
        },
        7: {
            t: [
                "[^"
            ],
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$q),
            i: 1,
            u: (e)=>({
                    target: "#" + l(e[1], $b8704774810853d7$export$c383cdd2a518017a),
                    text: e[1]
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href")
                }, W("sup", {
                    key: r.key
                }, e.text))
        },
        8: {
            t: [
                "[ ]",
                "[x]"
            ],
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$$),
            i: 1,
            u: (e)=>({
                    completed: "x" === e[1].toLowerCase()
                }),
            l: (e, n, r)=>W("input", {
                    checked: e.completed,
                    key: r.key,
                    readOnly: !0,
                    type: "checkbox"
                })
        },
        9: {
            t: [
                "#"
            ],
            o: $b8704774810853d7$var$Te(t.enforceAtxHeadings ? $b8704774810853d7$var$z : $b8704774810853d7$var$S),
            i: 1,
            u: (e, n, r)=>({
                    children: $b8704774810853d7$var$Pe(n, e[2], r),
                    id: l(e[2], $b8704774810853d7$export$c383cdd2a518017a),
                    level: e[1].length
                }),
            l: (e, n, r)=>W("h" + e.level, {
                    id: e.id,
                    key: r.key
                }, n(e.children, r))
        },
        10: {
            t: (e)=>{
                const n = e.indexOf("\n");
                return n > 0 && n < e.length - 1 && ("=" === e[n + 1] || "-" === e[n + 1]);
            },
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$E),
            i: 1,
            u: (e, n, r)=>({
                    children: $b8704774810853d7$var$Pe(n, e[1], r),
                    level: "=" === e[2] ? 1 : 2,
                    type: "9"
                })
        },
        11: {
            t: [
                "<"
            ],
            o: $b8704774810853d7$var$Me($b8704774810853d7$var$A),
            i: 1,
            u (e, n, r) {
                const [, t] = e[3].match($b8704774810853d7$var$ae), o = RegExp("^" + t, "gm"), a = e[3].replace(o, ""), i = Q(H, a) ? $b8704774810853d7$var$Ne : $b8704774810853d7$var$Pe, u = e[1].toLowerCase(), l = -1 !== $b8704774810853d7$var$c.indexOf(u), s = (l ? u : e[1]).trim(), f = {
                    attrs: ce(s, e[2]),
                    noInnerParse: l,
                    tag: s
                };
                if (r.inAnchor = r.inAnchor || "a" === u, l) f.text = e[3];
                else {
                    const e = r.inHTML;
                    r.inHTML = !0, f.children = i(n, a, r), r.inHTML = e;
                }
                return r.inAnchor = !1, f;
            },
            l: (e, r, t)=>W(e.tag, $b8704774810853d7$var$n({
                    key: t.key
                }, e.attrs), e.text || (e.children ? r(e.children, t) : ""))
        },
        13: {
            t: [
                "<"
            ],
            o: $b8704774810853d7$var$Me($b8704774810853d7$var$O),
            i: 1,
            u (e) {
                const n = e[1].trim();
                return {
                    attrs: ce(n, e[2] || ""),
                    tag: n
                };
            },
            l: (e, r, t)=>W(e.tag, $b8704774810853d7$var$n({}, e.attrs, {
                    key: t.key
                }))
        },
        12: {
            t: [
                "\x3c!--"
            ],
            o: $b8704774810853d7$var$Me($b8704774810853d7$var$B),
            i: 1,
            u: ()=>({}),
            l: $b8704774810853d7$var$Ve
        },
        14: {
            t: [
                "!["
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$be),
            i: 1,
            u: (e)=>({
                    alt: $b8704774810853d7$var$Fe(e[1]),
                    target: $b8704774810853d7$var$Fe(e[2]),
                    title: $b8704774810853d7$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("img", {
                    key: r.key,
                    alt: e.alt || void 0,
                    title: e.title || void 0,
                    src: G(e.target, "img", "src")
                })
        },
        15: {
            t: [
                "["
            ],
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$ve),
            i: 3,
            u: (e, n, r)=>({
                    children: $b8704774810853d7$var$Ze(n, e[1], r),
                    target: $b8704774810853d7$var$Fe(e[2]),
                    title: $b8704774810853d7$var$Fe(e[3])
                }),
            l: (e, n, r)=>W("a", {
                    key: r.key,
                    href: G(e.target, "a", "href"),
                    title: e.title
                }, n(e.children, r))
        },
        16: {
            t: [
                "<"
            ],
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$I),
            i: 0,
            u (e) {
                let n = e[1], r = !1;
                return -1 !== n.indexOf("@") && -1 === n.indexOf("//") && (r = !0, n = n.replace("mailto:", "")), {
                    children: [
                        {
                            text: n,
                            type: "27"
                        }
                    ],
                    target: r ? "mailto:" + n : n,
                    type: "15"
                };
            }
        },
        17: {
            t: (e, n)=>!n.inAnchor && !t.disableAutoLink && ($b8704774810853d7$var$ze(e, "http://") || $b8704774810853d7$var$ze(e, "https://")),
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$C),
            i: 0,
            u: (e)=>({
                    children: [
                        {
                            text: e[1],
                            type: "27"
                        }
                    ],
                    target: e[1],
                    title: void 0,
                    type: "15"
                })
        },
        20: $b8704774810853d7$var$qe(W, 1),
        33: $b8704774810853d7$var$qe(W, 2),
        19: {
            t: [
                "\n"
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$m),
            i: 3,
            u: $b8704774810853d7$var$Ue,
            l: ()=>"\n"
        },
        21: {
            o: $b8704774810853d7$var$je(function(e, n) {
                if (n.inline || n.simple || n.inHTML && -1 === e.indexOf("\n\n") && -1 === n.prevCapture.indexOf("\n\n")) return null;
                let r = "", t = 0;
                for(;;){
                    const n = e.indexOf("\n", t), o = e.slice(t, -1 === n ? void 0 : n + 1);
                    if (Q(V, o)) break;
                    if (r += o, -1 === n || !o.trim()) break;
                    t = n + 1;
                }
                const o = $b8704774810853d7$var$Se(r);
                return "" === o ? null : [
                    r,
                    ,
                    o
                ];
            }),
            i: 3,
            u: $b8704774810853d7$var$Ge,
            l: (e, n, r)=>W("p", {
                    key: r.key
                }, n(e.children, r))
        },
        22: {
            t: [
                "["
            ],
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$D),
            i: 0,
            u: (e)=>(ue[e[1]] = {
                    target: e[2],
                    title: e[4]
                }, {}),
            l: $b8704774810853d7$var$Ve
        },
        23: {
            t: [
                "!["
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$F),
            i: 0,
            u: (e)=>({
                    alt: e[1] ? $b8704774810853d7$var$Fe(e[1]) : void 0,
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("img", {
                    key: r.key,
                    alt: e.alt,
                    src: G(ue[e.ref].target, "img", "src"),
                    title: ue[e.ref].title
                }) : null
        },
        24: {
            t: (e)=>"[" === e[0] && -1 === e.indexOf("]("),
            o: $b8704774810853d7$var$Ce($b8704774810853d7$var$P),
            i: 0,
            u: (e, n, r)=>({
                    children: n(e[1], r),
                    fallbackChildren: e[0],
                    ref: e[2]
                }),
            l: (e, n, r)=>ue[e.ref] ? W("a", {
                    key: r.key,
                    href: G(ue[e.ref].target, "a", "href"),
                    title: ue[e.ref].title
                }, n(e.children, r)) : W("span", {
                    key: r.key
                }, e.fallbackChildren)
        },
        25: {
            t: [
                "|"
            ],
            o: $b8704774810853d7$var$Te($b8704774810853d7$var$M),
            i: 1,
            u: $b8704774810853d7$var$Le,
            l (e, n, r) {
                const t = e;
                return W("table", {
                    key: r.key
                }, W("thead", null, W("tr", null, t.header.map(function(e, o) {
                    return W("th", {
                        key: o,
                        style: $b8704774810853d7$var$Oe(t, o)
                    }, n(e, r));
                }))), W("tbody", null, t.cells.map(function(e, o) {
                    return W("tr", {
                        key: o
                    }, e.map(function(e, o) {
                        return W("td", {
                            key: o,
                            style: $b8704774810853d7$var$Oe(t, o)
                        }, n(e, r));
                    }));
                })));
            }
        },
        27: {
            o: $b8704774810853d7$var$je(function(e, n) {
                let r;
                return $b8704774810853d7$var$ze(e, ":") && (r = $b8704774810853d7$var$ee.exec(e)), r || $b8704774810853d7$var$te.exec(e);
            }),
            i: 4,
            u (e) {
                const n = e[0];
                return {
                    text: -1 === n.indexOf("&") ? n : n.replace($b8704774810853d7$var$R, (e, n)=>t.namedCodesToUnicode[n] || e)
                };
            },
            l: (e)=>e.text
        },
        28: {
            t: [
                "**",
                "__"
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$J),
            i: 2,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("strong", {
                    key: r.key
                }, n(e.children, r))
        },
        29: {
            t: (e)=>{
                const n = e[0];
                return ("*" === n || "_" === n) && e[1] !== n;
            },
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$K),
            i: 3,
            u: (e, n, r)=>({
                    children: n(e[2], r)
                }),
            l: (e, n, r)=>W("em", {
                    key: r.key
                }, n(e.children, r))
        },
        30: {
            t: [
                "\\"
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$ne),
            i: 1,
            u: (e)=>({
                    text: e[1],
                    type: "27"
                })
        },
        31: {
            t: [
                "=="
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$X),
            i: 3,
            u: $b8704774810853d7$var$Ge,
            l: (e, n, r)=>W("mark", {
                    key: r.key
                }, n(e.children, r))
        },
        32: {
            t: [
                "~~"
            ],
            o: $b8704774810853d7$var$Ie($b8704774810853d7$var$Y),
            i: 3,
            u: $b8704774810853d7$var$Ge,
            l: (e, n, r)=>W("del", {
                    key: r.key
                }, n(e.children, r))
        }
    };
    !0 === t.disableParsingRawHTML && (delete le[11], delete le[13]);
    const se = function(e) {
        var n = Object.keys(e);
        function r(t, o) {
            var a = [];
            if (o.prevCapture = o.prevCapture || "", t.trim()) for(; t;)for(var c = 0; c < n.length;){
                var i = n[c], u = e[i];
                if (!u.t || $b8704774810853d7$var$Ee(t, o, u.t)) {
                    var l = u.o(t, o);
                    if (l && l[0]) {
                        t = t.substring(l[0].length);
                        var s = u.u(l, r, o);
                        o.prevCapture += l[0], s.type || (s.type = i), a.push(s);
                        break;
                    }
                    c++;
                } else c++;
            }
            return o.prevCapture = "", a;
        }
        return n.sort(function(n, r) {
            return e[n].i - e[r].i || (n < r ? -1 : 1);
        }), function(e, n) {
            return r(function(e) {
                return e.replace($b8704774810853d7$var$k, "\n").replace($b8704774810853d7$var$v, "").replace($b8704774810853d7$var$N, "    ");
            }(e), n);
        };
    }(le), fe = function(e, n) {
        return function r(t, o = {}) {
            if (Array.isArray(t)) {
                const e = o.key, n = [];
                let a = !1;
                for(let e = 0; e < t.length; e++){
                    o.key = e;
                    const c = r(t[e], o), i = $b8704774810853d7$var$$e(c);
                    i && a ? n[n.length - 1] += c : null !== c && n.push(c), a = i;
                }
                return o.key = e, n;
            }
            return function(r, t, o) {
                const a = e[r.type].l;
                return n ? n(()=>a(r, t, o), r, t, o) : a(r, t, o);
            }(t, r, o);
        };
    }(le, t.renderRule), _e = re(r);
    return ie.length ? W("div", null, _e, W("footer", {
        key: "footer"
    }, ie.map(function(e) {
        return W("div", {
            id: l(e.identifier, $b8704774810853d7$export$c383cdd2a518017a),
            key: e.identifier
        }, e.identifier, fe(se(e.footnote, {
            inline: !0
        })));
    }))) : _e;
}
var $b8704774810853d7$export$2e2bcd8739ae039 = (n)=>{
    let { children: t, options: o } = n, a = function(e, n) {
        if (null == e) return {};
        var r, t, o = {}, a = Object.keys(e);
        for(t = 0; t < a.length; t++)n.indexOf(r = a[t]) >= 0 || (o[r] = e[r]);
        return o;
    }(n, $b8704774810853d7$var$r);
    return $fc4bM.cloneElement($b8704774810853d7$export$69f434acfbdb0b32(null == t ? "" : t, o), a);
};

});

parcelRegister("eDb6A", function(module, exports) {
$parcel$export(module.exports, "default", () => $63c5e765412fd5a0$export$2e2bcd8739ae039);
/* ulist.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");
const $63c5e765412fd5a0$var$listStyles = null;
const $63c5e765412fd5a0$var$UList = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("ul", {
        ...props,
        className: (0, $2R2iS.default)([
            "_19bvv47k _bozgv47k"
        ])
    }, children);
var $63c5e765412fd5a0$export$2e2bcd8739ae039 = $63c5e765412fd5a0$var$UList;

});


parcelRegister("6dQUz", function(module, exports) {
$parcel$export(module.exports, "default", () => $df4ee5e3947decd5$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fVrlX = parcelRequire("fVrlX");
const $df4ee5e3947decd5$var$AIEventSummaryViewed = ({ fromCache: fromCache = null })=>{
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    (0, $fc4bM.useEffect)(()=>{
        fireEvent('ui.summary.viewed', {
            fromCache: fromCache
        });
        if (fromCache) fireEvent('track.aiInteraction.initiated', {
            aiFeatureName: 'Smart Links Summary',
            proactiveAIGenerated: 1,
            userGeneratedAI: 0
        });
    }, [
        fireEvent,
        fromCache
    ]);
    return null;
};
var $df4ee5e3947decd5$export$2e2bcd8739ae039 = $df4ee5e3947decd5$var$AIEventSummaryViewed;

});



parcelRegister("7XQ7l", function(module, exports) {
$parcel$export(module.exports, "default", () => $829f50ec92986d3b$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $gE5Az = parcelRequire("gE5Az");

var $8DLmm = parcelRequire("8DLmm");
const $829f50ec92986d3b$var$ImagePreview = ({ fallbackElementHeight: fallbackElementHeight, response: response })=>{
    const transitionStarted = (0, $fc4bM.useRef)(false);
    const previewBlockRef = (0, $fc4bM.useRef)(null);
    const [showPreview, setShowPreview] = (0, $fc4bM.useState)(true);
    const [dynamicStyles, setDynamicStyles] = (0, $fc4bM.useState)({});
    // Set Preview to a fixed height to enable transitions
    const onPreviewRender = (0, $fc4bM.useCallback)(()=>{
        if (previewBlockRef.current) {
            var _previewBlockRef$curr;
            const previewHeight = (_previewBlockRef$curr = previewBlockRef.current) === null || _previewBlockRef$curr === void 0 ? void 0 : _previewBlockRef$curr.getBoundingClientRect().height;
            setDynamicStyles({
                borderTopLeftRadius: "var(--ds-radius-large, 8px)",
                borderTopRightRadius: "var(--ds-radius-large, 8px)",
                ...previewHeight ? {
                    height: `${previewHeight}px`
                } : {}
            });
        }
    }, []);
    // On error set Preview to Fallback height with transition
    const onPreviewError = (0, $fc4bM.useCallback)(()=>{
        if (transitionStarted.current === false) {
            setDynamicStyles({
                transition: 'height 300ms ease-in-out',
                height: `${fallbackElementHeight}px`
            });
            transitionStarted.current = true;
        }
    }, [
        fallbackElementHeight
    ]);
    const onPreviewTransitionEnd = (0, $fc4bM.useCallback)(()=>{
        setShowPreview(false);
    }, []);
    return showPreview && (0, $gE5Az.extractSmartLinkPreviewImage)(response) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8DLmm.default), {
        onError: onPreviewError,
        ignoreContainerPadding: true,
        onTransitionEnd: onPreviewTransitionEnd,
        blockRef: previewBlockRef,
        onRender: onPreviewRender,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: dynamicStyles
    }) : null;
};
var $829f50ec92986d3b$export$2e2bcd8739ae039 = $829f50ec92986d3b$var$ImagePreview;

});
parcelRegister("gE5Az", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkPreviewImage", () => $2665d60f4a1a21a2$export$a79836076066b8b6);

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");

var $j9rqA = parcelRequire("j9rqA");

var $6V9Nj = parcelRequire("6V9Nj");
const $2665d60f4a1a21a2$export$a79836076066b8b6 = (response)=>{
    if (!response || !(response !== null && response !== void 0 && response.data)) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _entity$thumbnail;
        const entity = (0, $YqY0I.extractEntity)(response);
        let url = entity === null || entity === void 0 || (_entity$thumbnail = entity.thumbnail) === null || _entity$thumbnail === void 0 ? void 0 : _entity$thumbnail.externalUrl;
        return url ? {
            type: (0, $j9rqA.MediaType).Image,
            url: url
        } : undefined;
    }
    return (0, $6V9Nj.extractPreview)(response.data);
};

});
parcelRegister("6V9Nj", function(module, exports) {
$parcel$export(module.exports, "extractPreview", () => $0476bc9083fb62b9$export$4b0d98b1b7f6d115);

var $cgIWc = parcelRequire("cgIWc");

var $j9rqA = parcelRequire("j9rqA");
const $0476bc9083fb62b9$export$4b0d98b1b7f6d115 = (data)=>{
    if (!data) return undefined;
    const url = (0, $cgIWc.extractImage)(data);
    return url ? {
        type: (0, $j9rqA.MediaType).Image,
        url: url
    } : undefined;
};

});
parcelRegister("cgIWc", function(module, exports) {
$parcel$export(module.exports, "extractImage", () => $d544d47d65133224$export$4c753a1297cb9805);

var $8BY94 = parcelRequire("8BY94");
const $d544d47d65133224$export$4c753a1297cb9805 = (jsonLd)=>{
    const image = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.image;
    if (image) {
        if (typeof image === 'string') return image;
        else if (image['@type'] === 'Link') return (0, $8BY94.extractUrlFromLinkJsonLd)(image);
        else if (image['@type'] === 'Image') {
            if (image.url) return (0, $8BY94.extractUrlFromLinkJsonLd)(image.url);
        }
    }
    return undefined;
};

});





parcelRegister("cWM5n", function(module, exports) {
$parcel$export(module.exports, "default", () => $23c95d32b413f40e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $2R2iS = parcelRequire("2R2iS");

var $fc4bM = parcelRequire("fc4bM");

var $nLHJY = parcelRequire("nLHJY");

var $kJrsj = parcelRequire("kJrsj");

var $gndj3 = parcelRequire("gndj3");

var $4IHO5 = parcelRequire("4IHO5");

var $eHCJ9 = parcelRequire("eHCJ9");
const $23c95d32b413f40e$var$loadingViewContainer = null;
const $23c95d32b413f40e$var$skeletonContainer = null;
const $23c95d32b413f40e$var$titleStyle = null;
const $23c95d32b413f40e$var$titleBlockStyles = null;
const $23c95d32b413f40e$var$HoverCardLoadingView = ({ titleBlockProps: titleBlockProps })=>{
    const testId = 'hover-card-loading-view';
    const lineHeightRem = 1.25;
    const skeletonWidth = (0, $eHCJ9.CARD_WIDTH_REM) - 2;
    const { size: size, actions: actions } = titleBlockProps;
    const actionGroup = (actions === null || actions === void 0 ? void 0 : actions.length) && (actions === null || actions === void 0 ? void 0 : actions.length) > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $kJrsj.default), {
        items: actions,
        visibleButtonsNum: 2
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        "data-testid": testId,
        className: (0, $2R2iS.default)([
            "_1e0c1txw _2lx21bp4 _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
        className: (0, $2R2iS.default)([
            "_zulpud5o _1e0c1txw _2lx21bp4 _4cvr1h6o"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $gndj3.default), {
        ...titleBlockProps,
        testId: `${testId}-title-block`,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _1bsb1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $4IHO5.default), {
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nLHJY.LoadingSkeleton), null),
        size: size
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("span", {
        "data-testid": `${testId}-title`,
        className: (0, $2R2iS.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _4t3i1k92 _e2oo1osq"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nLHJY.LoadingSkeleton), {
        height: `${lineHeightRem}rem`
    })), actionGroup), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nLHJY.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nLHJY.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem * 3}rem`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $nLHJY.LoadingSkeleton), {
        width: `${skeletonWidth}rem`,
        height: `${lineHeightRem}rem`
    }))));
};
var $23c95d32b413f40e$export$2e2bcd8739ae039 = $23c95d32b413f40e$var$HoverCardLoadingView;

});

parcelRegister("1EYsK", function(module, exports) {
$parcel$export(module.exports, "default", () => $133667e3488beecc$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");

var $kzNPc = parcelRequire("kzNPc");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $lBTn5 = parcelRequire("lBTn5");

var $9575Q = parcelRequire("9575Q");

var $8Rlkg = parcelRequire("8Rlkg");

var $6Sqna = parcelRequire("6Sqna");

var $kJrsj = parcelRequire("kJrsj");

var $gndj3 = parcelRequire("gndj3");

var $4tJOd = parcelRequire("4tJOd");
const $133667e3488beecc$var$connectButtonStyles = null;
const $133667e3488beecc$var$titleBlockStyles = null;
const $133667e3488beecc$var$mainTextStyles = null;
const $133667e3488beecc$var$HoverCardUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, testId: testId = 'hover-card-unauthorised-view', url: url })=>{
    var _extractSmartLinkProv;
    const { cardState: cardState } = flexibleCardProps;
    const providerName = (_extractSmartLinkProv = (0, $kzNPc.extractSmartLinkProvider)(cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text;
    const isProductIntegrationSupported = (0, $9575Q.hasAuthScopeOverrides)(cardState.details);
    const { authorize: authorize } = (0, $lBTn5.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const handleAuthorize = (0, $fc4bM.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $j9rqA.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const actions = (0, $fc4bM.useMemo)(()=>[
            {
                name: (0, $j9rqA.ActionName).CustomAction,
                content: /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
                    ...(0, $ewFKq.messages).connect_unauthorised_account_action,
                    values: {
                        context: providerName
                    }
                }),
                onClick: handleAuthorize
            }
        ], [
        handleAuthorize,
        providerName
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Sqna.default), {
        ...flexibleCardProps,
        testId: testId
    }, /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        testId: `${testId}-title`,
        className: (0, $2R2iS.default)([
            "_zulpu2gc _13mh1pd9"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4tJOd.default), null), /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).connect_link_account_card_name,
        values: {
            context: providerName
        }
    })), /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        testId: `${testId}-content`,
        className: (0, $2R2iS.default)([
            "_11c8wadc _19pku2gc"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement("div", null, /*#__PURE__*/ $fc4bM.createElement((0, $8Rlkg.default), {
        providerName: providerName,
        isProductIntegrationSupported: isProductIntegrationSupported
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $gndj3.default), {
        testId: `${testId}-button`,
        className: (0, $2R2iS.default)([
            "_1bahesu3 _19pku2gc"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $kJrsj.default), {
        items: actions,
        appearance: "primary"
    })));
};
var $133667e3488beecc$export$2e2bcd8739ae039 = $133667e3488beecc$var$HoverCardUnauthorisedView;

});
parcelRegister("9575Q", function(module, exports) {
$parcel$export(module.exports, "hasAuthScopeOverrides", () => $a0baadbcc01dbaca$export$3f9446bb21b945a0);
const $a0baadbcc01dbaca$export$3f9446bb21b945a0 = (details)=>!!(details !== null && details !== void 0 && details.meta.hasScopeOverrides);

});

parcelRegister("8Rlkg", function(module, exports) {
$parcel$export(module.exports, "default", () => $e87da64fef252da1$export$2e2bcd8739ae039);

var $fc4bM = parcelRequire("fc4bM");

var $fd880 = parcelRequire("fd880");

var $dRkX9 = parcelRequire("dRkX9");

var $5Ny1Q = parcelRequire("5Ny1Q");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");
/**
 * This component is used in unauthorized views of a smart link.
 * It represents the main text that provides a user with information on how to connect their account
 */ const $e87da64fef252da1$var$UnauthorisedViewContent = ({ providerName: providerName, isProductIntegrationSupported: isProductIntegrationSupported, testId: testId = 'unauthorised-view-content' })=>{
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const handleLearnMoreClick = (0, $fc4bM.useCallback)(()=>{
        fireEvent('ui.button.clicked.learnMore', {});
    }, [
        fireEvent
    ]);
    const learnMoreMessage = isProductIntegrationSupported ? (0, $dRkX9.fg)('product-terminology-refresh') ? (0, $ewFKq.messages).learn_more_about_connecting_account_appify : (0, $ewFKq.messages).learn_more_about_connecting_account : (0, $ewFKq.messages).learn_more_about_smart_links;
    const unauthorizedAccountDescriptionMessage = (0, $ewFKq.messages).learn_more_about_connecting_account_experiment_shorter;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).Fragment, null, providerName ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), {
        ...unauthorizedAccountDescriptionMessage,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), (0, $dRkX9.fg)('product-terminology-refresh') ? (0, $ewFKq.messages).connect_unauthorised_account_description_no_provider_appify : (0, $ewFKq.messages).connect_unauthorised_account_description_no_provider), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $5Ny1Q.Anchor), {
        href: isProductIntegrationSupported ? (0, $j9rqA.CONTENT_URL_3P_ACCOUNT_AUTH) : (0, $j9rqA.CONTENT_URL_SECURITY_AND_PERMISSIONS),
        target: "_blank",
        testId: `${testId}-learn-more`,
        onClick: handleLearnMoreClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $fd880.default), learnMoreMessage)));
};
var $e87da64fef252da1$export$2e2bcd8739ae039 = $e87da64fef252da1$var$UnauthorisedViewContent;

});


parcelRegister("sCfVT", function(module, exports) {
$parcel$export(module.exports, "default", () => $408c7596122294c6$export$2e2bcd8739ae039);
/* RovoUnauthorisedView.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $fd880 = parcelRequire("fd880");

var $5dzEI = parcelRequire("5dzEI");

var $7cjzH = parcelRequire("7cjzH");

var $inMs5 = parcelRequire("inMs5");

var $j3PNU = parcelRequire("j3PNU");

var $kzNPc = parcelRequire("kzNPc");

var $YihpL = parcelRequire("YihpL");

var $dBtOK = parcelRequire("dBtOK");

var $i3riz = parcelRequire("i3riz");

var $cJzRi = parcelRequire("cJzRi");

var $k8Adr = parcelRequire("k8Adr");

var $fVrlX = parcelRequire("fVrlX");

var $j9rqA = parcelRequire("j9rqA");

var $ewFKq = parcelRequire("ewFKq");

var $lBTn5 = parcelRequire("lBTn5");

var $6Sqna = parcelRequire("6Sqna");

var $4tJOd = parcelRequire("4tJOd");

var $4RQ49 = parcelRequire("4RQ49");

var $lTXTn = parcelRequire("lTXTn");

var $2cjTt = parcelRequire("2cjTt");
const $408c7596122294c6$var$ROVO_FEATURES = [
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($inMs5))),
        message: (0, $ewFKq.messages).rovo_unauthorised_feature_clear_link_names,
        testIdSuffix: 'clear-link-names'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7cjzH))),
        message: (0, $ewFKq.messages).rovo_unauthorised_feature_understand_linked_docs,
        testIdSuffix: 'understand-linked-docs'
    },
    {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($j3PNU))),
        message: (0, $ewFKq.messages).rovo_unauthorised_feature_go_deeper_smart_suggestions,
        testIdSuffix: 'go-deeper-smart-suggestions'
    }
];
const $408c7596122294c6$var$sparkleWrapBase = null;
const $408c7596122294c6$var$sparkleLeftWrap = null;
const $408c7596122294c6$var$sparkleGreyRightWrap = null;
const $408c7596122294c6$var$sparkleVioletRightWrap = null;
const $408c7596122294c6$var$layoutStyles = {
    connectorStroke: "_syaz1fxt _1e0c1txw _1o9zidpf",
    atlassianIconTile: "_2rko1mok _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _bfhk16e3",
    header: "_bfhk11bn _ca0q1ejb _u5f3pxbi _n3tdutpp _19bvpxbi _13li1mok _qrwq1mok _kqswh2mm",
    headerGraphicRow: "_zulpu2gc _1e0c1txw _4cvr1h6o _1bah1h6o _otyrutpp",
    headerTitle: "_y3gn1h6o",
    body: "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
    featureIconCell: "_1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _1bsb7vkz",
    footer: "_zulputpp _19pkutpp _ca0q1b66 _1e0c1txw _4cvr1h6o _1bahesu3 _1n261g80"
};
const $408c7596122294c6$var$RovoUnauthorisedView = ({ id: id = '', flexibleCardProps: flexibleCardProps, onDismiss: onDismiss, testId: testId = 'hover-card-rovo-unauthorised-view', url: url })=>{
    const providerName = (0, $fc4bM.useMemo)(()=>{
        var _extractSmartLinkProv;
        return (_extractSmartLinkProv = (0, $kzNPc.extractSmartLinkProvider)(flexibleCardProps.cardState.details)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text;
    }, [
        flexibleCardProps.cardState.details
    ]);
    const { authorize: authorize } = (0, $lBTn5.useSmartCardActions)(id, url);
    const { fireEvent: fireEvent } = (0, $fVrlX.useAnalyticsEvents)();
    const handleAuthorize = (0, $fc4bM.useCallback)(()=>{
        if (authorize) {
            fireEvent('track.applicationAccount.authStarted', {});
            authorize((0, $j9rqA.CardDisplay).HoverCardPreview);
        }
    }, [
        authorize,
        fireEvent
    ]);
    const handleDismiss = (0, $fc4bM.useCallback)(()=>{
        if (onDismiss) {
            fireEvent('ui.button.clicked.dismiss', {});
            onDismiss();
        }
    }, [
        fireEvent,
        onDismiss
    ]);
    return /*#__PURE__*/ $fc4bM.createElement((0, $6Sqna.default), {
        ...flexibleCardProps,
        testId: testId,
        ui: {
            hideElevation: true,
            hideBackground: true,
            removeBlockRestriction: true,
            hidePadding: true
        }
    }, /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.header
    }, /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syaz1yjp _154i1ul9 _1ltv1v6z"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4RQ49.DenseSparkle), null)), /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syazwejn _154i1crf _1xi2qslr"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $lTXTn.SparseSparkle), null)), /*#__PURE__*/ $fc4bM.createElement("div", {
        className: (0, $2R2iS.default)([
            "_1o9zidpf _1e0c1txw _kqswstnw",
            "_syazuq3u _1bsbqslr _154i1ylp _1xi21v6z"
        ])
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4RQ49.DenseSparkle), null)), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.headerGraphicRow
    }, /*#__PURE__*/ $fc4bM.createElement((0, $4tJOd.default), {
        size: (0, $j9rqA.SmartLinkSize).Medium,
        isTiledIcon: true
    }), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.connectorStroke
    }, /*#__PURE__*/ $fc4bM.createElement((0, $2cjTt.SquiglyArrow), null)), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.atlassianIconTile
    }, /*#__PURE__*/ $fc4bM.createElement((0, $YihpL.AtlassianIcon), {
        appearance: "inverse",
        size: "small"
    }))), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.headerTitle
    }, /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), {
        weight: "bold",
        size: "medium",
        color: "color.text"
    }, providerName ? /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), {
        ...(0, $ewFKq.messages).rovo_unauthorised_title,
        values: {
            context: providerName
        }
    }) : /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).rovo_unauthorised_title_no_provider)))), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.body
    }, /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), {
        space: "space.050"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $cJzRi.Stack), {
        space: "space.200"
    }, $408c7596122294c6$var$ROVO_FEATURES.map((feature)=>{
        const FeatureIcon = feature.icon;
        return /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
            key: feature.testIdSuffix,
            space: "space.150",
            alignBlock: "center",
            testId: `${testId}-feature-${feature.testIdSuffix}`
        }, /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
            xcss: $408c7596122294c6$var$layoutStyles.featureIconCell
        }, /*#__PURE__*/ $fc4bM.createElement(FeatureIcon, {
            label: ""
        })), /*#__PURE__*/ $fc4bM.createElement((0, $k8Adr.Text), null, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), feature.message)));
    })), /*#__PURE__*/ $fc4bM.createElement((0, $dBtOK.Box), {
        xcss: $408c7596122294c6$var$layoutStyles.footer
    }, /*#__PURE__*/ $fc4bM.createElement((0, $i3riz.Inline), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ $fc4bM.createElement((0, $5dzEI.default), {
        appearance: "subtle",
        spacing: "compact",
        onClick: handleDismiss,
        testId: `${testId}-not-now`
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).rovo_unauthorised_not_now)), /*#__PURE__*/ $fc4bM.createElement((0, $5dzEI.default), {
        appearance: "primary",
        onClick: handleAuthorize,
        testId: `${testId}-connect-account`
    }, /*#__PURE__*/ $fc4bM.createElement((0, $fd880.default), (0, $ewFKq.messages).rovo_unauthorised_connect_account)))))));
};
var $408c7596122294c6$export$2e2bcd8739ae039 = $408c7596122294c6$var$RovoUnauthorisedView;

});
parcelRegister("4RQ49", function(module, exports) {
$parcel$export(module.exports, "DenseSparkle", () => $44a0dbc0879d43da$export$eaa6832866c251cf);
/* DenseSparkle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");
const $44a0dbc0879d43da$export$eaa6832866c251cf = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "33",
        height: "33",
        viewBox: "0 0 33 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        fill: "currentColor",
        d: "M 18.1377,8.5584 C 19.820521,9.7606431 19.569624,7.0234324 19.891314,6.0724492 20.627318,4.4834923 20.654624,2.6485663 20.986387,0.9358225 20.985763,-0.63106096 19.153938,0.29529924 19.30907,1.4628594 18.581402,3.0380165 18.941526,4.9281736 18.3064,6.59809 18.189624,7.241971 17.98497,7.9130416 18.1377,8.5584 Z M 14.048,8.62872 C 16.108587,8.8291383 14.519035,6.5848441 14.323941,5.6001158 14.16595,3.856369 13.270155,2.254813 12.701225,0.60606587 11.918719,-0.74933808 10.791962,0.96396467 11.513059,1.8973545 11.672048,3.6244988 12.925689,5.0825474 13.2127,6.8456 13.436435,7.4621245 13.581302,8.1376081 14.048,8.62872 Z M 10.5438,10.7324 C 12.427639,9.875884 9.9317744,8.7259408 9.2689606,7.9718267 8.2625,6.5396335 6.6886891,5.5966404 5.36875,4.4566662 4.0131223,3.6745583 3.8966957,5.7235932 4.9866023,6.1718516 5.9867147,7.5895644 7.8032328,8.2251817 8.93219,9.61022 9.4294433,10.031063 9.9148481,10.555839 10.5438,10.7324 Z M 8.55828,14.3099 C 9.7604964,12.627122 7.023384,12.877794 6.0723265,12.556262 4.4833477,11.820331 2.6484558,11.792914 0.93570025,11.461212 c -1.5668845,6.26e-4 -0.64052126,1.832452 0.52703915,1.677318 1.5751539,0.727694 3.4653396,0.36738 5.1352306,1.00267 0.6438861,0.116827 1.314933,0.321333 1.96031,0.1687 z m 0.07008,4.0894 C 8.828733,16.338698 6.5844599,17.928323 5.5997508,18.123433 3.8560002,18.281408 2.2543901,19.1771 0.60569938,19.746162 -0.74955704,20.529217 0.96332374,21.653982 1.8969889,20.93548 3.6240071,20.774217 5.0821994,19.522267 6.84523,19.2346 7.4618123,19.010984 8.1372369,18.866007 8.62836,18.3993 Z m 2.10414,3.5072 C 9.8760472,20.022637 8.7260556,22.518484 7.9719398,23.181273 6.5393153,24.18655 5.6000777,25.76278 4.4595963,27.081513 3.6775168,28.437135 5.7265095,28.553572 6.1747816,27.463666 7.5925047,26.463552 8.2280912,24.647029 9.61315,23.5181 c 0.418283,-0.497326 0.951352,-0.985318 1.11935,-1.6116 z m 3.5775,1.9828 c -1.682815,-1.202255 -1.431924,1.534991 -1.753614,2.485976 -0.736023,1.588942 -0.763314,3.423872 -1.095073,5.136612 6.39e-4,1.566887 1.832425,0.640518 1.677317,-0.527032 0.727655,-1.57517 0.367555,-3.465328 1.00267,-5.135256 0.116772,-0.64388 0.321426,-1.314917 0.1687,-1.9603 z m 4.0891,-0.0702 c -2.060649,-0.200406 -0.470945,2.043891 -0.275873,3.028605 0.157937,1.743716 1.053669,3.345319 1.622686,4.994007 0.782496,1.355437 1.909207,-0.357878 1.188142,-1.291274 C 20.77504,28.823312 19.521385,27.365256 19.2344,25.6022 19.010647,24.985692 18.865809,24.310193 18.3991,23.8191 Z m 3.5074,-2.1038 c -1.88386,0.856461 0.611976,2.006423 1.274773,2.760542 1.006466,1.432207 2.580314,2.375182 3.90024,3.515183 1.355682,0.782012 1.472001,-1.26689 0.382153,-1.715209 C 26.463526,24.858147 24.647022,24.222555 23.5181,22.8375 23.02082,22.416678 22.53553,21.891757 21.9065,21.7153 Z m 1.9826,-3.5775 c -1.202233,1.682763 1.53485,1.432123 2.485905,1.753638 1.588978,0.735928 3.423859,0.763338 5.136608,1.095049 1.566893,-5.94e-4 0.640594,-1.832443 -0.527,-1.677317 C 29.409454,18.581486 27.519286,18.941792 25.8494,18.3065 25.205557,18.189667 24.534178,17.985164 23.8891,18.1378 Z m -0.0704,-4.0894 c -0.200405,2.06064 2.043899,0.470968 3.028605,0.275867 1.743759,-0.15797 3.345359,-1.053678 4.994083,-1.622679 1.355308,-0.782551 -0.357965,-1.909199 -1.29135,-1.188185 -1.727151,0.159054 -3.185218,1.412574 -4.948238,1.699697 -0.616574,0.223619 -1.291971,0.368616 -1.7831,0.8353 z M 21.7152,10.544 c 0.85645,1.88385 2.006449,-0.6119565 2.760542,-1.2747918 1.432624,-1.0052563 2.371905,-2.581444 3.512333,-3.9002107 C 28.770204,4.0133778 26.721159,3.8969258 26.272916,4.986848 24.855171,5.9869493 24.21954,7.8034667 22.8345,8.93243 22.416234,9.4297408 21.883198,9.917751 21.7152,10.544 Z"
    }));
};

});

parcelRegister("lTXTn", function(module, exports) {
$parcel$export(module.exports, "SparseSparkle", () => $b59f91bbbb2eb9b9$export$d4cc5913ef36e057);
/* SparseSparkle.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");
const $b59f91bbbb2eb9b9$export$d4cc5913ef36e057 = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "35",
        height: "34",
        viewBox: "0 0 35 34",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        fill: "currentColor",
        d: "m 21.4614,9.02651 c 1.774882,1.267966 1.510442,-1.6188099 1.849578,-2.6219063 0.776223,-1.6758612 0.805105,-3.61111 1.154947,-5.41753458 C 24.447185,-0.68027653 22.513317,0.28790594 22.69688,1.5429258 21.929419,3.2042498 22.309243,5.1977402 21.6394,6.95899 21.51609,7.6380728 21.300546,8.3458903 21.4614,9.02651 Z m -9.1629,0.611 C 14.479174,9.6115402 12.55696,7.4386694 12.239238,6.4296801 11.873994,4.6211661 10.751762,3.0453042 9.9684287,1.3818975 9.0519692,0.02745097 7.9717763,1.9817201 8.8672911,2.872095 9.2298246,4.664959 10.714117,6.0484595 11.2158,7.86365 c 0.30309,0.6222222 0.536236,1.3131609 1.0827,1.77386 z M 9.02651,14.4282 c 1.267976,-1.774848 -1.6188386,-1.510386 -2.6219063,-1.849578 -1.6758612,-0.776223 -3.61111,-0.805105 -5.41753458,-1.154947 -1.66734565,0.01874 -0.69916318,1.952608 0.55585668,1.769045 1.661324,0.767461 3.6548144,0.387637 5.4160642,1.05748 0.6790828,0.12331 1.3869003,0.338854 2.06752,0.178 z m 0.79812,7.0123 C 9.6506342,19.264889 7.6156756,21.33182 6.6290172,21.715218 4.8462675,22.200193 3.3480398,23.427583 1.7425513,24.327425 0.48184315,25.389439 2.4687817,26.243895 3.3047292,25.323131 5.0679233,24.838194 6.3485808,23.265036 8.1279,22.6448 8.727623,22.296964 9.4030508,22.019757 9.82463,21.4405 Z m 4.60367,2.4235 c -1.774857,-1.267999 -1.510322,1.618845 -1.849554,2.621865 -0.776222,1.675869 -0.805026,3.611122 -1.154946,5.417535 0.01882,1.667361 1.952587,0.699167 1.769034,-0.555848 0.767463,-1.661311 0.387597,-3.654815 1.057466,-5.416052 0.123252,-0.679055 0.338956,-1.387036 0.178,-2.0675 z m 5.9772,0.261 c -2.173333,-0.211383 -0.496768,2.155705 -0.291021,3.19429 0.166568,1.839106 1.111399,3.528228 1.711458,5.267122 0.84816,1.433261 2.042749,-0.366933 1.253122,-1.36187 C 22.911487,29.402909 21.589251,27.865123 21.2864,26.0057 21.05053,25.355401 20.897759,24.642984 20.4055,24.125 Z m 4.3514,-4.2566 c -1.918413,1.03763 0.793683,2.065164 1.542216,2.81224 1.163691,1.434148 2.891651,2.307238 4.359284,3.41661 1.503797,0.716781 1.491809,-1.445265 0.281572,-1.83218 C 29.783911,22.847779 27.827538,22.311391 26.5397,20.9362 25.981077,20.526301 25.453402,20.026312 24.7569,19.8684 Z m 0.2667,-6.5645 c -0.61356,2.094147 2.024993,0.892339 3.082584,0.881972 1.837741,0.184903 3.674321,-0.429733 5.494903,-0.694759 1.566146,-0.568664 0.02093,-2.078292 -1.105917,-1.48934 -1.8201,-0.172658 -3.577509,0.836398 -5.46037,0.783027 -0.682737,0.109486 -1.416687,0.125746 -2.0112,0.5191 z"
    }));
};

});

parcelRegister("2cjTt", function(module, exports) {
$parcel$export(module.exports, "SquiglyArrow", () => $7ea3cf8dc846c01b$export$940e84768143d382);
/* SquiglyArrow.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");
const $7ea3cf8dc846c01b$export$940e84768143d382 = ()=>{
    return /*#__PURE__*/ $fc4bM.createElement("svg", {
        width: "31",
        height: "21",
        viewBox: "0 0 31 21",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $fc4bM.createElement("path", {
        fill: "currentColor",
        d: "M 21.853446,0.12040609 C 20.167706,1.2017532 24.715673,2.4997309 25.755055,3.0673371 25.02723,3.2209011 21.984019,3.856737 20.991485,3.9633568 16.045179,5.5890307 11.446918,7.8287185 9.1072914,12.742806 7.8983204,12.284216 5.7117383,11.960731 4.1643839,12.645906 2.2323901,13.501397 0.58356937,15.13985 0.06015349,17.184987 0.06666279,19.997869 1.7741124,16.035826 2.7542112,15.14763 c 1.6305676,-1.477671 4.7339707,-2.002323 5.8717147,-1.083896 -0.6742412,2.17406 -0.7914961,6.013849 1.8803011,6.750565 2.072285,0.571408 3.768061,-1.977378 2.786707,-4.245231 C 12.524186,14.792533 11.187386,13.937797 10.469825,13.425746 12.484573,8.4842061 19.328854,5.5947574 24.21859,4.6647774 25.288915,4.5397793 29.069777,3.0700705 27.388804,4.826459 26.472831,6.3589647 23.793814,8.1658647 23.628028,9.0737265 23.1618,11.626835 26.092344,8.4605266 26.699318,7.7349157 27.826169,6.2825775 29.856947,4.4211835 30.479445,3.5562506 28.766042,2.8991905 26.575439,1.3555612 24.569756,0.89998649 23.662177,0.65006782 22.790889,0.24992986 21.853446,0.12040609 Z M 9.9983561,14.652336 C 11.498101,15.3957 13.411213,18.565161 11.127761,19.347839 9.1996093,18.911365 9.5916528,16.22149 9.9983561,14.652336 Z"
    }));
};

});



parcelRegister("8CWF9", function(module, exports) {
$parcel$export(module.exports, "createCustomPopupContainer", () => $6518f507dea115eb$export$c98f335200f1c8df);

var $fc4bM = parcelRequire("fc4bM");
const $6518f507dea115eb$export$c98f335200f1c8df = (zIndex)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).forwardRef(// FIXME: ...props spreads all props to the div, including isReferenceHidden, which is not a valid prop for a div.
    // Find another way but adding exceptions with _, __, ___ etc.
    ({ children: children, shouldFitContainer: _, shouldRenderToParent: __, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement("div", {
            ...props,
            ref: ref,
            ...zIndex !== undefined && {
                style: {
                    ...props.style,
                    zIndex: zIndex
                }
            }
        }, children));
};

});




parcelRegister("2Dis3", function(module, exports) {
$parcel$export(module.exports, "default", () => $5fd91e60672cd5b5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $fc4bM = parcelRequire("fc4bM");

var $2R2iS = parcelRequire("2R2iS");

var $f1474 = parcelRequire("f1474");
const $5fd91e60672cd5b5$var$styles = null;
/**
 * An anchor component to cover the entire container creating a clickable area.
 * @internal
 * @see `clickableContainer`
 */ const $5fd91e60672cd5b5$var$LayeredLink = ({ onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, target: target, testId: testId, text: text, url: url })=>{
    const onMouseDown = (0, $f1474.useMouseDownEvent)();
    return /*#__PURE__*/ $fc4bM.createElement("a", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $2R2iS.default)([
            "_1reo15vq _18m915vq _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _azhw1osq _o5721q9c _hboxstnw _obkmidpf _a52dkb7n",
            "layered-link"
        ]),
        "data-testid": `${testId}-layered-link`,
        href: url,
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        onMouseDown: onMouseDown,
        target: target
    }, text);
};
var $5fd91e60672cd5b5$export$2e2bcd8739ae039 = $5fd91e60672cd5b5$var$LayeredLink;

});


parcelRegister("heq9X", function(module, exports) {
$parcel$export(module.exports, "getContextByStatus", () => $d6e9b05673b26314$export$e68aec76e359e401);

var $j9rqA = parcelRequire("j9rqA");

var $fdtgK = parcelRequire("fdtgK");

var $k8J82 = parcelRequire("k8J82");

var $dQzXs = parcelRequire("dQzXs");

var $4stHy = parcelRequire("4stHy");

var $gE5Az = parcelRequire("gE5Az");

var $SoLKX = parcelRequire("SoLKX");

var $fDTjp = parcelRequire("fDTjp");
const $d6e9b05673b26314$export$e68aec76e359e401 = (params)=>{
    var _response$meta;
    const { onClick: onClick, response: response, status: status, url: url } = params ?? {};
    switch(status){
        case (0, $j9rqA.SmartLinkStatus).Pending:
        case (0, $j9rqA.SmartLinkStatus).Resolving:
            return {
                linkTitle: (0, $dQzXs.default)(status, url, response, onClick),
                url: url
            };
        case (0, $j9rqA.SmartLinkStatus).Resolved:
            return (0, $fdtgK.default)(params);
        case (0, $j9rqA.SmartLinkStatus).Unauthorized:
        case (0, $j9rqA.SmartLinkStatus).Forbidden:
        case (0, $j9rqA.SmartLinkStatus).NotFound:
        case (0, $j9rqA.SmartLinkStatus).Errored:
        case (0, $j9rqA.SmartLinkStatus).Fallback:
        default:
            return {
                url: url,
                linkIcon: (0, $SoLKX.extractErrorIcon)(response, status),
                linkTitle: (0, $dQzXs.default)(status, url, response, onClick),
                preview: (0, $gE5Az.extractSmartLinkPreviewImage)(response),
                provider: (0, $4stHy.default)(response),
                actions: {
                    [(0, $j9rqA.InternalActionName).UnresolvedAction]: (0, $fDTjp.getRetryOptions)(url, status, response, params.onAuthorize)
                },
                meta: {
                    accessType: response === null || response === void 0 || (_response$meta = response.meta) === null || _response$meta === void 0 || (_response$meta = _response$meta.requestAccess) === null || _response$meta === void 0 ? void 0 : _response$meta.accessType
                },
                hostName: (0, $k8J82.extractHostName)(response)
            };
    }
};

});
parcelRegister("fdtgK", function(module, exports) {
$parcel$export(module.exports, "default", () => $ec30732445139ffa$export$2e2bcd8739ae039);

var $1sniP = parcelRequire("1sniP");

var $ghqH4 = parcelRequire("ghqH4");

var $9r6uU = parcelRequire("9r6uU");

var $4SQG4 = parcelRequire("4SQG4");

var $eXjTm = parcelRequire("eXjTm");

var $5gvOn = parcelRequire("5gvOn");

var $fil80 = parcelRequire("fil80");

var $cbtbS = parcelRequire("cbtbS");

var $lOxou = parcelRequire("lOxou");

var $dRkX9 = parcelRequire("dRkX9");

var $hGTGd = parcelRequire("hGTGd");

var $jMH4W = parcelRequire("jMH4W");

var $c1aAh = parcelRequire("c1aAh");

var $4MxLD = parcelRequire("4MxLD");

var $7DN26 = parcelRequire("7DN26");

var $llkoX = parcelRequire("llkoX");

var $7mMuf = parcelRequire("7mMuf");

var $iWfWP = parcelRequire("iWfWP");

var $k8J82 = parcelRequire("k8J82");

var $dQzXs = parcelRequire("dQzXs");

var $bPeBW = parcelRequire("bPeBW");

var $fZkbk = parcelRequire("fZkbk");

var $rugWY = parcelRequire("rugWY");

var $krEI2 = parcelRequire("krEI2");

var $8FBNQ = parcelRequire("8FBNQ");

var $aDAi2 = parcelRequire("aDAi2");

var $6jPLy = parcelRequire("6jPLy");

var $k9JH8 = parcelRequire("k9JH8");

var $4stHy = parcelRequire("4stHy");

var $2M0BH = parcelRequire("2M0BH");

var $1Ev4I = parcelRequire("1Ev4I");

var $gE5Az = parcelRequire("gE5Az");

var $usiaF = parcelRequire("usiaF");

var $biykc = parcelRequire("biykc");

var $4h7Pt = parcelRequire("4h7Pt");

var $70s5w = parcelRequire("70s5w");

var $fM0PU = parcelRequire("fM0PU");

var $7zETV = parcelRequire("7zETV");

var $dYCtJ = parcelRequire("dYCtJ");

var $lmySn = parcelRequire("lmySn");

var $7xqxz = parcelRequire("7xqxz");

var $1UoIz = parcelRequire("1UoIz");

var $4bnJG = parcelRequire("4bnJG");

var $85uGW = parcelRequire("85uGW");

var $2TRbH = parcelRequire("2TRbH");

var $bSjVt = parcelRequire("bSjVt");
const $ec30732445139ffa$var$extractFlexibleUiContext = ({ appearance: appearance, fireEvent: fireEvent, id: id, onClick: onClick, onAuxClick: onAuxClick, onContextMenu: onContextMenu, origin: origin, product: product, resolve: resolve, rovoConfig: rovoConfig, actionOptions: actionOptions, response: response, status: status, aiSummaryConfig: aiSummaryConfig, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel, transformUrl: transformUrl, ...props } = {})=>{
    if (!response) return undefined;
    const data = response.data;
    const meta = response.meta;
    const url = (0, $cbtbS.extractSmartLinkUrl)(response);
    return {
        actions: (0, $jMH4W.extractFlexibleCardActions)({
            actionOptions: actionOptions,
            aiSummaryConfig: aiSummaryConfig,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            product: product,
            rovoConfig: rovoConfig,
            response: response,
            url: props.url,
            isPreviewPanelAvailable: // Use the original URL in edge cases, such as short links for AI summary and copy link actions.
            isPreviewPanelAvailable,
            ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }),
        appliedToComponentsCount: (0, $4MxLD.extractAppliedToComponentsCount)(data),
        assignedToGroup: (0, $aDAi2.extractPersonAssignedToAsArray)(data),
        attachmentCount: (0, $llkoX.extractAttachmentCount)(data),
        authorGroup: (0, $9r6uU.extractSmartLinkAuthorGroup)(response),
        ownedByGroup: (0, $1sniP.extractPersonOwnedBy)(data),
        collaboratorGroup: (0, $c1aAh.extractPersonsUpdatedBy)(data),
        commentCount: (0, $1Ev4I.extractSmartLinkCommentCount)(response),
        viewCount: (0, $4bnJG.extractViewCount)(data),
        reactCount: (0, $usiaF.extractSmartLinkReactCount)(response),
        voteCount: (0, $85uGW.extractVoteCount)(data),
        checklistProgress: (0, $7mMuf.extractChecklistProgress)(data),
        createdBy: (0, $4SQG4.extractSmartLinkCreatedBy)(response),
        ownedBy: (0, $8FBNQ.extractOwnedBy)(data),
        assignedTo: (0, $7DN26.extractAssignedTo)(data),
        createdOn: (0, $eXjTm.extractSmartLinkCreatedOn)(response),
        dueOn: (0, $iWfWP.extractDueOn)(data),
        latestCommit: (0, $bSjVt.extractLatestCommit)(data),
        linkIcon: (0, $2TRbH.extractSmartLinkIcon)(response),
        linkTitle: (0, $dQzXs.default)(status, props.url, response, onClick, onAuxClick, onContextMenu),
        location: (0, $bPeBW.extractLocation)(data),
        modifiedBy: (0, $5gvOn.extractSmartLinkModifiedBy)(response),
        modifiedOn: (0, $fil80.extractSmartLinkModifiedOn)(response),
        preview: (0, $gE5Az.extractSmartLinkPreviewImage)(response),
        priority: (0, $6jPLy.default)(data),
        provider: (0, $4stHy.default)(response),
        programmingLanguage: (0, $k9JH8.extractProgrammingLanguage)(data),
        readTime: (0, $2M0BH.extractReadTime)(data),
        sentOn: (0, $biykc.extractSmartLinkSentOn)(response),
        snippet: (0, $hGTGd.extractSmartLinkSummary)(response) || undefined,
        // Explicitly set here to remove an empty string
        sourceBranch: (0, $4h7Pt.extractSourceBranch)(data),
        state: (0, $70s5w.default)(response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, (0, $dRkX9.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined),
        subscriberCount: (0, $dYCtJ.extractSubscriberCount)(data),
        subTasksProgress: (0, $7zETV.extractSubTasksProgress)(data),
        storyPoints: (0, $fM0PU.extractStoryPoints)(data),
        targetBranch: (0, $lmySn.extractTargetBranch)(data),
        userAttributes: (0, $1UoIz.extractUserAttributes)(data),
        teamMemberCount: (0, $7xqxz.extractTeamMemberCount)(data),
        url: url,
        ari: (0, $ghqH4.extractSmartLinkAri)(response),
        type: (0, $lOxou.extractType)(data),
        meta: {
            objectId: (0, $fZkbk.extractMetaObjectId)(meta),
            resourceType: (0, $rugWY.extractMetaResourceType)(meta),
            tenantId: (0, $krEI2.extractMetaTenantId)(meta)
        },
        hostName: (0, $k8J82.extractHostName)(response)
    };
};
var $ec30732445139ffa$export$2e2bcd8739ae039 = $ec30732445139ffa$var$extractFlexibleUiContext;

});
parcelRegister("ghqH4", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkAri", () => $623d96fac2c28924$export$16b02be3e2bb31ad);

var $exyMZ = parcelRequire("exyMZ");

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");
const $623d96fac2c28924$export$16b02be3e2bb31ad = (response)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity, _extractEntity2;
        return ((_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.ari) || ((_extractEntity2 = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity2 === void 0 ? void 0 : _extractEntity2.thirdPartyAri);
    }
    const data = response === null || response === void 0 ? void 0 : response.data;
    return (0, $exyMZ.extractAri)(data);
};

});

parcelRegister("9r6uU", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkAuthorGroup", () => $19fc6c83728f486e$export$41fc716e1bc2dc90);

var $YqY0I = parcelRequire("YqY0I");

var $52yzE = parcelRequire("52yzE");

var $6G8gX = parcelRequire("6G8gX");
const $19fc6c83728f486e$export$41fc716e1bc2dc90 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        const entity = (0, $YqY0I.extractEntity)(response);
        const owners = entity === null || entity === void 0 ? void 0 : entity.owners;
        if (owners) return owners.map((owner)=>({
                name: owner.displayName,
                src: owner.picture
            })).filter((item)=>!!item);
    }
    return (0, $52yzE.extractPersonCreatedBy)(response.data);
};

});
parcelRegister("52yzE", function(module, exports) {
$parcel$export(module.exports, "extractPersonCreatedBy", () => $5a736c29760d610b$export$a66235cba0c9d11a);

var $lzLGl = parcelRequire("lzLGl");
const $5a736c29760d610b$export$a66235cba0c9d11a = (jsonLd)=>{
    const attributedTo = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.attributedTo;
    if (attributedTo) {
        if (Array.isArray(attributedTo)) return attributedTo.map((0, $lzLGl.extractPersonFromJsonLd)).filter((item)=>!!item);
        else {
            const item = (0, $lzLGl.extractPersonFromJsonLd)(attributedTo);
            if (item) return [
                item
            ];
        }
    }
    return undefined;
};

});


parcelRegister("4SQG4", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCreatedBy", () => $1c49a6efa583258a$export$242875b46118beb2);

var $YqY0I = parcelRequire("YqY0I");

var $52yzE = parcelRequire("52yzE");

var $6G8gX = parcelRequire("6G8gX");
const $1c49a6efa583258a$export$242875b46118beb2 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 || (_extractEntity = _extractEntity.createdBy) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    const persons = (0, $52yzE.extractPersonCreatedBy)(response.data);
    return !!(persons !== null && persons !== void 0 && persons.length) ? persons[0].name : undefined;
};

});

parcelRegister("eXjTm", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCreatedOn", () => $d69aa495da8d69e6$export$7a685df468cbf38f);

var $jBgfx = parcelRequire("jBgfx");

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");
const $d69aa495da8d69e6$export$7a685df468cbf38f = (response)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $jBgfx.extractDateCreated)(response.data);
};

});
parcelRegister("jBgfx", function(module, exports) {
$parcel$export(module.exports, "extractDateCreated", () => $44d4ec4cbfe33a4b$export$e1226a5e0bbbf862);
const $44d4ec4cbfe33a4b$export$e1226a5e0bbbf862 = (jsonLd)=>{
    if (jsonLd !== null && jsonLd !== void 0 && jsonLd['schema:dateCreated']) return jsonLd['schema:dateCreated'];
    return undefined;
};

});


parcelRegister("5gvOn", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkModifiedBy", () => $55f02b5fb334267a$export$7f099a839071a190);

var $YqY0I = parcelRequire("YqY0I");

var $5ux4r = parcelRequire("5ux4r");

var $6G8gX = parcelRequire("6G8gX");
const $55f02b5fb334267a$export$7f099a839071a190 = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 || (_extractEntity = _extractEntity.lastUpdatedBy) === null || _extractEntity === void 0 ? void 0 : _extractEntity.displayName;
    }
    const person = (0, $5ux4r.extractPersonUpdatedBy)(response.data);
    return person ? person.name : undefined;
};

});
parcelRegister("5ux4r", function(module, exports) {
$parcel$export(module.exports, "extractPersonUpdatedBy", () => $aece812cf4835d24$export$8a2d1ed7e6f336f0);

var $lzLGl = parcelRequire("lzLGl");
const $aece812cf4835d24$export$8a2d1ed7e6f336f0 = (jsonLd)=>{
    const updatedBy = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd['atlassian:updatedBy'];
    if (updatedBy) return (0, $lzLGl.extractPersonFromJsonLd)(updatedBy);
    return undefined;
};

});


parcelRegister("fil80", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkModifiedOn", () => $0cf1582846933d83$export$75047940e157fd1f);

var $hbzj5 = parcelRequire("hbzj5");

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");
const $0cf1582846933d83$export$75047940e157fd1f = (response)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.lastUpdatedAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $hbzj5.extractDateUpdated)(response.data);
};

});
parcelRegister("hbzj5", function(module, exports) {
$parcel$export(module.exports, "extractDateUpdated", () => $1c38af2233df0e1a$export$7fc2f5e6f9d22ae7);
const $1c38af2233df0e1a$export$7fc2f5e6f9d22ae7 = (jsonLd)=>{
    if (jsonLd !== null && jsonLd !== void 0 && jsonLd.updated) return jsonLd.updated;
    return undefined;
};

});


parcelRegister("cbtbS", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkUrl", () => $241266911906abf6$export$7ba9b12c6a1b73de);

var $YqY0I = parcelRequire("YqY0I");

var $2r9K5 = parcelRequire("2r9K5");

var $6G8gX = parcelRequire("6G8gX");
const $241266911906abf6$export$7ba9b12c6a1b73de = (response)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.url;
    }
    return (0, $2r9K5.extractLink)(response === null || response === void 0 ? void 0 : response.data);
};

});

parcelRegister("hGTGd", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSummary", () => $67b77d935d943bcb$export$8c6b9b49f358840);

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");

var $3nvas = parcelRequire("3nvas");
const $67b77d935d943bcb$export$8c6b9b49f358840 = (response)=>{
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.description;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $3nvas.extractSummary)(response.data);
};

});
parcelRegister("3nvas", function(module, exports) {
$parcel$export(module.exports, "extractSummary", () => $58722107a0192235$export$db5a8500f6b6286e);
const $58722107a0192235$export$db5a8500f6b6286e = (jsonLd)=>{
    if (typeof (jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd.summary) === 'string') {
        const summary = jsonLd.summary.trim();
        return Boolean(summary) ? summary : undefined;
    }
};

});


parcelRegister("jMH4W", function(module, exports) {
$parcel$export(module.exports, "extractFlexibleCardActions", () => $b3eb9c81d88052d7$export$abe8d0ca1daa1755);

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $2vNtU = parcelRequire("2vNtU");

var $7newS = parcelRequire("7newS");

var $5jpQ6 = parcelRequire("5jpQ6");

var $f8D9t = parcelRequire("f8D9t");

var $hn52b = parcelRequire("hn52b");

var $oMMBT = parcelRequire("oMMBT");

var $95H2w = parcelRequire("95H2w");

var $fajly = parcelRequire("fajly");
const $b3eb9c81d88052d7$export$abe8d0ca1daa1755 = ({ actionOptions: actionOptions, aiSummaryConfig: aiSummaryConfig, appearance: appearance, fireEvent: fireEvent, id: id, origin: origin, product: product, response: response, rovoConfig: rovoConfig, transformUrl: transformUrl, url: url, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel })=>{
    const action = {
        [(0, $j9rqA.ActionName).CopyLinkAction]: (0, $5jpQ6.extractCopyLinkClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $j9rqA.ActionName).DownloadAction]: (0, $f8D9t.extractDownloadClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            response: response
        }),
        [(0, $j9rqA.ActionName).FollowAction]: (0, $hn52b.default)(response, actionOptions, id),
        [(0, $j9rqA.ActionName).PreviewAction]: (0, $oMMBT.extractPreviewClientAction)({
            actionOptions: actionOptions,
            appearance: appearance,
            fireEvent: fireEvent,
            id: id,
            origin: origin,
            response: response,
            isPreviewPanelAvailable: isPreviewPanelAvailable,
            ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
                isPreviewRestricted: isPreviewRestricted
            } : undefined,
            openPreviewPanel: openPreviewPanel,
            transformUrl: transformUrl
        }),
        [(0, $j9rqA.ActionName).AutomationAction]: (0, $7newS.extractAutomationAction)(response),
        [(0, $j9rqA.InternalActionName).AISummaryAction]: (0, $2vNtU.extractAISummaryAction)(response, url, actionOptions, aiSummaryConfig),
        [(0, $j9rqA.ActionName).RovoChatAction]: (0, $95H2w.default)({
            actionOptions: actionOptions,
            appearance: appearance,
            id: id,
            product: product,
            response: response,
            rovoConfig: rovoConfig
        }),
        [(0, $j9rqA.InternalActionName).ViewRelatedLinksAction]: (0, $fajly.extractViewRelatedLinksAction)(response)
    };
    return Object.values(action).some((value)=>Boolean(value)) ? action : undefined;
};

});
parcelRegister("2vNtU", function(module, exports) {
$parcel$export(module.exports, "extractAISummaryAction", () => $a146b8000778ddbb$export$e7f7a50a8b8932df);

var $j9rqA = parcelRequire("j9rqA");

var $g9TRl = parcelRequire("g9TRl");

var $jqXyW = parcelRequire("jqXyW");
const $a146b8000778ddbb$export$e7f7a50a8b8932df = (response, url, actionOptions, aiSummaryConfig)=>{
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).AISummaryAction, actionOptions) || !(0, $jqXyW.getIsAISummaryEnabled)(aiSummaryConfig === null || aiSummaryConfig === void 0 ? void 0 : aiSummaryConfig.isAdminHubAIEnabled, response) || !url) return;
    return {
        url: url
    };
};

});
parcelRegister("g9TRl", function(module, exports) {
$parcel$export(module.exports, "canShowAction", () => $8bdd6223f9f73b17$export$2487b058456cca75);
const $8bdd6223f9f73b17$export$2487b058456cca75 = (action, actionOptions)=>{
    var _actionOptions$exclud;
    if (typeof actionOptions === 'undefined') return true;
    if (actionOptions.hide || (_actionOptions$exclud = actionOptions.exclude) !== null && _actionOptions$exclud !== void 0 && _actionOptions$exclud.includes(action)) return false;
    return true;
};

});


parcelRegister("7newS", function(module, exports) {
$parcel$export(module.exports, "extractAutomationAction", () => $7abfdac230d56969$export$f913cc6abf3ec084);

var $j9rqA = parcelRequire("j9rqA");
const $7abfdac230d56969$export$f913cc6abf3ec084 = (response)=>{
    var _response$meta;
    if (!response.data) return undefined;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta = _response$meta.supportedFeature) !== null && _response$meta !== void 0 && _response$meta.includes((0, $j9rqA.ActionName).AutomationAction))) return undefined;
    const data = response.data;
    const meta = response.meta;
    const { name: name, 'atlassian:ari': objectAri } = data;
    const { product: product, tenantId: tenantId, resourceType: resourceType } = meta;
    return {
        product: product,
        resourceType: resourceType,
        siteAri: `ari:cloud:${product}::site/${tenantId}`,
        objectName: name,
        objectAri: objectAri,
        // TODO: The admin experience will be a follow up
        canManageAutomation: false,
        baseAutomationUrl: '',
        analyticsSource: 'smartCardAutomationAction'
    };
};

});

parcelRegister("5jpQ6", function(module, exports) {
$parcel$export(module.exports, "extractCopyLinkClientAction", () => $b41ab9e2088e4098$export$31ddd5c40039ce53);

var $h9HkQ = parcelRequire("h9HkQ");
const $b41ab9e2088e4098$export$31ddd5c40039ce53 = (param)=>{
    const invokeAction = (0, $h9HkQ.extractInvokeCopyLinkAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("h9HkQ", function(module, exports) {
$parcel$export(module.exports, "extractInvokeCopyLinkAction", () => $37813cafb896d060$export$5ec86886067a062d);

var $cbtbS = parcelRequire("cbtbS");

var $j9rqA = parcelRequire("j9rqA");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $jKScA = parcelRequire("jKScA");

var $g9TRl = parcelRequire("g9TRl");
const $37813cafb896d060$export$5ec86886067a062d = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).CopyLinkAction, actionOptions)) return;
    const url = (0, $cbtbS.extractSmartLinkUrl)(response);
    if (!url) return;
    return {
        actionFn: async ()=>navigator.clipboard.writeText(url),
        actionSubjectId: 'copyLink',
        actionType: (0, $j9rqA.ActionName).CopyLinkAction,
        definitionId: (0, $6ZxOX.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $96gGh.getExtensionKey)(response),
        id: id,
        resourceType: (0, $jKScA.getResourceType)(response)
    };
};

});


parcelRegister("f8D9t", function(module, exports) {
$parcel$export(module.exports, "extractDownloadClientAction", () => $61c3e04856860221$export$f6c386869a352b1f);

var $7EFx4 = parcelRequire("7EFx4");
const $61c3e04856860221$export$f6c386869a352b1f = (param)=>{
    const invokeAction = (0, $7EFx4.extractInvokeDownloadAction)(param);
    return invokeAction ? {
        invokeAction: invokeAction
    } : undefined;
};

});
parcelRegister("7EFx4", function(module, exports) {
$parcel$export(module.exports, "extractInvokeDownloadAction", () => $63c49a56777d5785$export$ea97cd34c2ca86de);

var $ktT39 = parcelRequire("ktT39");

var $j9rqA = parcelRequire("j9rqA");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $jKScA = parcelRequire("jKScA");

var $g9TRl = parcelRequire("g9TRl");

var $cCQ6r = parcelRequire("cCQ6r");

var $j1S0E = parcelRequire("j1S0E");
const $63c49a56777d5785$export$ea97cd34c2ca86de = ({ actionOptions: actionOptions, appearance: appearance, id: id, response: response })=>{
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).DownloadAction, actionOptions)) return;
    const data = response.data;
    const downloadActionExists = (0, $j1S0E.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'DownloadAction');
    if (downloadActionExists) {
        const downloadUrl = (0, $ktT39.extractSmartLinkDownloadUrl)(response);
        return {
            actionFn: async ()=>(0, $cCQ6r.downloadUrl)(downloadUrl),
            actionSubjectId: 'downloadDocument',
            actionType: (0, $j9rqA.ActionName).DownloadAction,
            definitionId: (0, $6ZxOX.getDefinitionId)(response),
            display: appearance,
            extensionKey: (0, $96gGh.getExtensionKey)(response),
            id: id,
            resourceType: (0, $jKScA.getResourceType)(response)
        };
    }
};

});
parcelRegister("ktT39", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkDownloadUrl", () => $1ddbdc4df579eba0$export$96ed4c1b14ac210a);

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");
const $1ddbdc4df579eba0$export$96ed4c1b14ac210a = (response)=>{
    var _response$data;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _entity$exportLinks;
        const entity = (0, $YqY0I.extractEntity)(response);
        return entity && 'exportLinks' in entity && Array.isArray(entity.exportLinks) && entity.exportLinks.length > 0 ? entity === null || entity === void 0 || (_entity$exportLinks = entity.exportLinks) === null || _entity$exportLinks === void 0 ? void 0 : _entity$exportLinks[0].url : undefined;
    }
    return response === null || response === void 0 || (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data['atlassian:downloadUrl'];
};

});

parcelRegister("cCQ6r", function(module, exports) {
$parcel$export(module.exports, "downloadUrl", () => $f12a66e786a90dc3$export$8a96edb1c96563f4);
const $f12a66e786a90dc3$export$8a96edb1c96563f4 = async (url)=>{
    if (!url) return;
    const isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    const iframeName = 'media-download-iframe';
    const link = document.createElement('a');
    let iframe = document.getElementById(iframeName);
    if (!iframe) {
        iframe = document.createElement('iframe');
        iframe.style.display = 'none';
        iframe.id = iframeName;
        iframe.name = iframeName;
        document.body.appendChild(iframe);
    }
    link.href = url;
    link.download = url;
    link.target = isIE11 || isSafari ? '_blank' : iframeName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

});

parcelRegister("j1S0E", function(module, exports) {
$parcel$export(module.exports, "getActionsFromJsonLd", () => $a4398fdebd4e0302$export$8f031784a3a03b23);
const $a4398fdebd4e0302$export$8f031784a3a03b23 = (jsonLd)=>{
    let actions = jsonLd && jsonLd['schema:potentialAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) actions = [
        actions
    ];
    return actions;
};

});



parcelRegister("hn52b", function(module, exports) {
$parcel$export(module.exports, "default", () => $31d3e9a432493372$export$2e2bcd8739ae039);

var $2r9K5 = parcelRequire("2r9K5");

var $lOxou = parcelRequire("lOxou");

var $eq2cZ = parcelRequire("eq2cZ");

var $j9rqA = parcelRequire("j9rqA");

var $96gGh = parcelRequire("96gGh");

var $g9TRl = parcelRequire("g9TRl");

var $90lSx = parcelRequire("90lSx");
const $31d3e9a432493372$var$extractFollowAction = (response, actionOptions, id)=>{
    var _action$dataUpdateAct;
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).FollowAction, actionOptions)) return;
    const extensionKey = (0, $96gGh.getExtensionKey)(response);
    const data = response === null || response === void 0 ? void 0 : response.data;
    const actions = (0, $90lSx.default)(data);
    const type = (0, $lOxou.extractType)(data);
    const isProject = type === null || type === void 0 ? void 0 : type.includes('atlassian:Project');
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>{
        if ((item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction') {
            var _dataUpdateAction;
            const actionName = item === null || item === void 0 || (_dataUpdateAction = item.dataUpdateAction) === null || _dataUpdateAction === void 0 ? void 0 : _dataUpdateAction.name;
            return actionName === (0, $eq2cZ.SmartLinkActionType).FollowEntityAction || actionName === (0, $eq2cZ.SmartLinkActionType).UnfollowEntityAction;
        }
        return false;
    });
    if (!action || !action.resourceIdentifiers) return;
    const url = (0, $2r9K5.extractLink)(data);
    const reload = url ? {
        id: id,
        url: url
    } : undefined;
    const actionType = (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name;
    return {
        action: {
            action: {
                actionType: actionType,
                resourceIdentifiers: action.resourceIdentifiers
            },
            providerKey: extensionKey,
            reload: reload
        },
        value: actionType === (0, $eq2cZ.SmartLinkActionType).FollowEntityAction,
        isProject: isProject
    };
};
var $31d3e9a432493372$export$2e2bcd8739ae039 = $31d3e9a432493372$var$extractFollowAction;

});
parcelRegister("90lSx", function(module, exports) {
$parcel$export(module.exports, "default", () => $39d1c8a42300c0d6$export$2e2bcd8739ae039);
const $39d1c8a42300c0d6$var$extractServerAction = (data)=>{
    const actions = data === null || data === void 0 ? void 0 : data['atlassian:serverAction'];
    if (!actions) return [];
    if (actions && !Array.isArray(actions)) return [
        actions
    ];
    return actions;
};
var $39d1c8a42300c0d6$export$2e2bcd8739ae039 = $39d1c8a42300c0d6$var$extractServerAction;

});


parcelRegister("oMMBT", function(module, exports) {
$parcel$export(module.exports, "extractPreviewClientAction", () => $8a754d0024844ecf$export$9f0d9100b079448);

var $5knQT = parcelRequire("5knQT");
const $8a754d0024844ecf$export$9f0d9100b079448 = (param)=>{
    const result = (0, $5knQT.extractInvokePreviewAction)(param);
    return result ? result : undefined;
};

});
parcelRegister("5knQT", function(module, exports) {
$parcel$export(module.exports, "extractInvokePreviewAction", () => $20bc1c2f4c8353ae$export$caf83f49e52ac0bb);

var $juFVr = parcelRequire("juFVr");

var $ghqH4 = parcelRequire("ghqH4");

var $kSVgB = parcelRequire("kSVgB");

var $kzNPc = parcelRequire("kzNPc");

var $9b5Ea = parcelRequire("9b5Ea");

var $cbtbS = parcelRequire("cbtbS");

var $4UGyv = parcelRequire("4UGyv");

var $dRkX9 = parcelRequire("dRkX9");

var $aEmSo = parcelRequire("aEmSo");

var $j9rqA = parcelRequire("j9rqA");

var $96gGh = parcelRequire("96gGh");

var $g9TRl = parcelRequire("g9TRl");

var $1nhsP = parcelRequire("1nhsP");

var $2bNyC = parcelRequire("2bNyC");

var $8CG9h = parcelRequire("8CG9h");

var $kT5C7 = parcelRequire("kT5C7");

var $2TRbH = parcelRequire("2TRbH");

var $7EFx4 = parcelRequire("7EFx4");

var $V9qe1 = parcelRequire("V9qe1");
const $20bc1c2f4c8353ae$export$caf83f49e52ac0bb = (param)=>{
    var _extractPreviewData;
    const { actionOptions: actionOptions, appearance: display, fireEvent: fireEvent, onClose: onClose, id: id, origin: origin, response: response, isPreviewPanelAvailable: isPreviewPanelAvailable, isPreviewRestricted: isPreviewRestricted, openPreviewPanel: openPreviewPanel } = param;
    const ari = (0, $ghqH4.extractSmartLinkAri)(response);
    const url = (0, $cbtbS.extractSmartLinkUrl)(response);
    const name = (0, $9b5Ea.extractSmartLinkTitle)(response);
    const hasPreviewPanelParams = Boolean((0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && isPreviewPanelAvailable && openPreviewPanel && ari && url && name);
    const hasPreviewPanel = hasPreviewPanelParams && isPreviewPanelAvailable({
        ari: ari
    });
    const isInPreviewPanel = (0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && (0, $4UGyv.isWithinPreviewPanelIFrame)();
    const data = response.data;
    const meta = response.meta;
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).PreviewAction, actionOptions)) return;
    // Restricted (e.g. cross-unit) resources must not be previewed at all — suppress
    // the action so it does not fall back to a preview modal.
    if (ari && isPreviewRestricted !== null && isPreviewRestricted !== void 0 && isPreviewRestricted({
        ari: ari
    }) && (0, $dRkX9.fg)('preview_panel_unit_check')) return;
    /* Analytics UI event for preview action created to support tracking of preview actions as the experiment rolls out */ const firePreviewActionUIEvent = ({ previewType: previewType })=>{
        if (!(0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') || origin !== 'smartLinkPreviewHoverCard' || !fireEvent) return;
        fireEvent('ui.smartLink.clicked.previewHoverCard', {
            id: id || '',
            display: 'hoverCardPreview',
            previewType: previewType
        });
    };
    const src = (_extractPreviewData = (0, $juFVr.extractPreview)(data, 'web')) === null || _extractPreviewData === void 0 ? void 0 : _extractPreviewData.src;
    // disallow preview modals within preview panels
    if (!hasPreviewPanel && isInPreviewPanel) return;
    if (src) {
        const extensionKey = (0, $96gGh.getExtensionKey)(response);
        return {
            hasPreviewPanel: hasPreviewPanel,
            invokeAction: {
                actionFn: async ()=>{
                    if (hasPreviewPanel) {
                        var _extractSmartLinkEmbe;
                        let resolvedUrl = url;
                        if ((0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test')) {
                            const responseUrl = response.data && 'url' in response.data ? response.data.url : undefined;
                            resolvedUrl = responseUrl || url;
                        }
                        openPreviewPanel({
                            ari: ari,
                            url: resolvedUrl,
                            name: name,
                            iconUrl: undefined,
                            panelData: {
                                embedUrl: (0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') ? (_extractSmartLinkEmbe = (0, $kSVgB.extractSmartLinkEmbed)(response)) === null || _extractSmartLinkEmbe === void 0 ? void 0 : _extractSmartLinkEmbe.src : undefined
                            }
                        });
                        (0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'panel'
                        });
                    } else {
                        var _extractSmartLinkProv, _extractSmartLinkEmbe2, _actionOptions$previe, _actionOptions$previe2;
                        await (0, $1nhsP.openEmbedModal)({
                            fireEvent: fireEvent,
                            extensionKey: extensionKey,
                            id: id,
                            invokeDownloadAction: (0, $7EFx4.extractInvokeDownloadAction)(param),
                            invokeViewAction: (0, $V9qe1.extractInvokeViewAction)(param, true),
                            isSupportTheming: (0, $2bNyC.extractIsSupportTheming)(meta),
                            isTrusted: (0, $8CG9h.extractIsTrusted)(meta),
                            linkIcon: (0, $dRkX9.fg)('platform_lp_use_generator_icon_for_provider') ? (0, $2TRbH.extractSmartLinkIcon)(response) : (0, $kT5C7.extractLinkIcon)(response),
                            providerName: (_extractSmartLinkProv = (0, $kzNPc.extractSmartLinkProvider)(response)) === null || _extractSmartLinkProv === void 0 ? void 0 : _extractSmartLinkProv.text,
                            onClose: onClose,
                            origin: origin,
                            src: (_extractSmartLinkEmbe2 = (0, $kSVgB.extractSmartLinkEmbed)(response)) === null || _extractSmartLinkEmbe2 === void 0 ? void 0 : _extractSmartLinkEmbe2.src,
                            title: (0, $9b5Ea.extractSmartLinkTitle)(response),
                            url: url,
                            size: actionOptions === null || actionOptions === void 0 || (_actionOptions$previe = actionOptions.previewAction) === null || _actionOptions$previe === void 0 ? void 0 : _actionOptions$previe.size,
                            isBlanketHidden: actionOptions === null || actionOptions === void 0 || (_actionOptions$previe2 = actionOptions.previewAction) === null || _actionOptions$previe2 === void 0 ? void 0 : _actionOptions$previe2.hideBlanket,
                            ...(0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && {
                                isInPreviewPanel: isInPreviewPanel
                            }
                        });
                        (0, $aEmSo.expValEquals)('platform_hover_card_preview_panel', 'cohort', 'test') && firePreviewActionUIEvent({
                            previewType: 'modal'
                        });
                    }
                },
                actionSubjectId: 'invokePreviewScreen',
                actionType: (0, $j9rqA.ActionName).PreviewAction,
                display: display,
                extensionKey: extensionKey,
                id: id
            }
        };
    }
};

});
parcelRegister("4UGyv", function(module, exports) {
$parcel$export(module.exports, "isWithinPreviewPanelIFrame", () => $93fa6cfe7fd9d825$export$24def1b22639c691);

var $19Bo1 = parcelRequire("19Bo1");

var $fKhkY = parcelRequire("fKhkY");
const $93fa6cfe7fd9d825$export$24def1b22639c691 = ()=>{
    return (0, $19Bo1.isInIframe)() && (0, $fKhkY.isWithinPreviewPanel)();
};

});
parcelRegister("19Bo1", function(module, exports) {
$parcel$export(module.exports, "isInIframe", () => $2cb4d1477a55f4ed$export$9f140ed41af5108c);
/**
 * Checks if the current code is running inside an iframe.
 * @returns true if running in an iframe, false otherwise
 */ const $2cb4d1477a55f4ed$export$9f140ed41af5108c = ()=>{
    try {
        return window !== window.top;
    } catch  {
        // If we can't access window.top due to cross-origin restrictions, assume we're in an iframe
        return true;
    }
};

});

parcelRegister("fKhkY", function(module, exports) {
$parcel$export(module.exports, "isWithinPreviewPanel", () => $e507c58503bf94c9$export$f274fcef361fe59d);
/**
 * Utility functions for detecting iframe and preview panel contexts.
 * These utilities help components determine if they're running inside an iframe
 * or within a preview panel context.
 */ const $e507c58503bf94c9$var$PREVIEW_PANEL_INDICATORS = {
    EMBEDDED_SOURCE: 'embeddedConfluenceSource',
    PREVIEW_PANELS: 'previewPanels',
    CONFLUENCE_PAGE_PREVIEW: 'confluence-page-preview-panel'
};
const $e507c58503bf94c9$var$getUrlSearchParams = (url)=>{
    try {
        return new URLSearchParams(url);
    } catch  {
        return null;
    }
};
const $e507c58503bf94c9$var$hasPreviewPanelIndicators = (searchParams)=>{
    return searchParams.has($e507c58503bf94c9$var$PREVIEW_PANEL_INDICATORS.PREVIEW_PANELS) || searchParams.get($e507c58503bf94c9$var$PREVIEW_PANEL_INDICATORS.EMBEDDED_SOURCE) === $e507c58503bf94c9$var$PREVIEW_PANEL_INDICATORS.CONFLUENCE_PAGE_PREVIEW;
};
const $e507c58503bf94c9$export$f274fcef361fe59d = ()=>{
    try {
        const currentSearch = window.location.search;
        if (currentSearch) {
            const currentParams = $e507c58503bf94c9$var$getUrlSearchParams(currentSearch);
            if (currentParams && $e507c58503bf94c9$var$hasPreviewPanelIndicators(currentParams)) return true;
        }
        return false;
    } catch  {
        return false;
    }
};

});


parcelRegister("1nhsP", function(module, exports) {
$parcel$export(module.exports, "openEmbedModal", () => $1305c1ee121f22e9$export$7859f96cd8cff034);

var $fc4bM = parcelRequire("fc4bM");

var $bTkYf = parcelRequire("bTkYf");

var $dQotp = parcelRequire("dQotp");

var $8MaoS = parcelRequire("8MaoS");

var $dRkX9 = parcelRequire("dRkX9");
let $1305c1ee121f22e9$var$reactRoots = new WeakMap();
/** Mounts `element` into `mountPoint`: uses the React 18/19 `createRoot` API when `nike_r19_render_unmount` is on, else the legacy render path. */ const $1305c1ee121f22e9$var$renderToMountPoint = (element, mountPoint)=>{
    if ((0, $dRkX9.fg)('nike_r19_render_unmount')) {
        let root = $1305c1ee121f22e9$var$reactRoots.get(mountPoint);
        if (!root) {
            root = (0, $dQotp.createRoot)(mountPoint);
            $1305c1ee121f22e9$var$reactRoots.set(mountPoint, root);
        }
        root.render(element);
    } else (0, (/*@__PURE__*/$parcel$interopDefault($bTkYf))).render(element, mountPoint);
};
/** Unmounts the tree at `mountPoint`: uses `root.unmount()` when `nike_r19_render_unmount` is on, else the legacy unmount path. */ const $1305c1ee121f22e9$var$unmountFromMountPoint = (mountPoint)=>{
    if ((0, $dRkX9.fg)('nike_r19_render_unmount')) {
        const root = $1305c1ee121f22e9$var$reactRoots.get(mountPoint);
        if (root) {
            root.unmount();
            $1305c1ee121f22e9$var$reactRoots.delete(mountPoint);
        }
    } else (0, (/*@__PURE__*/$parcel$interopDefault($bTkYf))).unmountComponentAtNode(mountPoint);
};
const $1305c1ee121f22e9$var$IFRAME_NAME = 'twp-editor-preview-iframe';
const $1305c1ee121f22e9$var$POPUP_MOUNT_POINT_ID = 'twp-editor-preview-iframe';

async function $1305c1ee121f22e9$export$7859f96cd8cff034({ onClose: onClose = ()=>{}, ...props } = {}) {
    let popupMountPoint;
    popupMountPoint = document.getElementById($1305c1ee121f22e9$var$POPUP_MOUNT_POINT_ID);
    if (!popupMountPoint) {
        popupMountPoint = document.createElement('div');
        popupMountPoint.id = $1305c1ee121f22e9$var$POPUP_MOUNT_POINT_ID;
        popupMountPoint.setAttribute('data-testid', 'preview-modal');
        document.body.appendChild(popupMountPoint);
    }
    let Modal = await (parcelRequire("bzDp4"));
    $1305c1ee121f22e9$var$renderToMountPoint(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement((0, $8MaoS.default), {
        locale: "en"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($fc4bM))).createElement(Modal.default, {
        ...props,
        iframeName: $1305c1ee121f22e9$var$IFRAME_NAME,
        onClose: (_context)=>{
            if (popupMountPoint) $1305c1ee121f22e9$var$unmountFromMountPoint(popupMountPoint);
            if (onClose) onClose(_context);
        },
        showModal: true
    })), popupMountPoint);
}

});
parcelRegister("bzDp4", function(module, exports) {

var $9dnsd = parcelRequire("9dnsd");
module.exports = Promise.all([
    $9dnsd("aYb4i"),
    $9dnsd("dfpdo"),
    $9dnsd("bMKAA"),
    $9dnsd("lvnYq")
]).then(()=>parcelRequire('iq5vf'));

});
parcelRegister("9dnsd", function(module, exports) {
"use strict";

function $6b57856c7829fee2$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("5WWY2")).resolve(id));
}
module.exports = $6b57856c7829fee2$var$load;

});
parcelRegister("5WWY2", function(module, exports) {
$parcel$export(module.exports, "register", () => $45501c3954b19655$export$6503ec6e8aabbaf, (v) => $45501c3954b19655$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $45501c3954b19655$export$f7ad0328861e2f03, (v) => $45501c3954b19655$export$f7ad0328861e2f03 = v);
var $45501c3954b19655$export$6503ec6e8aabbaf;
var $45501c3954b19655$export$f7ad0328861e2f03;
"use strict";
var $45501c3954b19655$var$mapping = new Map();
function $45501c3954b19655$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$45501c3954b19655$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $45501c3954b19655$var$resolve(id) {
    var resolved = $45501c3954b19655$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$45501c3954b19655$export$6503ec6e8aabbaf = $45501c3954b19655$var$register;
$45501c3954b19655$export$f7ad0328861e2f03 = $45501c3954b19655$var$resolve;

});




parcelRegister("2bNyC", function(module, exports) {
$parcel$export(module.exports, "extractIsSupportTheming", () => $bccffd8476dfb5cb$export$38d755f52cdf4acb);

var $5zI23 = parcelRequire("5zI23");
const $bccffd8476dfb5cb$export$38d755f52cdf4acb = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && (0, $5zI23.PROVIDER_KEYS_WITH_THEMING).includes(meta.key));
};

});
parcelRegister("5zI23", function(module, exports) {
$parcel$export(module.exports, "CONFLUENCE_GENERATOR_ID", () => $417ae3c8ea231c41$export$cee224b5de4d6d66);
$parcel$export(module.exports, "JIRA_GENERATOR_ID", () => $417ae3c8ea231c41$export$f654d825189934a7);
$parcel$export(module.exports, "JIRA_TASK", () => $417ae3c8ea231c41$export$84a73a0383f58180);
$parcel$export(module.exports, "JIRA_SUB_TASK", () => $417ae3c8ea231c41$export$c6c83963a9378a67);
$parcel$export(module.exports, "JIRA_STORY", () => $417ae3c8ea231c41$export$58af3c426c111a6d);
$parcel$export(module.exports, "JIRA_BUG", () => $417ae3c8ea231c41$export$ac9898a63417219e);
$parcel$export(module.exports, "JIRA_EPIC", () => $417ae3c8ea231c41$export$54db5e3fb12e39cd);
$parcel$export(module.exports, "JIRA_INCIDENT", () => $417ae3c8ea231c41$export$2f54a5a217202c85);
$parcel$export(module.exports, "JIRA_SERVICE_REQUEST", () => $417ae3c8ea231c41$export$d097371052bfc411);
$parcel$export(module.exports, "JIRA_CHANGE", () => $417ae3c8ea231c41$export$efd9452ad16c6676);
$parcel$export(module.exports, "JIRA_PROBLEM", () => $417ae3c8ea231c41$export$2e7e70abb5d81f67);
$parcel$export(module.exports, "JIRA_CUSTOM_TASK_TYPE", () => $417ae3c8ea231c41$export$ce25cfc40b280dbc);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_THEMING", () => $417ae3c8ea231c41$export$fe44ce30fd8d131b);
$parcel$export(module.exports, "PROVIDER_KEYS_WITH_HOSTPRODUCT_CONTEXT", () => $417ae3c8ea231c41$export$3740f371d9ab7d4);
const $417ae3c8ea231c41$export$cee224b5de4d6d66 = 'https://www.atlassian.com/#Confluence';
const $417ae3c8ea231c41$export$f654d825189934a7 = 'https://www.atlassian.com/#Jira';
const $417ae3c8ea231c41$export$84a73a0383f58180 = 'JiraTask';
const $417ae3c8ea231c41$export$c6c83963a9378a67 = 'JiraSubTask';
const $417ae3c8ea231c41$export$58af3c426c111a6d = 'JiraStory';
const $417ae3c8ea231c41$export$ac9898a63417219e = 'JiraBug';
const $417ae3c8ea231c41$export$54db5e3fb12e39cd = 'JiraEpic';
const $417ae3c8ea231c41$export$2f54a5a217202c85 = 'JiraIncident';
const $417ae3c8ea231c41$export$d097371052bfc411 = 'JiraServiceRequest';
const $417ae3c8ea231c41$export$efd9452ad16c6676 = 'JiraChange';
const $417ae3c8ea231c41$export$2e7e70abb5d81f67 = 'JiraProblem';
const $417ae3c8ea231c41$export$ce25cfc40b280dbc = 'JiraCustomTaskType';
const $417ae3c8ea231c41$export$fe44ce30fd8d131b = [
    'jira-object-provider',
    'confluence-object-provider',
    'watermelon-object-provider',
    'legion-object-provider',
    'avpplatform-object-provider'
];
const $417ae3c8ea231c41$export$3740f371d9ab7d4 = [
    'avpplatform-object-provider'
];

});


parcelRegister("8CG9h", function(module, exports) {
$parcel$export(module.exports, "extractIsTrusted", () => $f6c5a58c0d3e0c91$export$4f3ffbb500daac5a);
const $f6c5a58c0d3e0c91$export$4f3ffbb500daac5a = (meta)=>{
    return Boolean((meta === null || meta === void 0 ? void 0 : meta.key) && meta.key !== 'iframely-object-provider');
};

});

parcelRegister("kT5C7", function(module, exports) {
$parcel$export(module.exports, "extractLinkIcon", () => $162a2d0858a99a33$export$43612bed147eae48);

var $gkUFy = parcelRequire("gkUFy");

var $j7KHa = parcelRequire("j7KHa");
const $162a2d0858a99a33$export$43612bed147eae48 = (response, renderers)=>{
    const data = response.data;
    const render = (0, $gkUFy.default)(data, renderers);
    return {
        ...(0, $j7KHa.default)(data),
        render: render
    };
};

});
parcelRegister("gkUFy", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ffba21207a92074$export$2e2bcd8739ae039);
const $8ffba21207a92074$var$sanitizeEmojiValue = (value)=>value && value.replace(/['"]+/g, '').replace(/null/, '') || '';
const $8ffba21207a92074$var$extractIconRenderer = (data, renderers)=>{
    const prefix = data['atlassian:titlePrefix'];
    if ((prefix === null || prefix === void 0 ? void 0 : prefix['@type']) === 'atlassian:Emoji') {
        const emojiId = $8ffba21207a92074$var$sanitizeEmojiValue(prefix['text']);
        const emojiRenderer = renderers === null || renderers === void 0 ? void 0 : renderers.emoji;
        if (emojiId && emojiRenderer) return ()=>emojiRenderer(emojiId);
    }
};
var $8ffba21207a92074$export$2e2bcd8739ae039 = $8ffba21207a92074$var$extractIconRenderer;

});

parcelRegister("j7KHa", function(module, exports) {
$parcel$export(module.exports, "default", () => $d952e1b98a959caf$export$2e2bcd8739ae039);

var $j9rqA = parcelRequire("j9rqA");

var $dGpse = parcelRequire("dGpse");

var $abiNE = parcelRequire("abiNE");

var $j40rd = parcelRequire("j40rd");

var $5zI23 = parcelRequire("5zI23");

var $cxzV2 = parcelRequire("cxzV2");

var $h7pZU = parcelRequire("h7pZU");

var $fBSA8 = parcelRequire("fBSA8");

var $6dr4w = parcelRequire("6dr4w");

var $f1418 = parcelRequire("f1418");
const $d952e1b98a959caf$var$extractTask = (data)=>{
    const { id: id, icon: url, name: name } = (0, $j40rd.extractTaskType)(data) || {};
    const taskType = id === null || id === void 0 ? void 0 : id.split('#').pop();
    const taskIconLabel = (name === null || name === void 0 ? void 0 : name.trim()) || 'Task';
    const taskIcon = url ? {
        label: taskIconLabel,
        url: url
    } : undefined;
    return {
        taskType: taskType,
        taskIcon: taskIcon
    };
};
const $d952e1b98a959caf$var$extractType = (jsonLd)=>{
    const type = jsonLd['@type'];
    return Array.isArray(type) ? type.sort((a, b)=>(0, $abiNE.extractorPriorityMap)[b] - (0, $abiNE.extractorPriorityMap)[a])[0] : type;
};
const $d952e1b98a959caf$var$isJiraProvider = (provider)=>provider === (0, $5zI23.JIRA_GENERATOR_ID);
function $d952e1b98a959caf$var$chooseIcon({ type: type, data: data, providerIcon: providerIcon }) {
    var _data$generator;
    const providerId = (_data$generator = data.generator) === null || _data$generator === void 0 ? void 0 : _data$generator['@id'];
    const fileFormat = data === null || data === void 0 ? void 0 : data['schema:fileFormat'];
    const fileFormatIcon = (0, $h7pZU.default)(fileFormat);
    const iconDescriptor = $d952e1b98a959caf$var$typeToIconDescriptor({
        type: type,
        providerId: providerId,
        data: data
    });
    const extractedDocumentTypeIcon = (0, $cxzV2.default)(type, providerId);
    const documentTypeIcon = iconDescriptor || extractedDocumentTypeIcon;
    const urlIcon = (0, $f1418.default)(data.icon, documentTypeIcon === null || documentTypeIcon === void 0 ? void 0 : documentTypeIcon.label);
    return (0, $dGpse.prioritiseIcon)({
        fileFormatIcon: fileFormatIcon,
        documentTypeIcon: documentTypeIcon,
        urlIcon: urlIcon,
        providerIcon: providerIcon
    });
}
function $d952e1b98a959caf$var$typeToIconDescriptor({ type: type, providerId: providerId, data: data }) {
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(type){
        case 'atlassian:Goal':
            return getIconDescriptor((0, $j9rqA.IconType).Task, 'goal');
        case 'atlassian:Project':
            // FIXME: atlassian:Project seem to be returned for many things, including Confluence space or Trello board,
            // But `IconType.Project` actual value is `BitBucket:Project`!
            return getIconDescriptor((0, $j9rqA.IconType).Project, 'project');
        case 'atlassian:SourceCodeCommit':
            return getIconDescriptor((0, $j9rqA.IconType).Commit, 'commit');
        case 'atlassian:SourceCodePullRequest':
            return getIconDescriptor((0, $j9rqA.IconType).PullRequest, 'pull request');
        case 'atlassian:SourceCodeReference':
            return getIconDescriptor((0, $j9rqA.IconType).Branch, 'branch');
        case 'atlassian:SourceCodeRepository':
            return getIconDescriptor((0, $j9rqA.IconType).Repo, 'repository');
        case 'atlassian:Task':
            const taskIconDescriptor = {
                icon: (0, $j9rqA.IconType).Task,
                label: 'task'
            };
            if ($d952e1b98a959caf$var$isJiraProvider(providerId)) {
                const { taskType: taskType, taskIcon: taskIcon } = $d952e1b98a959caf$var$extractTask(data);
                return taskType === 'JiraCustomTaskType' ? taskIcon || taskIconDescriptor : (0, $fBSA8.default)(taskType);
            }
            return taskIconDescriptor;
        default:
            return undefined;
    }
}
/**
 * Return the icon object given a JSON-LD data object.
 */ const $d952e1b98a959caf$var$extractJsonldDataIcon = (data)=>{
    const type = $d952e1b98a959caf$var$extractType(data);
    const providerIcon = (0, $6dr4w.default)(data);
    return $d952e1b98a959caf$var$chooseIcon({
        type: type,
        data: data,
        providerIcon: providerIcon
    });
};
var $d952e1b98a959caf$export$2e2bcd8739ae039 = $d952e1b98a959caf$var$extractJsonldDataIcon;

});
parcelRegister("dGpse", function(module, exports) {
$parcel$export(module.exports, "prioritiseIcon", () => $69e627878b42c01f$export$65e47eb22a387a86);
/**
 * Options required to prioritise which icon to show
 */ function $69e627878b42c01f$export$65e47eb22a387a86({ fileFormatIcon: fileFormatIcon, documentTypeIcon: documentTypeIcon, urlIcon: urlIcon, providerIcon: providerIcon }) {
    return urlIcon || fileFormatIcon || documentTypeIcon || providerIcon;
}

});

parcelRegister("abiNE", function(module, exports) {
$parcel$export(module.exports, "extractorPriorityMap", () => $ea7d3d90cf720214$export$e0deaeb4a2dfe2b4);
const $ea7d3d90cf720214$export$e0deaeb4a2dfe2b4 = {
    Object: 0,
    Document: 5,
    'schema:TextDigitalDocument': 10,
    'schema:DigitalDocument': 10,
    'schema:BlogPosting': 10,
    'schema:SpreadsheetDigitalDocument': 10,
    'schema:PresentationDigitalDocument': 10,
    'atlassian:Goal': 10,
    'atlassian:Task': 10,
    'atlassian:Project': 10,
    'atlassian:Template': 10,
    'atlassian:SourceCodeCommit': 10,
    'atlassian:SourceCodeRepository': 10,
    'atlassian:SourceCodePullRequest': 10,
    'atlassian:SourceCodeReference': 10,
    'atlassian:UndefinedLink': 10
};

});

parcelRegister("j40rd", function(module, exports) {
$parcel$export(module.exports, "extractTaskType", () => $5a98c3c08ac4fc92$export$ed3fd59180514d27);

var $6Hxqo = parcelRequire("6Hxqo");
const $5a98c3c08ac4fc92$export$ed3fd59180514d27 = (jsonLd)=>{
    // TODO: Remove once Jira migrate to the correct type.
    const taskType = jsonLd['atlassian:taskType'] || jsonLd.taskType;
    if (taskType) {
        if (typeof taskType === 'string') return {
            id: taskType
        };
        else if (taskType['@type'] === 'Link') return {
            id: taskType.href
        };
        else return {
            id: taskType['@id'],
            name: taskType.name,
            icon: taskType.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(taskType.icon)
        };
    }
};

});

parcelRegister("cxzV2", function(module, exports) {
$parcel$export(module.exports, "default", () => $f8d4210ede586d14$export$2e2bcd8739ae039);

var $kOAZg = parcelRequire("kOAZg");

var $j9rqA = parcelRequire("j9rqA");
/**
 * Computes the relevant icon for a document type.
 *
 * @remark Note that document icons can vary based on the provider. E.g., a
 * provider may choose to re-use one of these document types in their domain,
 * but offer a different SVG icon on the frontend (to map to this type in their
 * domain). See `schema:digitalDocument` for an example of this behaviour. This
 * mechanism will be superseded by backend-driven icon URLs as part of
 * go/j/MODES-5864. Do not add more!
 *
 * @param documentType JSON-LD document type
 * @param providerId JSON-LD provider (generator ID)
 * @returns an icon descriptor representing the document type
 */ const $f8d4210ede586d14$var$extractDocumentTypeIcon = (documentType, providerId)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(documentType){
        case 'schema:BlogPosting':
            return getIconDescriptor((0, $j9rqA.IconType).Blog, 'blog');
        case 'schema:DigitalDocument':
            if (providerId && (0, $kOAZg.isConfluenceGenerator)(providerId)) return getIconDescriptor((0, $j9rqA.IconType).LiveDocument, 'live document');
            else return getIconDescriptor((0, $j9rqA.IconType).File, 'file');
        case 'schema:TextDigitalDocument':
            return getIconDescriptor((0, $j9rqA.IconType).Document, 'document');
        case 'schema:PresentationDigitalDocument':
            return getIconDescriptor((0, $j9rqA.IconType).Presentation, 'presentation');
        case 'schema:SpreadsheetDigitalDocument':
            return getIconDescriptor((0, $j9rqA.IconType).Spreadsheet, 'spreadsheet');
        case 'atlassian:Template':
            return getIconDescriptor((0, $j9rqA.IconType).Template, 'template');
        case 'atlassian:UndefinedLink':
            return getIconDescriptor((0, $j9rqA.IconType).Document, 'document');
        default:
            return undefined;
    }
};
var $f8d4210ede586d14$export$2e2bcd8739ae039 = $f8d4210ede586d14$var$extractDocumentTypeIcon;

});
parcelRegister("kOAZg", function(module, exports) {
$parcel$export(module.exports, "isConfluenceGenerator", () => $4b452326ef550c52$export$38df542ff03a4183);

var $2IY91 = parcelRequire("2IY91");
const $4b452326ef550c52$export$38df542ff03a4183 = (id)=>{
    return id === (0, $2IY91.CONFLUENCE_GENERATOR_ID);
};

});


parcelRegister("h7pZU", function(module, exports) {
$parcel$export(module.exports, "default", () => $d40e0d8db3a68342$export$2e2bcd8739ae039);

var $j9rqA = parcelRequire("j9rqA");
const $d40e0d8db3a68342$var$extractFileFormatIcon = (fileFormat)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(fileFormat){
        // Generic documents
        case 'folder':
            return getIconDescriptor((0, $j9rqA.IconType).Folder, 'folder');
        case 'text/plain':
        case 'application/vnd.oasis.opendocument.text':
        case 'application/vnd.apple.pages':
            return getIconDescriptor((0, $j9rqA.IconType).Document, 'document');
        case 'application/pdf':
            return getIconDescriptor((0, $j9rqA.IconType).PDF, 'pdf');
        case 'application/vnd.oasis.opendocument.presentation':
        case 'application/vnd.apple.keynote':
            return getIconDescriptor((0, $j9rqA.IconType).Presentation, 'presentation');
        case 'application/vnd.oasis.opendocument.spreadsheet':
        case 'application/vnd.apple.numbers':
            return getIconDescriptor((0, $j9rqA.IconType).Spreadsheet, 'spreadsheet');
        // Google Drive
        case 'application/vnd.google-apps.document':
            return getIconDescriptor((0, $j9rqA.IconType).GoogleDocs, 'google document');
        case 'application/vnd.google-apps.form':
            return getIconDescriptor((0, $j9rqA.IconType).GoogleForms, 'google form');
        case 'application/vnd.google-apps.spreadsheet':
            return getIconDescriptor((0, $j9rqA.IconType).GoogleSheets, 'google sheet');
        case 'application/vnd.google-apps.presentation':
            return getIconDescriptor((0, $j9rqA.IconType).GoogleSlides, 'google slide');
        // Microsoft
        case 'application/vnd.ms-excel':
        case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
            return getIconDescriptor((0, $j9rqA.IconType).MSExcel, 'excel spreadsheet');
        case 'application/vnd.ms-powerpoint':
        case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
            return getIconDescriptor((0, $j9rqA.IconType).MSPowerpoint, 'powerpoint');
        case 'application/msword':
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return getIconDescriptor((0, $j9rqA.IconType).MSWord, 'word document');
        case 'image/png':
        case 'image/jpeg':
        case 'image/bmp':
        case 'image/webp':
        case 'image/svg+xml':
            return getIconDescriptor((0, $j9rqA.IconType).Image, 'image');
        case 'image/gif':
            return getIconDescriptor((0, $j9rqA.IconType).GIF, 'gif');
        case 'audio/midi':
        case 'audio/mpeg':
        case 'audio/webm':
        case 'audio/ogg':
        case 'audio/wav':
            return getIconDescriptor((0, $j9rqA.IconType).Audio, 'audio');
        case 'video/mp4':
        case 'video/quicktime':
        case 'video/mov':
        case 'video/webm':
        case 'video/ogg':
        case 'video/x-ms-wmv':
        case 'video/x-msvideo':
            return getIconDescriptor((0, $j9rqA.IconType).Video, 'video');
        // Others
        case 'text/css':
        case 'text/html':
        case 'application/javascript':
            return getIconDescriptor((0, $j9rqA.IconType).Code, 'code');
        case 'application/zip':
        case 'application/x-tar':
        case 'application/x-gtar':
        case 'application/x-7z-compressed':
        case 'application/x-apple-diskimage':
        case 'application/vnd.rar':
            return getIconDescriptor((0, $j9rqA.IconType).Archive, 'archive');
        case 'application/dmg':
            return getIconDescriptor((0, $j9rqA.IconType).Executable, 'disk image');
        case 'application/sketch':
            return getIconDescriptor((0, $j9rqA.IconType).Sketch, 'sketch');
        case 'application/octet-stream':
            return getIconDescriptor((0, $j9rqA.IconType).Generic, 'file');
        case 'application/invision.prototype':
            return getIconDescriptor((0, $j9rqA.IconType).Generic, 'file');
        default:
            return undefined;
    }
};
var $d40e0d8db3a68342$export$2e2bcd8739ae039 = $d40e0d8db3a68342$var$extractFileFormatIcon;

});

parcelRegister("fBSA8", function(module, exports) {
$parcel$export(module.exports, "default", () => $4c5dc09486f3f731$export$2e2bcd8739ae039);

var $j9rqA = parcelRequire("j9rqA");
const $4c5dc09486f3f731$var$extractJiraTaskIcon = (taskType)=>{
    const getIconDescriptor = (icon, label)=>({
            icon: icon,
            label: label
        });
    switch(taskType){
        case 'JiraBug':
            return getIconDescriptor((0, $j9rqA.IconType).Bug, 'Bug');
        case 'JiraChange':
            return getIconDescriptor((0, $j9rqA.IconType).Change, 'Change');
        case 'JiraEpic':
            return getIconDescriptor((0, $j9rqA.IconType).Epic, 'Epic');
        case 'JiraIncident':
            return getIconDescriptor((0, $j9rqA.IconType).Incident, 'Incident');
        case 'JiraProblem':
            return getIconDescriptor((0, $j9rqA.IconType).Problem, 'Problem');
        case 'JiraServiceRequest':
            return getIconDescriptor((0, $j9rqA.IconType).ServiceRequest, 'Service request');
        case 'JiraStory':
            return getIconDescriptor((0, $j9rqA.IconType).Story, 'Story');
        case 'JiraSubTask':
            return getIconDescriptor((0, $j9rqA.IconType).SubTask, 'Sub-task');
        case 'JiraTask':
        default:
            return getIconDescriptor((0, $j9rqA.IconType).Task, 'Task');
    }
};
var $4c5dc09486f3f731$export$2e2bcd8739ae039 = $4c5dc09486f3f731$var$extractJiraTaskIcon;

});

parcelRegister("6dr4w", function(module, exports) {
$parcel$export(module.exports, "default", () => $8e4e457f4b068980$export$2e2bcd8739ae039);

var $4Dem6 = parcelRequire("4Dem6");

var $j9rqA = parcelRequire("j9rqA");

var $5zI23 = parcelRequire("5zI23");

var $f1418 = parcelRequire("f1418");
/**
 * Extracts the provider icon and label from the given JSON-LD data.
 *
 * If the data is from Confluence, the icon will be the Confluence icon and the label will be 'Confluence'.
 * If the data is from Jira, the icon will be the Jira icon and the label will be 'Jira'.
 * If the data is from another provider, the icon and label will be extracted from the generator object.
 *
 * @param data - The JSON-LD data to extract the provider icon and label from.
 * @returns IconDescriptor with optional icon string name, url and label, or `undefined` if the data is not provided.
 */ const $8e4e457f4b068980$var$extractProviderIcon = (data)=>{
    if (!data) return undefined;
    const generator = data.generator;
    const provider = generator === null || generator === void 0 ? void 0 : generator['@id'];
    const icon = generator === null || generator === void 0 ? void 0 : generator.icon;
    const label = (generator === null || generator === void 0 ? void 0 : generator.name) || (0, $4Dem6.extractTitle)(data);
    if (provider === (0, $5zI23.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $j9rqA.IconType).Confluence,
        label: label || 'Confluence'
    };
    if (provider === (0, $5zI23.JIRA_GENERATOR_ID)) return {
        icon: (0, $j9rqA.IconType).Jira,
        label: label || 'Jira'
    };
    return (0, $f1418.default)(icon, label);
};
var $8e4e457f4b068980$export$2e2bcd8739ae039 = $8e4e457f4b068980$var$extractProviderIcon;

});
parcelRegister("f1418", function(module, exports) {
$parcel$export(module.exports, "default", () => $4cf5c55c5df24c68$export$2e2bcd8739ae039);

var $6Hxqo = parcelRequire("6Hxqo");
/**
 * Extracts the URL icon from the given icon or link object.
 *
 * @param icon - The icon or link object from which to extract the URL icon.
 * @param label - The label for the URL icon.
 * @returns IconDescriptor, which will contain label and url, or undefined
 */ const $4cf5c55c5df24c68$var$extractUrlIcon = (icon, label)=>{
    const url = icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(icon);
    return url ? {
        label: label,
        url: url
    } : undefined;
};
var $4cf5c55c5df24c68$export$2e2bcd8739ae039 = $4cf5c55c5df24c68$var$extractUrlIcon;

});




parcelRegister("2TRbH", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkIcon", () => $dea833126f5fe1fc$export$35040aed9264b11c);

var $2okdt = parcelRequire("2okdt");

var $6G8gX = parcelRequire("6G8gX");

var $kT5C7 = parcelRequire("kT5C7");
const $dea833126f5fe1fc$export$35040aed9264b11c = (response, renderers)=>{
    if (!response || !(response !== null && response !== void 0 && response.data)) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        const entityIcon = (0, $2okdt.extractEntityIcon)(response);
        if (entityIcon) return entityIcon;
    }
    return (0, $kT5C7.extractLinkIcon)(response, renderers);
};

});

parcelRegister("V9qe1", function(module, exports) {
$parcel$export(module.exports, "extractInvokeViewAction", () => $1ecf90c2658a626c$export$88c5813cfbbe4e4c);

var $2r9K5 = parcelRequire("2r9K5");

var $j9rqA = parcelRequire("j9rqA");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $jKScA = parcelRequire("jKScA");

var $g9TRl = parcelRequire("g9TRl");

var $970fo = parcelRequire("970fo");

var $j1S0E = parcelRequire("j1S0E");
const $1ecf90c2658a626c$export$88c5813cfbbe4e4c = ({ actionOptions: actionOptions, appearance: appearance, transformUrl: transformUrl, id: id, response: response }, force)=>{
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).ViewAction, actionOptions)) return;
    const data = response.data;
    if (!data) return;
    const url = (0, $2r9K5.extractLink)(data);
    const viewActionExists = (0, $j1S0E.getActionsFromJsonLd)(data).find((action)=>action['@type'] === 'ViewAction');
    if (url && (viewActionExists || force)) return {
        actionFn: async ()=>{
            const destinationUrl = (transformUrl === null || transformUrl === void 0 ? void 0 : transformUrl(url)) ?? url;
            return (0, $970fo.openUrl)(destinationUrl);
        },
        actionSubjectId: 'shortcutGoToLink',
        actionType: 'ViewAction',
        definitionId: (0, $6ZxOX.getDefinitionId)(response),
        display: appearance,
        extensionKey: (0, $96gGh.getExtensionKey)(response),
        id: id,
        resourceType: (0, $jKScA.getResourceType)(response)
    };
};

});
parcelRegister("970fo", function(module, exports) {
$parcel$export(module.exports, "openUrl", () => $4d698853732cbfad$export$a238cfe4a10e6279);
const $4d698853732cbfad$export$a238cfe4a10e6279 = async (url)=>{
    if (!url) return;
    window.open(url, '_blank', 'noopener=yes');
};

});




parcelRegister("95H2w", function(module, exports) {
$parcel$export(module.exports, "default", () => $bb230d0d18ee9930$export$2e2bcd8739ae039);

var $cbtbS = parcelRequire("cbtbS");

var $j9rqA = parcelRequire("j9rqA");

var $6ZxOX = parcelRequire("6ZxOX");

var $96gGh = parcelRequire("96gGh");

var $jKScA = parcelRequire("jKScA");

var $g9TRl = parcelRequire("g9TRl");

var $f4Od9 = parcelRequire("f4Od9");
const $bb230d0d18ee9930$var$extractRovoChatAction = ({ actionOptions: actionOptions, appearance: appearance, id: id, product: product, response: response, rovoConfig: rovoConfig })=>{
    var _actionOptions$rovoCh;
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).RovoChatAction, actionOptions)) return;
    const isRovoChatEnabled = (0, $f4Od9.getIsRovoChatEnabled)(rovoConfig === null || rovoConfig === void 0 ? void 0 : rovoConfig.rovoOptions);
    if (!isRovoChatEnabled) return;
    const extensionKey = (0, $96gGh.getExtensionKey)(response);
    const url = (0, $cbtbS.extractSmartLinkUrl)(response);
    return actionOptions !== null && actionOptions !== void 0 && (_actionOptions$rovoCh = actionOptions.rovoChatAction) !== null && _actionOptions$rovoCh !== void 0 && _actionOptions$rovoCh.optIn ? {
        invokeAction: {
            actionSubjectId: 'rovoChatPrompt',
            actionType: (0, $j9rqA.ActionName).RovoChatAction,
            definitionId: (0, $6ZxOX.getDefinitionId)(response),
            display: appearance,
            extensionKey: extensionKey,
            id: id,
            resourceType: (0, $jKScA.getResourceType)(response)
        },
        product: product,
        url: url
    } : undefined;
};
var $bb230d0d18ee9930$export$2e2bcd8739ae039 = $bb230d0d18ee9930$var$extractRovoChatAction;

});

parcelRegister("fajly", function(module, exports) {
$parcel$export(module.exports, "extractViewRelatedLinksAction", () => $3e54c55147879455$export$debae7424a0231b9);

var $ghqH4 = parcelRequire("ghqH4");
const $3e54c55147879455$export$debae7424a0231b9 = (response)=>{
    var _response$meta;
    if (!(response !== null && response !== void 0 && (_response$meta = response.meta) !== null && _response$meta !== void 0 && (_response$meta = _response$meta.supportedFeature) !== null && _response$meta !== void 0 && _response$meta.includes('RelatedLinks'))) return;
    const ari = (0, $ghqH4.extractSmartLinkAri)(response);
    if (!ari) return;
    return {
        ari: ari
    };
};

});


parcelRegister("c1aAh", function(module, exports) {
$parcel$export(module.exports, "extractPersonsUpdatedBy", () => $2ef77e567f7f5aa1$export$216e4f6aa7c169b8);

var $5ZWE6 = parcelRequire("5ZWE6");

var $lzLGl = parcelRequire("lzLGl");
const $2ef77e567f7f5aa1$export$216e4f6aa7c169b8 = (jsonLd)=>{
    if (jsonLd['@type'] === 'atlassian:Project') {
        const members = (0, $5ZWE6.extractMembers)(jsonLd);
        if (members && members.length !== 0) return members;
    }
    const updatedBy = jsonLd['atlassian:updatedBy'];
    if (updatedBy) {
        const extractedPersons = (0, $lzLGl.extractPersonFromJsonLd)(updatedBy);
        return extractedPersons ? [
            extractedPersons
        ] : undefined;
    }
};

});
parcelRegister("5ZWE6", function(module, exports) {
$parcel$export(module.exports, "extractMembers", () => $4e08d12b21aac8f7$export$6281d080d62a0719);

var $lzLGl = parcelRequire("lzLGl");
const $4e08d12b21aac8f7$export$6281d080d62a0719 = (jsonLd)=>{
    const members = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd['atlassian:member'];
    if (members) {
        if (typeof members === 'string') throw Error('Link[atlassian:members] must be an array or object.');
        else if (members.hasOwnProperty('totalItems')) {
            const collection = members;
            if (collection.items) return collection.items.map((member)=>(0, $lzLGl.extractPersonFromJsonLd)(member)).filter((member)=>!!member);
        } else {
            const memberItem = members;
            const memberItemForLink = (0, $lzLGl.extractPersonFromJsonLd)(memberItem);
            if (memberItemForLink) return [
                memberItemForLink
            ];
        }
    }
    return undefined;
};

});


parcelRegister("4MxLD", function(module, exports) {
$parcel$export(module.exports, "extractAppliedToComponentsCount", () => $ddcf178f65010ca3$export$4356c594f5c138d6);

var $T8dR3 = parcelRequire("T8dR3");
const $ddcf178f65010ca3$export$4356c594f5c138d6 = (data)=>(0, $T8dR3.extractValue)(data, 'atlassian:appliedToComponentsCount');

});
parcelRegister("T8dR3", function(module, exports) {
$parcel$export(module.exports, "extractValue", () => $de9db01e685bf941$export$e66823f955487935);
const $de9db01e685bf941$export$e66823f955487935 = (data, key)=>{
    return data === null || data === void 0 ? void 0 : data[key];
};

});


parcelRegister("7DN26", function(module, exports) {
$parcel$export(module.exports, "extractAssignedTo", () => $b693ffbf1fbb5c03$export$5546969a505305);

var $7yJN7 = parcelRequire("7yJN7");
const $b693ffbf1fbb5c03$export$5546969a505305 = (data)=>{
    const person = (0, $7yJN7.extractPersonAssignedTo)(data);
    if (person) return person.name;
};

});
parcelRegister("7yJN7", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedTo", () => $6a48525cbce0017c$export$38a0979ebf273662);

var $lzLGl = parcelRequire("lzLGl");
const $6a48525cbce0017c$export$38a0979ebf273662 = (jsonLd)=>{
    const assignedTo = jsonLd === null || jsonLd === void 0 ? void 0 : jsonLd['atlassian:assignedTo'];
    if (assignedTo) return (0, $lzLGl.extractPersonFromJsonLd)(assignedTo);
    return undefined;
};

});


parcelRegister("llkoX", function(module, exports) {
$parcel$export(module.exports, "extractAttachmentCount", () => $38f96731ef7b648a$export$65362ff78a97fd8);

var $T8dR3 = parcelRequire("T8dR3");
const $38f96731ef7b648a$export$65362ff78a97fd8 = (data)=>(0, $T8dR3.extractValue)(data, 'atlassian:attachmentCount');

});

parcelRegister("7mMuf", function(module, exports) {
$parcel$export(module.exports, "extractChecklistProgress", () => $79047c78bdfb6583$export$dd980f9881b65d9c);

var $T8dR3 = parcelRequire("T8dR3");
const $79047c78bdfb6583$export$dd980f9881b65d9c = (data)=>{
    const checkItemsObj = (0, $T8dR3.extractValue)(data, 'atlassian:checkItems');
    return checkItemsObj ? `${checkItemsObj.checkedItems}/${checkItemsObj.totalItems}` : undefined;
};

});

parcelRegister("iWfWP", function(module, exports) {
$parcel$export(module.exports, "extractDueOn", () => $ff036d51aefa3d69$export$ac56bd7a37249b48);

var $T8dR3 = parcelRequire("T8dR3");
const $ff036d51aefa3d69$export$ac56bd7a37249b48 = (data)=>(0, $T8dR3.extractValue)(data, 'endTime');

});

parcelRegister("k8J82", function(module, exports) {
$parcel$export(module.exports, "extractHostName", () => $4c573be6dbc3a9a4$export$f222ff3355b608d8);

var $cbtbS = parcelRequire("cbtbS");
const $4c573be6dbc3a9a4$export$f222ff3355b608d8 = (response)=>{
    try {
        const url = (0, $cbtbS.extractSmartLinkUrl)(response);
        const hostName = url ? new URL(url).hostname : undefined;
        return hostName;
    } catch  {
        return undefined;
    }
};

});

parcelRegister("dQzXs", function(module, exports) {
$parcel$export(module.exports, "default", () => $8ecbb451f088a65b$export$2e2bcd8739ae039);

var $9b5Ea = parcelRequire("9b5Ea");

var $cbtbS = parcelRequire("cbtbS");

var $j9rqA = parcelRequire("j9rqA");
const $8ecbb451f088a65b$var$extractLinkTitle = (status, propUrl, response, onClick, onAuxClick, onContextMenu)=>{
    const responseUrl = (0, $cbtbS.extractSmartLinkUrl)(response);
    const url = status === (0, $j9rqA.SmartLinkStatus).Resolved ? responseUrl ?? propUrl : propUrl;
    const name = (0, $9b5Ea.extractSmartLinkTitle)(response);
    const text = status === (0, $j9rqA.SmartLinkStatus).Resolved ? name ?? responseUrl ?? propUrl : propUrl;
    return {
        onClick: onClick,
        onAuxClick: onAuxClick,
        onContextMenu: onContextMenu,
        text: text,
        url: url
    };
};
var $8ecbb451f088a65b$export$2e2bcd8739ae039 = $8ecbb451f088a65b$var$extractLinkTitle;

});

parcelRegister("bPeBW", function(module, exports) {
$parcel$export(module.exports, "extractLocation", () => $5b214ddcac26f534$export$9df94c77b0746c3c);

var $T8dR3 = parcelRequire("T8dR3");
const $5b214ddcac26f534$export$9df94c77b0746c3c = (data)=>{
    const { url: url, name: name } = (0, $T8dR3.extractValue)(data, 'location') || {};
    if (url && name && typeof url === 'string') return {
        text: name,
        url: url
    };
};

});

parcelRegister("fZkbk", function(module, exports) {
$parcel$export(module.exports, "extractMetaObjectId", () => $c119f5ded4adb2bf$export$bec1443e3e33b166);
const $c119f5ded4adb2bf$export$bec1443e3e33b166 = (meta)=>meta.objectId;

});

parcelRegister("rugWY", function(module, exports) {
$parcel$export(module.exports, "extractMetaResourceType", () => $486f4818eea76975$export$11d1314ebbee594e);
const $486f4818eea76975$export$11d1314ebbee594e = (meta)=>meta.resourceType;

});

parcelRegister("krEI2", function(module, exports) {
$parcel$export(module.exports, "extractMetaTenantId", () => $2c3137b9599bda83$export$92037aea7f27bf7f);
const $2c3137b9599bda83$export$92037aea7f27bf7f = (meta)=>meta.tenantId;

});

parcelRegister("aDAi2", function(module, exports) {
$parcel$export(module.exports, "extractPersonAssignedToAsArray", () => $734a00536db01fe2$export$edb8a7a44b91274e);

var $7yJN7 = parcelRequire("7yJN7");
const $734a00536db01fe2$export$edb8a7a44b91274e = (data)=>{
    const person = (0, $7yJN7.extractPersonAssignedTo)(data);
    return person ? [
        person
    ] : undefined;
};

});

parcelRegister("6jPLy", function(module, exports) {
$parcel$export(module.exports, "default", () => $7a3dd48cad0cebce$export$2e2bcd8739ae039);

var $6Hxqo = parcelRequire("6Hxqo");

var $j9rqA = parcelRequire("j9rqA");
const $7a3dd48cad0cebce$var$priorityMapper = {
    blocker: (0, $j9rqA.IconType).PriorityBlocker,
    critical: (0, $j9rqA.IconType).PriorityCritical,
    high: (0, $j9rqA.IconType).PriorityHigh,
    highest: (0, $j9rqA.IconType).PriorityHighest,
    low: (0, $j9rqA.IconType).PriorityLow,
    lowest: (0, $j9rqA.IconType).PriorityLowest,
    major: (0, $j9rqA.IconType).PriorityMajor,
    medium: (0, $j9rqA.IconType).PriorityMedium,
    minor: (0, $j9rqA.IconType).PriorityMinor,
    trivial: (0, $j9rqA.IconType).PriorityTrivial,
    undefined: (0, $j9rqA.IconType).PriorityUndefined
};
const $7a3dd48cad0cebce$var$extractPriority = (data)=>{
    const priority = data['atlassian:priority'];
    if (priority) {
        if (typeof priority === 'string') {
            const icon = $7a3dd48cad0cebce$var$priorityMapper[priority.toLowerCase()];
            if (icon) return {
                icon: icon,
                label: priority
            };
        } else if (priority['@type'] === 'Object') return {
            label: priority.name,
            url: priority.icon && (0, $6Hxqo.extractUrlFromIconJsonLd)(priority.icon)
        };
    }
};
var $7a3dd48cad0cebce$export$2e2bcd8739ae039 = $7a3dd48cad0cebce$var$extractPriority;

});

parcelRegister("k9JH8", function(module, exports) {
$parcel$export(module.exports, "extractProgrammingLanguage", () => $5ae6eddd2fb7fe7e$export$43e54589935a1ff);

var $T8dR3 = parcelRequire("T8dR3");
const $5ae6eddd2fb7fe7e$export$43e54589935a1ff = (data)=>(0, $T8dR3.extractValue)(data, 'schema:programmingLanguage');

});

parcelRegister("4stHy", function(module, exports) {
$parcel$export(module.exports, "default", () => $4b0af8a94e825541$export$2e2bcd8739ae039);

var $kzNPc = parcelRequire("kzNPc");

var $j9rqA = parcelRequire("j9rqA");

var $5zI23 = parcelRequire("5zI23");
const $4b0af8a94e825541$var$extractProvider = (response)=>{
    const provider = (0, $kzNPc.extractSmartLinkProvider)(response);
    if (!provider) return;
    const providerName = provider.text;
    if (provider.id === (0, $5zI23.CONFLUENCE_GENERATOR_ID)) return {
        icon: (0, $j9rqA.IconType).Confluence,
        label: providerName || 'Confluence'
    };
    if (provider.id === (0, $5zI23.JIRA_GENERATOR_ID)) return {
        icon: (0, $j9rqA.IconType).Jira,
        label: providerName || 'Jira'
    };
    if (providerName) return {
        label: providerName,
        url: typeof provider.icon === 'string' ? provider.icon : undefined
    };
};
var $4b0af8a94e825541$export$2e2bcd8739ae039 = $4b0af8a94e825541$var$extractProvider;

});

parcelRegister("2M0BH", function(module, exports) {
$parcel$export(module.exports, "extractReadTime", () => $c1681f04d33d3a81$export$cc4028b2878d0675);

var $T8dR3 = parcelRequire("T8dR3");
const $c1681f04d33d3a81$export$cc4028b2878d0675 = (data)=>{
    return (0, $T8dR3.extractValue)(data, 'atlassian:readTimeInMinutes');
};

});

parcelRegister("1Ev4I", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkCommentCount", () => $3211edbb47ccaae9$export$fb0960a89fb9c17b);

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");

var $iNjlD = parcelRequire("iNjlD");
const $3211edbb47ccaae9$export$fb0960a89fb9c17b = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        const entity = (0, $YqY0I.extractEntity)(response);
        return entity && 'commentCount' in entity && typeof entity.commentCount === 'number' ? entity === null || entity === void 0 ? void 0 : entity.commentCount : undefined;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $iNjlD.extractCommentCount)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("iNjlD", function(module, exports) {
$parcel$export(module.exports, "extractCommentCount", () => $0024471979f815cd$export$b68822b76d5d51d5);

var $T8dR3 = parcelRequire("T8dR3");
const $0024471979f815cd$export$b68822b76d5d51d5 = (data)=>(0, $T8dR3.extractValue)(data, 'schema:commentCount');

});


parcelRegister("usiaF", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkReactCount", () => $5a14bcdd2aa91ca0$export$bb52c21c67a309ca);

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");

var $9NeYm = parcelRequire("9NeYm");
const $5a14bcdd2aa91ca0$export$bb52c21c67a309ca = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        const entity = (0, $YqY0I.extractEntity)(response);
        const reactions = entity && 'reactions' in entity && Array.isArray(entity.reactions) ? entity.reactions : undefined;
        return reactions === null || reactions === void 0 ? void 0 : reactions.reduce((total, reaction)=>total + (reaction === null || reaction === void 0 ? void 0 : reaction.total), 0);
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $9NeYm.extractReactCount)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("9NeYm", function(module, exports) {
$parcel$export(module.exports, "extractReactCount", () => $c9018e65f8f72a99$export$44130aa92252501);

var $T8dR3 = parcelRequire("T8dR3");
const $c9018e65f8f72a99$export$44130aa92252501 = (data)=>(0, $T8dR3.extractValue)(data, 'atlassian:reactCount');

});


parcelRegister("biykc", function(module, exports) {
$parcel$export(module.exports, "extractSmartLinkSentOn", () => $c3a2e4aee3dc9f9b$export$5c05c5b7ca37e36e);

var $YqY0I = parcelRequire("YqY0I");

var $6G8gX = parcelRequire("6G8gX");

var $hdrcN = parcelRequire("hdrcN");
const $c3a2e4aee3dc9f9b$export$5c05c5b7ca37e36e = (response)=>{
    if (!response || !response.data) return undefined;
    if ((0, $6G8gX.isEntityPresent)(response)) {
        var _extractEntity;
        return (_extractEntity = (0, $YqY0I.extractEntity)(response)) === null || _extractEntity === void 0 ? void 0 : _extractEntity.createdAt;
    }
    return (response === null || response === void 0 ? void 0 : response.data) && (0, $hdrcN.extractSentOn)(response === null || response === void 0 ? void 0 : response.data);
};

});
parcelRegister("hdrcN", function(module, exports) {
$parcel$export(module.exports, "extractSentOn", () => $eaef54d5f55bd156$export$b592ddecae70b61d);

var $T8dR3 = parcelRequire("T8dR3");
const $eaef54d5f55bd156$export$b592ddecae70b61d = (data)=>{
    return (0, $T8dR3.extractValue)(data, 'dateSent');
};

});


parcelRegister("4h7Pt", function(module, exports) {
$parcel$export(module.exports, "extractSourceBranch", () => $a9f4c5e8136eef54$export$949ac6a8325b3fdb);

var $5EiYR = parcelRequire("5EiYR");
const $a9f4c5e8136eef54$export$949ac6a8325b3fdb = (data)=>(0, $5EiYR.extractLinkName)(data['atlassian:mergeSource']);

});
parcelRegister("5EiYR", function(module, exports) {
$parcel$export(module.exports, "extractLinkName", () => $da4e3c4b89f3df52$export$ec5923ec479b7275);
const $da4e3c4b89f3df52$export$ec5923ec479b7275 = (link)=>{
    if (link && typeof link === 'object' && link['@type'] === 'Link') return link.name;
};

});


parcelRegister("70s5w", function(module, exports) {
$parcel$export(module.exports, "default", () => $fb600e2d696c6dad$export$2e2bcd8739ae039);

var $2r9K5 = parcelRequire("2r9K5");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $96gGh = parcelRequire("96gGh");

var $g9TRl = parcelRequire("g9TRl");

var $5knQT = parcelRequire("5knQT");

var $i8C20 = parcelRequire("i8C20");

var $90lSx = parcelRequire("90lSx");
const $fb600e2d696c6dad$var$toInvokeRequest = (extensionKey, resourceIdentifiers, actionType, details)=>{
    if (!actionType) return;
    return {
        action: {
            actionType: actionType,
            resourceIdentifiers: resourceIdentifiers
        },
        providerKey: extensionKey,
        details: details
    };
};
const $fb600e2d696c6dad$var$extractAction = (response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    var _action$dataRetrieval, _extractInvokePreview, _action$dataUpdateAct;
    const extensionKey = (0, $96gGh.getExtensionKey)(response);
    const data = response === null || response === void 0 ? void 0 : response.data;
    const actions = (0, $90lSx.default)(data);
    if (!extensionKey || actions.length === 0) return;
    const action = actions.find((item)=>(item === null || item === void 0 ? void 0 : item.name) === 'UpdateAction' && (item === null || item === void 0 ? void 0 : item.refField) === 'tag');
    if (!action || !action.resourceIdentifiers) return;
    const read = $fb600e2d696c6dad$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataRetrieval = action.dataRetrievalAction) === null || _action$dataRetrieval === void 0 ? void 0 : _action$dataRetrieval.name);
    const url = (0, $2r9K5.extractLink)(data);
    const invokePreviewAction = response ? (_extractInvokePreview = (0, $5knQT.extractInvokePreviewAction)({
        actionOptions: actionOptions,
        appearance: appearance,
        fireEvent: fireEvent,
        id: id,
        onClose: resolve ? ()=>url && resolve({
                url: url,
                isReloading: true
            }) : undefined,
        origin: origin,
        response: response,
        isPreviewPanelAvailable: isPreviewPanelAvailable,
        ...(0, $dRkX9.fg)('preview_panel_unit_check') ? {
            isPreviewRestricted: isPreviewRestricted
        } : undefined,
        openPreviewPanel: openPreviewPanel,
        transformUrl: transformUrl
    })) === null || _extractInvokePreview === void 0 ? void 0 : _extractInvokePreview.invokeAction : undefined;
    const details = {
        id: id,
        url: url,
        invokePreviewAction: invokePreviewAction
    };
    const update = $fb600e2d696c6dad$var$toInvokeRequest(extensionKey, action.resourceIdentifiers, (_action$dataUpdateAct = action.dataUpdateAction) === null || _action$dataUpdateAct === void 0 ? void 0 : _action$dataUpdateAct.name, details);
    return read || update ? {
        read: read,
        update: update
    } : undefined;
};
const $fb600e2d696c6dad$var$extractState = (response, actionOptions, id, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, isPreviewRestricted)=>{
    if (!response || !response.data) return;
    const lozenge = (0, $i8C20.extractLozenge)(response === null || response === void 0 ? void 0 : response.data);
    if (!lozenge) return;
    if (!(0, $g9TRl.canShowAction)((0, $j9rqA.CardAction).ChangeStatusAction, actionOptions)) return lozenge;
    const action = $fb600e2d696c6dad$var$extractAction(response, id, actionOptions, appearance, origin, fireEvent, resolve, isPreviewPanelAvailable, openPreviewPanel, transformUrl, (0, $dRkX9.fg)('preview_panel_unit_check') ? isPreviewRestricted : undefined);
    return {
        ...lozenge,
        action: action
    };
};
var $fb600e2d696c6dad$export$2e2bcd8739ae039 = $fb600e2d696c6dad$var$extractState;

});
parcelRegister("i8C20", function(module, exports) {
$parcel$export(module.exports, "extractLozenge", () => $12bdeff8938cf5cb$export$e5da155556a77bca);

var $lOxou = parcelRequire("lOxou");

var $apuw3 = parcelRequire("apuw3");

var $2Ocoz = parcelRequire("2Ocoz");

var $fYART = parcelRequire("fYART");

var $j40rd = parcelRequire("j40rd");
const $12bdeff8938cf5cb$export$e5da155556a77bca = (jsonLd)=>{
    const type = (0, $lOxou.extractType)(jsonLd);
    if (type) {
        if (type.includes('atlassian:Task')) {
            const jsonLdTask = jsonLd;
            const lozengeFromTag = (0, $2Ocoz.extractTag)(jsonLdTask);
            const lozengeFromStatus = (0, $fYART.extractTaskStatus)(jsonLdTask);
            const lozengeFromTaskType = $12bdeff8938cf5cb$var$extractLozengeFromTaskType(jsonLdTask);
            return lozengeFromTag || lozengeFromStatus || lozengeFromTaskType;
        }
        if (type.includes('atlassian:UndefinedLink')) return {
            text: 'UNDEFINED',
            appearance: 'inprogress'
        };
        // casting it because `extractState` can safely handle missing properties
        return (0, $apuw3.extractState)(jsonLd);
    }
};
const $12bdeff8938cf5cb$var$extractLozengeFromTaskType = (jsonLdTask)=>{
    const taskType = (0, $j40rd.extractTaskType)(jsonLdTask);
    if (taskType && taskType.name) return {
        text: taskType.name,
        appearance: 'success'
    };
};

});
parcelRegister("apuw3", function(module, exports) {
$parcel$export(module.exports, "extractState", () => $65719a052e9ee257$export$5e4074cbce6574c7);

var $jtz7N = parcelRequire("jtz7N");
// Maps accent color short names to their corresponding background and text colors
const $65719a052e9ee257$var$lozengeAccentStyles = {
    blue: {
        backgroundColor: "var(--ds-background-accent-blue-subtler, #CFE1FD)",
        color: "var(--ds-text-accent-blue, #1558BC)"
    },
    gray: {
        backgroundColor: "var(--ds-background-accent-gray-subtler, #DDDEE1)",
        color: "var(--ds-text-accent-gray, #505258)"
    },
    green: {
        backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        color: "var(--ds-text-accent-green, #216E4E)"
    },
    lime: {
        backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
        color: "var(--ds-text-accent-lime, #4C6B1F)"
    },
    magenta: {
        backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
        color: "var(--ds-text-accent-magenta, #943D73)"
    },
    orange: {
        backgroundColor: "var(--ds-background-accent-orange-subtler, #FCE4A6)",
        color: "var(--ds-text-accent-orange, #9E4C00)"
    },
    purple: {
        backgroundColor: "var(--ds-background-accent-purple-subtler, #EED7FC)",
        color: "var(--ds-text-accent-purple, #803FA5)"
    },
    red: {
        backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        color: "var(--ds-text-accent-red, #AE2E24)"
    },
    teal: {
        backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        color: "var(--ds-text-accent-teal, #206A83)"
    },
    yellow: {
        backgroundColor: "var(--ds-background-accent-yellow-subtler, #F5E989)",
        color: "var(--ds-text-accent-yellow, #7F5F01)"
    }
};
const $65719a052e9ee257$var$capitalize = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $65719a052e9ee257$export$5e4074cbce6574c7 = (jsonLd)=>{
    const state = jsonLd['atlassian:state'];
    if (state) {
        if (typeof state === 'string') {
            const linkState = state.toLowerCase();
            if (!(0, $jtz7N.OMIT_STATES).includes(linkState)) return {
                text: $65719a052e9ee257$var$capitalize(linkState),
                appearance: (0, $jtz7N.VALID_STATES)[linkState] || 'default'
            };
        } else if (state['@type'] === 'Link' || state['@type'] === 'Object') {
            if (state.name) {
                const accent = state.accent;
                return {
                    text: state.name,
                    appearance: state.appearance || 'default',
                    style: accent ? $65719a052e9ee257$var$lozengeAccentStyles[accent] : undefined
                };
            }
        }
    }
};

});
parcelRegister("jtz7N", function(module, exports) {
$parcel$export(module.exports, "isValidAppearance", () => $c9a7b11f47985a77$export$ce6b5b303f8e3c99);
$parcel$export(module.exports, "VALID_STATES", () => $c9a7b11f47985a77$export$7b1deaaad25d1dc1);
$parcel$export(module.exports, "OMIT_STATES", () => $c9a7b11f47985a77$export$772610da74ddbc07);
const $c9a7b11f47985a77$var$VALID_APPEARANCES = [
    'default',
    'success',
    'removed',
    'inprogress',
    'new',
    'moved'
];
const $c9a7b11f47985a77$export$ce6b5b303f8e3c99 = (appearance)=>{
    return $c9a7b11f47985a77$var$VALID_APPEARANCES.indexOf(appearance) !== -1;
};
const $c9a7b11f47985a77$export$7b1deaaad25d1dc1 = {
    open: 'inprogress',
    merged: 'success',
    declined: 'removed',
    closed: 'success',
    draft: 'inprogress',
    archived: 'default',
    'queued to merge': 'moved'
};
const $c9a7b11f47985a77$export$772610da74ddbc07 = [
    'current'
];

});


parcelRegister("2Ocoz", function(module, exports) {
$parcel$export(module.exports, "extractTag", () => $fb4a314ff8189e25$export$962a8da34cf78a4f);

var $jtz7N = parcelRequire("jtz7N");
const $fb4a314ff8189e25$export$962a8da34cf78a4f = (jsonLd)=>{
    const tag = jsonLd.tag;
    if (tag) {
        if (typeof tag === 'string') return {
            text: tag,
            appearance: 'default'
        };
        else if (Array.isArray(tag)) {
            const tags = tag.map($fb4a314ff8189e25$var$extractTagItem).filter((item)=>!!item);
            if (tags.length > 0) return tags.shift();
        } else return $fb4a314ff8189e25$var$extractTagItem(tag);
    }
};
const $fb4a314ff8189e25$var$extractTagItem = (tag)=>{
    if (typeof tag === 'string') return {
        text: tag,
        appearance: 'default'
    };
    else if (tag['@type'] === 'Link') {
        if (tag.name) return {
            text: tag.name,
            appearance: 'default'
        };
    } else if (tag.name) {
        const appearance = tag.appearance;
        return {
            text: tag.name,
            // Jira currently uses tag.appearance to set the lozenge color. Remove this
            // once we migrate them away from using this old spec.
            appearance: (0, $jtz7N.isValidAppearance)(appearance) && appearance || 'default'
        };
    }
};

});

parcelRegister("fYART", function(module, exports) {
$parcel$export(module.exports, "extractTaskStatus", () => $2e4d3e6811b88a6f$export$7698df1946deda72);
const $2e4d3e6811b88a6f$export$7698df1946deda72 = (jsonLd)=>{
    const taskStatus = jsonLd['atlassian:taskStatus'];
    if (taskStatus && taskStatus.name) return {
        text: taskStatus.name,
        appearance: 'success'
    };
};

});



parcelRegister("fM0PU", function(module, exports) {
$parcel$export(module.exports, "extractStoryPoints", () => $5dc25f92c8275af3$export$bdcea84d1550eb9d);

var $T8dR3 = parcelRequire("T8dR3");
const $5dc25f92c8275af3$export$bdcea84d1550eb9d = (data)=>{
    return (0, $T8dR3.extractValue)(data, 'atlassian:storyPoints');
};

});

parcelRegister("7zETV", function(module, exports) {
$parcel$export(module.exports, "extractSubTasksProgress", () => $9f72210a00e2375c$export$744e3a2674114c1d);

var $T8dR3 = parcelRequire("T8dR3");
const $9f72210a00e2375c$export$744e3a2674114c1d = (data)=>{
    const subTasksObject = (0, $T8dR3.extractValue)(data, 'atlassian:subTasks');
    return subTasksObject && subTasksObject.totalCount ? `${subTasksObject.resolvedCount}/${subTasksObject.totalCount}` : undefined;
};

});

parcelRegister("dYCtJ", function(module, exports) {
$parcel$export(module.exports, "extractSubscriberCount", () => $b3e046521cc03143$export$8bd03a7beb5badf1);

var $T8dR3 = parcelRequire("T8dR3");
const $b3e046521cc03143$export$8bd03a7beb5badf1 = (data)=>(0, $T8dR3.extractValue)(data, 'atlassian:subscriberCount');

});

parcelRegister("lmySn", function(module, exports) {
$parcel$export(module.exports, "extractTargetBranch", () => $f921b6c73ecd9140$export$29b0ac5d2f9890cf);

var $5EiYR = parcelRequire("5EiYR");
const $f921b6c73ecd9140$export$29b0ac5d2f9890cf = (data)=>(0, $5EiYR.extractLinkName)(data['atlassian:mergeDestination']);

});

parcelRegister("7xqxz", function(module, exports) {
$parcel$export(module.exports, "extractTeamMemberCount", () => $0ac6dcad22b0bccd$export$9fc8706c6cb5343a);
const $0ac6dcad22b0bccd$export$9fc8706c6cb5343a = (data)=>{
    const val = data !== null && data !== void 0 && data.attributedTo ? Array.isArray(data === null || data === void 0 ? void 0 : data.attributedTo) ? data === null || data === void 0 ? void 0 : data.attributedTo.length : 0 : 0;
    return val;
};

});

parcelRegister("1UoIz", function(module, exports) {
$parcel$export(module.exports, "extractUserAttributes", () => $4847d5bedc9903f1$export$6052f26bb463e370);
const $4847d5bedc9903f1$export$6052f26bb463e370 = (data)=>{
    return data === null || data === void 0 ? void 0 : data.userAttributes;
};

});

parcelRegister("4bnJG", function(module, exports) {
$parcel$export(module.exports, "extractViewCount", () => $4282b7409de26a85$export$e57334ce4738e29d);

var $T8dR3 = parcelRequire("T8dR3");
const $4282b7409de26a85$export$e57334ce4738e29d = (data)=>(0, $T8dR3.extractValue)(data, 'atlassian:viewCount');

});

parcelRegister("85uGW", function(module, exports) {
$parcel$export(module.exports, "extractVoteCount", () => $5b7a738ce7637c7d$export$c8bef3d5e550a3a);

var $T8dR3 = parcelRequire("T8dR3");
const $5b7a738ce7637c7d$export$c8bef3d5e550a3a = (data)=>(0, $T8dR3.extractValue)(data, 'atlassian:voteCount');

});

parcelRegister("bSjVt", function(module, exports) {
$parcel$export(module.exports, "extractLatestCommit", () => $4d99c2d2633e7b40$export$f222392162cff0d8);
const $4d99c2d2633e7b40$export$f222392162cff0d8 = (jsonLd)=>{
    const latestCommit = jsonLd['atlassian:latestCommit'];
    if (typeof latestCommit === 'string') return latestCommit;
    if (latestCommit) //todo: change the properties to latestCommit.hash when BE is ready
    return latestCommit ? latestCommit.name : undefined;
};

});


parcelRegister("SoLKX", function(module, exports) {
$parcel$export(module.exports, "extractErrorIcon", () => $1f6fba5b0db86482$export$bdd29be9b0395931);

var $j9rqA = parcelRequire("j9rqA");

var $6dr4w = parcelRequire("6dr4w");
const $1f6fba5b0db86482$export$bdd29be9b0395931 = (response, status)=>{
    // Try to get provider icon first.
    if (response) {
        const data = response.data;
        const { icon: icon, url: url } = (0, $6dr4w.default)(data) || {};
        if (icon || url) return {
            icon: icon,
            url: url
        };
    }
    // Otherwise, use fallback icon for each status.
    switch(status){
        case (0, $j9rqA.SmartLinkStatus).Forbidden:
        case (0, $j9rqA.SmartLinkStatus).Unauthorized:
            return {
                icon: (0, $j9rqA.IconType).Forbidden
            };
        case (0, $j9rqA.SmartLinkStatus).NotFound:
            return {
                icon: (0, $j9rqA.IconType).Error
            };
        case (0, $j9rqA.SmartLinkStatus).Errored:
        case (0, $j9rqA.SmartLinkStatus).Fallback:
        default:
            return {
                icon: (0, $j9rqA.IconType).Default
            };
    }
};

});

parcelRegister("fDTjp", function(module, exports) {
$parcel$export(module.exports, "getRetryOptions", () => $7c4341c3b0088d18$export$f3d3482baaff4bf6);

var $kzNPc = parcelRequire("kzNPc");

var $dRkX9 = parcelRequire("dRkX9");

var $j9rqA = parcelRequire("j9rqA");

var $hiN0m = parcelRequire("hiN0m");

var $ewFKq = parcelRequire("ewFKq");

var $dnVHi = parcelRequire("dnVHi");

var $7tDET = parcelRequire("7tDET");
const $7c4341c3b0088d18$var$getForbiddenMessageKey = (meta)=>{
    var _meta$requestAccess;
    const accessType = meta === null || meta === void 0 || (_meta$requestAccess = meta.requestAccess) === null || _meta$requestAccess === void 0 ? void 0 : _meta$requestAccess.accessType;
    switch(accessType){
        case 'DIRECT_ACCESS':
            return (0, $dRkX9.fg)('confluence-issue-terminology-refresh') ? 'join_to_viewIssueTermRefresh' : 'join_to_view';
        case 'REQUEST_ACCESS':
            return (0, $dRkX9.fg)('confluence-issue-terminology-refresh') ? 'request_access_to_viewIssueTermRefresh' : 'request_access_to_view';
        case 'PENDING_REQUEST_EXISTS':
            return 'pending_request';
        case 'FORBIDDEN':
            return 'forbidden_access';
        case 'DENIED_REQUEST_EXISTS':
            return 'request_denied';
        default:
            return 'restricted_link';
    }
};
const $7c4341c3b0088d18$export$f3d3482baaff4bf6 = (url, status, response, onAuthorize)=>{
    var _access$action;
    const provider = (0, $kzNPc.extractSmartLinkProvider)(response);
    const context = provider === null || provider === void 0 ? void 0 : provider.text;
    const values = context ? {
        context: context
    } : undefined;
    switch(status){
        case (0, $j9rqA.SmartLinkStatus).Forbidden:
            const meta = (response === null || response === void 0 ? void 0 : response.meta) ?? (0, $dnVHi.getForbiddenJsonLd)().meta;
            const access = (0, $hiN0m.extractRequestAccessContextImproved)({
                jsonLd: meta,
                url: url,
                product: context ?? ''
            });
            const messageKey = $7c4341c3b0088d18$var$getForbiddenMessageKey(meta);
            const descriptor = (0, $ewFKq.messages)[messageKey];
            const retry = onAuthorize || (access === null || access === void 0 || (_access$action = access.action) === null || _access$action === void 0 ? void 0 : _access$action.promise);
            const onClick = retry && !((access === null || access === void 0 ? void 0 : access.buttonDisabled) ?? false) ? (0, $7tDET.handleOnClick)(retry) : undefined;
            return {
                descriptor: descriptor,
                onClick: onClick,
                values: values
            };
        case (0, $j9rqA.SmartLinkStatus).Unauthorized:
            return onAuthorize ? {
                descriptor: (0, $ewFKq.messages).connect_link_account_card_name,
                onClick: (0, $7tDET.handleOnClick)(onAuthorize),
                values: values
            } : undefined;
        case (0, $j9rqA.SmartLinkStatus).NotFound:
            return {
                descriptor: (0, $ewFKq.messages).cannot_find_link
            };
    }
};

});
parcelRegister("dnVHi", function(module, exports) {
$parcel$export(module.exports, "getForbiddenJsonLd", () => $7d97eaa40cd0b26d$export$e32193033a594efb);

var $8aoX8 = parcelRequire("8aoX8");
const $7d97eaa40cd0b26d$export$e32193033a594efb = ()=>({
        meta: {
            visibility: 'restricted',
            access: 'forbidden',
            auth: [],
            definitionId: 'provider-not-found'
        },
        data: {
            ...(0, $8aoX8.emptyData)
        }
    });

});





//# sourceMappingURL=shared.fb0b7298.js.map
